export const addressData = [
  {
    id: '110000',
    label: '北京市',
    value: '110000',
    children: [
      {
        id: '110100',
        label: '北京市',
        value: '110100',
        parentId: '110000',
        children: [
          {
            id: '110101',
            label: '东城区',
            value: '110101',
            parentId: '110100'
          },
          {
            id: '110102',
            label: '西城区',
            value: '110102',
            parentId: '110100'
          },
          {
            id: '110105',
            label: '朝阳区',
            value: '110105',
            parentId: '110100'
          },
          {
            id: '110106',
            label: '丰台区',
            value: '110106',
            parentId: '110100'
          },
          {
            id: '110107',
            label: '石景山区',
            value: '110107',
            parentId: '110100'
          },
          {
            id: '110108',
            label: '海淀区',
            value: '110108',
            parentId: '110100'
          },
          {
            id: '110109',
            label: '门头沟区',
            value: '110109',
            parentId: '110100'
          },
          {
            id: '110111',
            label: '房山区',
            value: '110111',
            parentId: '110100'
          },
          {
            id: '110112',
            label: '通州区',
            value: '110112',
            parentId: '110100'
          },
          {
            id: '110113',
            label: '顺义区',
            value: '110113',
            parentId: '110100'
          },
          {
            id: '110114',
            label: '昌平区',
            value: '110114',
            parentId: '110100'
          },
          {
            id: '110115',
            label: '大兴区',
            value: '110115',
            parentId: '110100'
          },
          {
            id: '110116',
            label: '怀柔区',
            value: '110116',
            parentId: '110100'
          },
          {
            id: '110117',
            label: '平谷区',
            value: '110117',
            parentId: '110100'
          },
          {
            id: '110118',
            label: '密云区',
            value: '110118',
            parentId: '110100'
          },
          {
            id: '110119',
            label: '延庆区',
            value: '110119',
            parentId: '110100'
          }
        ]
      }
    ]
  },
  {
    id: '120000',
    label: '天津市',
    value: '120000',
    children: [
      {
        id: '120100',
        label: '天津市',
        value: '120100',
        parentId: '120000',
        children: [
          {
            id: '120101',
            label: '和平区',
            value: '120101',
            parentId: '120100'
          },
          {
            id: '120102',
            label: '河东区',
            value: '120102',
            parentId: '120100'
          },
          {
            id: '120103',
            label: '河西区',
            value: '120103',
            parentId: '120100'
          },
          {
            id: '120104',
            label: '南开区',
            value: '120104',
            parentId: '120100'
          },
          {
            id: '120105',
            label: '河北区',
            value: '120105',
            parentId: '120100'
          },
          {
            id: '120106',
            label: '红桥区',
            value: '120106',
            parentId: '120100'
          },
          {
            id: '120110',
            label: '东丽区',
            value: '120110',
            parentId: '120100'
          },
          {
            id: '120111',
            label: '西青区',
            value: '120111',
            parentId: '120100'
          },
          {
            id: '120112',
            label: '津南区',
            value: '120112',
            parentId: '120100'
          },
          {
            id: '120113',
            label: '北辰区',
            value: '120113',
            parentId: '120100'
          },
          {
            id: '120114',
            label: '武清区',
            value: '120114',
            parentId: '120100'
          },
          {
            id: '120115',
            label: '宝坻区',
            value: '120115',
            parentId: '120100'
          },
          {
            id: '120116',
            label: '滨海新区',
            value: '120116',
            parentId: '120100'
          },
          {
            id: '120117',
            label: '宁河区',
            value: '120117',
            parentId: '120100'
          },
          {
            id: '120118',
            label: '静海区',
            value: '120118',
            parentId: '120100'
          },
          {
            id: '120119',
            label: '蓟州区',
            value: '120119',
            parentId: '120100'
          }
        ]
      }
    ]
  },
  {
    id: '130000',
    label: '河北省',
    value: '130000',
    children: [
      {
        id: '130100',
        label: '石家庄市',
        value: '130100',
        parentId: '130000',
        children: [
          {
            id: '130102',
            label: '长安区',
            value: '130102',
            parentId: '130100'
          },
          {
            id: '130104',
            label: '桥西区',
            value: '130104',
            parentId: '130100'
          },
          {
            id: '130105',
            label: '新华区',
            value: '130105',
            parentId: '130100'
          },
          {
            id: '130107',
            label: '井陉矿区',
            value: '130107',
            parentId: '130100'
          },
          {
            id: '130108',
            label: '裕华区',
            value: '130108',
            parentId: '130100'
          },
          {
            id: '130109',
            label: '藁城区',
            value: '130109',
            parentId: '130100'
          },
          {
            id: '130110',
            label: '鹿泉区',
            value: '130110',
            parentId: '130100'
          },
          {
            id: '130111',
            label: '栾城区',
            value: '130111',
            parentId: '130100'
          },
          {
            id: '130121',
            label: '井陉县',
            value: '130121',
            parentId: '130100'
          },
          {
            id: '130123',
            label: '正定县',
            value: '130123',
            parentId: '130100'
          },
          {
            id: '130125',
            label: '行唐县',
            value: '130125',
            parentId: '130100'
          },
          {
            id: '130126',
            label: '灵寿县',
            value: '130126',
            parentId: '130100'
          },
          {
            id: '130127',
            label: '高邑县',
            value: '130127',
            parentId: '130100'
          },
          {
            id: '130128',
            label: '深泽县',
            value: '130128',
            parentId: '130100'
          },
          {
            id: '130129',
            label: '赞皇县',
            value: '130129',
            parentId: '130100'
          },
          {
            id: '130130',
            label: '无极县',
            value: '130130',
            parentId: '130100'
          },
          {
            id: '130131',
            label: '平山县',
            value: '130131',
            parentId: '130100'
          },
          {
            id: '130132',
            label: '元氏县',
            value: '130132',
            parentId: '130100'
          },
          {
            id: '130133',
            label: '赵县',
            value: '130133',
            parentId: '130100'
          },
          {
            id: '130181',
            label: '辛集市',
            value: '130181',
            parentId: '130100'
          },
          {
            id: '130183',
            label: '晋州市',
            value: '130183',
            parentId: '130100'
          },
          {
            id: '130184',
            label: '新乐市',
            value: '130184',
            parentId: '130100'
          }
        ]
      },
      {
        id: '130200',
        label: '唐山市',
        value: '130200',
        parentId: '130000',
        children: [
          {
            id: '130202',
            label: '路南区',
            value: '130202',
            parentId: '130200'
          },
          {
            id: '130203',
            label: '路北区',
            value: '130203',
            parentId: '130200'
          },
          {
            id: '130204',
            label: '古冶区',
            value: '130204',
            parentId: '130200'
          },
          {
            id: '130205',
            label: '开平区',
            value: '130205',
            parentId: '130200'
          },
          {
            id: '130207',
            label: '丰南区',
            value: '130207',
            parentId: '130200'
          },
          {
            id: '130208',
            label: '丰润区',
            value: '130208',
            parentId: '130200'
          },
          {
            id: '130209',
            label: '曹妃甸区',
            value: '130209',
            parentId: '130200'
          },
          {
            id: '130224',
            label: '滦南县',
            value: '130224',
            parentId: '130200'
          },
          {
            id: '130225',
            label: '乐亭县',
            value: '130225',
            parentId: '130200'
          },
          {
            id: '130227',
            label: '迁西县',
            value: '130227',
            parentId: '130200'
          },
          {
            id: '130229',
            label: '玉田县',
            value: '130229',
            parentId: '130200'
          },
          {
            id: '130281',
            label: '遵化市',
            value: '130281',
            parentId: '130200'
          },
          {
            id: '130283',
            label: '迁安市',
            value: '130283',
            parentId: '130200'
          },
          {
            id: '130284',
            label: '滦州市',
            value: '130284',
            parentId: '130200'
          }
        ]
      },
      {
        id: '130300',
        label: '秦皇岛市',
        value: '130300',
        parentId: '130000',
        children: [
          {
            id: '130302',
            label: '海港区',
            value: '130302',
            parentId: '130300'
          },
          {
            id: '130303',
            label: '山海关区',
            value: '130303',
            parentId: '130300'
          },
          {
            id: '130304',
            label: '北戴河区',
            value: '130304',
            parentId: '130300'
          },
          {
            id: '130306',
            label: '抚宁区',
            value: '130306',
            parentId: '130300'
          },
          {
            id: '130321',
            label: '青龙满族自治县',
            value: '130321',
            parentId: '130300'
          },
          {
            id: '130322',
            label: '昌黎县',
            value: '130322',
            parentId: '130300'
          },
          {
            id: '130324',
            label: '卢龙县',
            value: '130324',
            parentId: '130300'
          }
        ]
      },
      {
        id: '130400',
        label: '邯郸市',
        value: '130400',
        parentId: '130000',
        children: [
          {
            id: '130402',
            label: '邯山区',
            value: '130402',
            parentId: '130400'
          },
          {
            id: '130403',
            label: '丛台区',
            value: '130403',
            parentId: '130400'
          },
          {
            id: '130404',
            label: '复兴区',
            value: '130404',
            parentId: '130400'
          },
          {
            id: '130406',
            label: '峰峰矿区',
            value: '130406',
            parentId: '130400'
          },
          {
            id: '130407',
            label: '肥乡区',
            value: '130407',
            parentId: '130400'
          },
          {
            id: '130408',
            label: '永年区',
            value: '130408',
            parentId: '130400'
          },
          {
            id: '130423',
            label: '临漳县',
            value: '130423',
            parentId: '130400'
          },
          {
            id: '130424',
            label: '成安县',
            value: '130424',
            parentId: '130400'
          },
          {
            id: '130425',
            label: '大名县',
            value: '130425',
            parentId: '130400'
          },
          {
            id: '130426',
            label: '涉县',
            value: '130426',
            parentId: '130400'
          },
          {
            id: '130427',
            label: '磁县',
            value: '130427',
            parentId: '130400'
          },
          {
            id: '130430',
            label: '邱县',
            value: '130430',
            parentId: '130400'
          },
          {
            id: '130431',
            label: '鸡泽县',
            value: '130431',
            parentId: '130400'
          },
          {
            id: '130432',
            label: '广平县',
            value: '130432',
            parentId: '130400'
          },
          {
            id: '130433',
            label: '馆陶县',
            value: '130433',
            parentId: '130400'
          },
          {
            id: '130434',
            label: '魏县',
            value: '130434',
            parentId: '130400'
          },
          {
            id: '130435',
            label: '曲周县',
            value: '130435',
            parentId: '130400'
          },
          {
            id: '130481',
            label: '武安市',
            value: '130481',
            parentId: '130400'
          }
        ]
      },
      {
        id: '130500',
        label: '邢台市',
        value: '130500',
        parentId: '130000',
        children: [
          {
            id: '130502',
            label: '襄都区',
            value: '130502',
            parentId: '130500'
          },
          {
            id: '130503',
            label: '信都区',
            value: '130503',
            parentId: '130500'
          },
          {
            id: '130505',
            label: '任泽区',
            value: '130505',
            parentId: '130500'
          },
          {
            id: '130506',
            label: '南和区',
            value: '130506',
            parentId: '130500'
          },
          {
            id: '130522',
            label: '临城县',
            value: '130522',
            parentId: '130500'
          },
          {
            id: '130523',
            label: '内丘县',
            value: '130523',
            parentId: '130500'
          },
          {
            id: '130524',
            label: '柏乡县',
            value: '130524',
            parentId: '130500'
          },
          {
            id: '130525',
            label: '隆尧县',
            value: '130525',
            parentId: '130500'
          },
          {
            id: '130528',
            label: '宁晋县',
            value: '130528',
            parentId: '130500'
          },
          {
            id: '130529',
            label: '巨鹿县',
            value: '130529',
            parentId: '130500'
          },
          {
            id: '130530',
            label: '新河县',
            value: '130530',
            parentId: '130500'
          },
          {
            id: '130531',
            label: '广宗县',
            value: '130531',
            parentId: '130500'
          },
          {
            id: '130532',
            label: '平乡县',
            value: '130532',
            parentId: '130500'
          },
          {
            id: '130533',
            label: '威县',
            value: '130533',
            parentId: '130500'
          },
          {
            id: '130534',
            label: '清河县',
            value: '130534',
            parentId: '130500'
          },
          {
            id: '130535',
            label: '临西县',
            value: '130535',
            parentId: '130500'
          },
          {
            id: '130581',
            label: '南宫市',
            value: '130581',
            parentId: '130500'
          },
          {
            id: '130582',
            label: '沙河市',
            value: '130582',
            parentId: '130500'
          }
        ]
      },
      {
        id: '130600',
        label: '保定市',
        value: '130600',
        parentId: '130000',
        children: [
          {
            id: '130602',
            label: '竞秀区',
            value: '130602',
            parentId: '130600'
          },
          {
            id: '130606',
            label: '莲池区',
            value: '130606',
            parentId: '130600'
          },
          {
            id: '130607',
            label: '满城区',
            value: '130607',
            parentId: '130600'
          },
          {
            id: '130608',
            label: '清苑区',
            value: '130608',
            parentId: '130600'
          },
          {
            id: '130609',
            label: '徐水区',
            value: '130609',
            parentId: '130600'
          },
          {
            id: '130623',
            label: '涞水县',
            value: '130623',
            parentId: '130600'
          },
          {
            id: '130624',
            label: '阜平县',
            value: '130624',
            parentId: '130600'
          },
          {
            id: '130626',
            label: '定兴县',
            value: '130626',
            parentId: '130600'
          },
          {
            id: '130627',
            label: '唐县',
            value: '130627',
            parentId: '130600'
          },
          {
            id: '130628',
            label: '高阳县',
            value: '130628',
            parentId: '130600'
          },
          {
            id: '130629',
            label: '容城县',
            value: '130629',
            parentId: '130600'
          },
          {
            id: '130630',
            label: '涞源县',
            value: '130630',
            parentId: '130600'
          },
          {
            id: '130631',
            label: '望都县',
            value: '130631',
            parentId: '130600'
          },
          {
            id: '130632',
            label: '安新县',
            value: '130632',
            parentId: '130600'
          },
          {
            id: '130633',
            label: '易县',
            value: '130633',
            parentId: '130600'
          },
          {
            id: '130634',
            label: '曲阳县',
            value: '130634',
            parentId: '130600'
          },
          {
            id: '130635',
            label: '蠡县',
            value: '130635',
            parentId: '130600'
          },
          {
            id: '130636',
            label: '顺平县',
            value: '130636',
            parentId: '130600'
          },
          {
            id: '130637',
            label: '博野县',
            value: '130637',
            parentId: '130600'
          },
          {
            id: '130638',
            label: '雄县',
            value: '130638',
            parentId: '130600'
          },
          {
            id: '130681',
            label: '涿州市',
            value: '130681',
            parentId: '130600'
          },
          {
            id: '130682',
            label: '定州市',
            value: '130682',
            parentId: '130600'
          },
          {
            id: '130683',
            label: '安国市',
            value: '130683',
            parentId: '130600'
          },
          {
            id: '130684',
            label: '高碑店市',
            value: '130684',
            parentId: '130600'
          }
        ]
      },
      {
        id: '130700',
        label: '张家口市',
        value: '130700',
        parentId: '130000',
        children: [
          {
            id: '130702',
            label: '桥东区',
            value: '130702',
            parentId: '130700'
          },
          {
            id: '130703',
            label: '桥西区',
            value: '130703',
            parentId: '130700'
          },
          {
            id: '130705',
            label: '宣化区',
            value: '130705',
            parentId: '130700'
          },
          {
            id: '130706',
            label: '下花园区',
            value: '130706',
            parentId: '130700'
          },
          {
            id: '130708',
            label: '万全区',
            value: '130708',
            parentId: '130700'
          },
          {
            id: '130709',
            label: '崇礼区',
            value: '130709',
            parentId: '130700'
          },
          {
            id: '130722',
            label: '张北县',
            value: '130722',
            parentId: '130700'
          },
          {
            id: '130723',
            label: '康保县',
            value: '130723',
            parentId: '130700'
          },
          {
            id: '130724',
            label: '沽源县',
            value: '130724',
            parentId: '130700'
          },
          {
            id: '130725',
            label: '尚义县',
            value: '130725',
            parentId: '130700'
          },
          {
            id: '130726',
            label: '蔚县',
            value: '130726',
            parentId: '130700'
          },
          {
            id: '130727',
            label: '阳原县',
            value: '130727',
            parentId: '130700'
          },
          {
            id: '130728',
            label: '怀安县',
            value: '130728',
            parentId: '130700'
          },
          {
            id: '130730',
            label: '怀来县',
            value: '130730',
            parentId: '130700'
          },
          {
            id: '130731',
            label: '涿鹿县',
            value: '130731',
            parentId: '130700'
          },
          {
            id: '130732',
            label: '赤城县',
            value: '130732',
            parentId: '130700'
          }
        ]
      },
      {
        id: '130800',
        label: '承德市',
        value: '130800',
        parentId: '130000',
        children: [
          {
            id: '130802',
            label: '双桥区',
            value: '130802',
            parentId: '130800'
          },
          {
            id: '130803',
            label: '双滦区',
            value: '130803',
            parentId: '130800'
          },
          {
            id: '130804',
            label: '鹰手营子矿区',
            value: '130804',
            parentId: '130800'
          },
          {
            id: '130821',
            label: '承德县',
            value: '130821',
            parentId: '130800'
          },
          {
            id: '130822',
            label: '兴隆县',
            value: '130822',
            parentId: '130800'
          },
          {
            id: '130824',
            label: '滦平县',
            value: '130824',
            parentId: '130800'
          },
          {
            id: '130825',
            label: '隆化县',
            value: '130825',
            parentId: '130800'
          },
          {
            id: '130826',
            label: '丰宁满族自治县',
            value: '130826',
            parentId: '130800'
          },
          {
            id: '130827',
            label: '宽城满族自治县',
            value: '130827',
            parentId: '130800'
          },
          {
            id: '130828',
            label: '围场满族蒙古族自治县',
            value: '130828',
            parentId: '130800'
          },
          {
            id: '130881',
            label: '平泉市',
            value: '130881',
            parentId: '130800'
          }
        ]
      },
      {
        id: '130900',
        label: '沧州市',
        value: '130900',
        parentId: '130000',
        children: [
          {
            id: '130902',
            label: '新华区',
            value: '130902',
            parentId: '130900'
          },
          {
            id: '130903',
            label: '运河区',
            value: '130903',
            parentId: '130900'
          },
          {
            id: '130921',
            label: '沧县',
            value: '130921',
            parentId: '130900'
          },
          {
            id: '130922',
            label: '青县',
            value: '130922',
            parentId: '130900'
          },
          {
            id: '130923',
            label: '东光县',
            value: '130923',
            parentId: '130900'
          },
          {
            id: '130924',
            label: '海兴县',
            value: '130924',
            parentId: '130900'
          },
          {
            id: '130925',
            label: '盐山县',
            value: '130925',
            parentId: '130900'
          },
          {
            id: '130926',
            label: '肃宁县',
            value: '130926',
            parentId: '130900'
          },
          {
            id: '130927',
            label: '南皮县',
            value: '130927',
            parentId: '130900'
          },
          {
            id: '130928',
            label: '吴桥县',
            value: '130928',
            parentId: '130900'
          },
          {
            id: '130929',
            label: '献县',
            value: '130929',
            parentId: '130900'
          },
          {
            id: '130930',
            label: '孟村回族自治县',
            value: '130930',
            parentId: '130900'
          },
          {
            id: '130981',
            label: '泊头市',
            value: '130981',
            parentId: '130900'
          },
          {
            id: '130982',
            label: '任丘市',
            value: '130982',
            parentId: '130900'
          },
          {
            id: '130983',
            label: '黄骅市',
            value: '130983',
            parentId: '130900'
          },
          {
            id: '130984',
            label: '河间市',
            value: '130984',
            parentId: '130900'
          }
        ]
      },
      {
        id: '131000',
        label: '廊坊市',
        value: '131000',
        parentId: '130000',
        children: [
          {
            id: '131002',
            label: '安次区',
            value: '131002',
            parentId: '131000'
          },
          {
            id: '131003',
            label: '广阳区',
            value: '131003',
            parentId: '131000'
          },
          {
            id: '131022',
            label: '固安县',
            value: '131022',
            parentId: '131000'
          },
          {
            id: '131023',
            label: '永清县',
            value: '131023',
            parentId: '131000'
          },
          {
            id: '131024',
            label: '香河县',
            value: '131024',
            parentId: '131000'
          },
          {
            id: '131025',
            label: '大城县',
            value: '131025',
            parentId: '131000'
          },
          {
            id: '131026',
            label: '文安县',
            value: '131026',
            parentId: '131000'
          },
          {
            id: '131028',
            label: '大厂回族自治县',
            value: '131028',
            parentId: '131000'
          },
          {
            id: '131081',
            label: '霸州市',
            value: '131081',
            parentId: '131000'
          },
          {
            id: '131082',
            label: '三河市',
            value: '131082',
            parentId: '131000'
          }
        ]
      },
      {
        id: '131100',
        label: '衡水市',
        value: '131100',
        parentId: '130000',
        children: [
          {
            id: '131102',
            label: '桃城区',
            value: '131102',
            parentId: '131100'
          },
          {
            id: '131103',
            label: '冀州区',
            value: '131103',
            parentId: '131100'
          },
          {
            id: '131121',
            label: '枣强县',
            value: '131121',
            parentId: '131100'
          },
          {
            id: '131122',
            label: '武邑县',
            value: '131122',
            parentId: '131100'
          },
          {
            id: '131123',
            label: '武强县',
            value: '131123',
            parentId: '131100'
          },
          {
            id: '131124',
            label: '饶阳县',
            value: '131124',
            parentId: '131100'
          },
          {
            id: '131125',
            label: '安平县',
            value: '131125',
            parentId: '131100'
          },
          {
            id: '131126',
            label: '故城县',
            value: '131126',
            parentId: '131100'
          },
          {
            id: '131127',
            label: '景县',
            value: '131127',
            parentId: '131100'
          },
          {
            id: '131128',
            label: '阜城县',
            value: '131128',
            parentId: '131100'
          },
          {
            id: '131182',
            label: '深州市',
            value: '131182',
            parentId: '131100'
          }
        ]
      }
    ]
  },
  {
    id: '140000',
    label: '山西省',
    value: '140000',
    children: [
      {
        id: '140100',
        label: '太原市',
        value: '140100',
        parentId: '140000',
        children: [
          {
            id: '140105',
            label: '小店区',
            value: '140105',
            parentId: '140100'
          },
          {
            id: '140106',
            label: '迎泽区',
            value: '140106',
            parentId: '140100'
          },
          {
            id: '140107',
            label: '杏花岭区',
            value: '140107',
            parentId: '140100'
          },
          {
            id: '140108',
            label: '尖草坪区',
            value: '140108',
            parentId: '140100'
          },
          {
            id: '140109',
            label: '万柏林区',
            value: '140109',
            parentId: '140100'
          },
          {
            id: '140110',
            label: '晋源区',
            value: '140110',
            parentId: '140100'
          },
          {
            id: '140121',
            label: '清徐县',
            value: '140121',
            parentId: '140100'
          },
          {
            id: '140122',
            label: '阳曲县',
            value: '140122',
            parentId: '140100'
          },
          {
            id: '140123',
            label: '娄烦县',
            value: '140123',
            parentId: '140100'
          },
          {
            id: '140181',
            label: '古交市',
            value: '140181',
            parentId: '140100'
          }
        ]
      },
      {
        id: '140200',
        label: '大同市',
        value: '140200',
        parentId: '140000',
        children: [
          {
            id: '140212',
            label: '新荣区',
            value: '140212',
            parentId: '140200'
          },
          {
            id: '140213',
            label: '平城区',
            value: '140213',
            parentId: '140200'
          },
          {
            id: '140214',
            label: '云冈区',
            value: '140214',
            parentId: '140200'
          },
          {
            id: '140215',
            label: '云州区',
            value: '140215',
            parentId: '140200'
          },
          {
            id: '140221',
            label: '阳高县',
            value: '140221',
            parentId: '140200'
          },
          {
            id: '140222',
            label: '天镇县',
            value: '140222',
            parentId: '140200'
          },
          {
            id: '140223',
            label: '广灵县',
            value: '140223',
            parentId: '140200'
          },
          {
            id: '140224',
            label: '灵丘县',
            value: '140224',
            parentId: '140200'
          },
          {
            id: '140225',
            label: '浑源县',
            value: '140225',
            parentId: '140200'
          },
          {
            id: '140226',
            label: '左云县',
            value: '140226',
            parentId: '140200'
          }
        ]
      },
      {
        id: '140300',
        label: '阳泉市',
        value: '140300',
        parentId: '140000',
        children: [
          {
            id: '140302',
            label: '城区',
            value: '140302',
            parentId: '140300'
          },
          {
            id: '140303',
            label: '矿区',
            value: '140303',
            parentId: '140300'
          },
          {
            id: '140311',
            label: '郊区',
            value: '140311',
            parentId: '140300'
          },
          {
            id: '140321',
            label: '平定县',
            value: '140321',
            parentId: '140300'
          },
          {
            id: '140322',
            label: '盂县',
            value: '140322',
            parentId: '140300'
          }
        ]
      },
      {
        id: '140400',
        label: '长治市',
        value: '140400',
        parentId: '140000',
        children: [
          {
            id: '140403',
            label: '潞州区',
            value: '140403',
            parentId: '140400'
          },
          {
            id: '140404',
            label: '上党区',
            value: '140404',
            parentId: '140400'
          },
          {
            id: '140405',
            label: '屯留区',
            value: '140405',
            parentId: '140400'
          },
          {
            id: '140406',
            label: '潞城区',
            value: '140406',
            parentId: '140400'
          },
          {
            id: '140423',
            label: '襄垣县',
            value: '140423',
            parentId: '140400'
          },
          {
            id: '140425',
            label: '平顺县',
            value: '140425',
            parentId: '140400'
          },
          {
            id: '140426',
            label: '黎城县',
            value: '140426',
            parentId: '140400'
          },
          {
            id: '140427',
            label: '壶关县',
            value: '140427',
            parentId: '140400'
          },
          {
            id: '140428',
            label: '长子县',
            value: '140428',
            parentId: '140400'
          },
          {
            id: '140429',
            label: '武乡县',
            value: '140429',
            parentId: '140400'
          },
          {
            id: '140430',
            label: '沁县',
            value: '140430',
            parentId: '140400'
          },
          {
            id: '140431',
            label: '沁源县',
            value: '140431',
            parentId: '140400'
          }
        ]
      },
      {
        id: '140500',
        label: '晋城市',
        value: '140500',
        parentId: '140000',
        children: [
          {
            id: '140502',
            label: '城区',
            value: '140502',
            parentId: '140500'
          },
          {
            id: '140521',
            label: '沁水县',
            value: '140521',
            parentId: '140500'
          },
          {
            id: '140522',
            label: '阳城县',
            value: '140522',
            parentId: '140500'
          },
          {
            id: '140524',
            label: '陵川县',
            value: '140524',
            parentId: '140500'
          },
          {
            id: '140525',
            label: '泽州县',
            value: '140525',
            parentId: '140500'
          },
          {
            id: '140581',
            label: '高平市',
            value: '140581',
            parentId: '140500'
          }
        ]
      },
      {
        id: '140600',
        label: '朔州市',
        value: '140600',
        parentId: '140000',
        children: [
          {
            id: '140602',
            label: '朔城区',
            value: '140602',
            parentId: '140600'
          },
          {
            id: '140603',
            label: '平鲁区',
            value: '140603',
            parentId: '140600'
          },
          {
            id: '140621',
            label: '山阴县',
            value: '140621',
            parentId: '140600'
          },
          {
            id: '140622',
            label: '应县',
            value: '140622',
            parentId: '140600'
          },
          {
            id: '140623',
            label: '右玉县',
            value: '140623',
            parentId: '140600'
          },
          {
            id: '140681',
            label: '怀仁市',
            value: '140681',
            parentId: '140600'
          }
        ]
      },
      {
        id: '140700',
        label: '晋中市',
        value: '140700',
        parentId: '140000',
        children: [
          {
            id: '140702',
            label: '榆次区',
            value: '140702',
            parentId: '140700'
          },
          {
            id: '140703',
            label: '太谷区',
            value: '140703',
            parentId: '140700'
          },
          {
            id: '140721',
            label: '榆社县',
            value: '140721',
            parentId: '140700'
          },
          {
            id: '140722',
            label: '左权县',
            value: '140722',
            parentId: '140700'
          },
          {
            id: '140723',
            label: '和顺县',
            value: '140723',
            parentId: '140700'
          },
          {
            id: '140724',
            label: '昔阳县',
            value: '140724',
            parentId: '140700'
          },
          {
            id: '140725',
            label: '寿阳县',
            value: '140725',
            parentId: '140700'
          },
          {
            id: '140727',
            label: '祁县',
            value: '140727',
            parentId: '140700'
          },
          {
            id: '140728',
            label: '平遥县',
            value: '140728',
            parentId: '140700'
          },
          {
            id: '140729',
            label: '灵石县',
            value: '140729',
            parentId: '140700'
          },
          {
            id: '140781',
            label: '介休市',
            value: '140781',
            parentId: '140700'
          }
        ]
      },
      {
        id: '140800',
        label: '运城市',
        value: '140800',
        parentId: '140000',
        children: [
          {
            id: '140802',
            label: '盐湖区',
            value: '140802',
            parentId: '140800'
          },
          {
            id: '140821',
            label: '临猗县',
            value: '140821',
            parentId: '140800'
          },
          {
            id: '140822',
            label: '万荣县',
            value: '140822',
            parentId: '140800'
          },
          {
            id: '140823',
            label: '闻喜县',
            value: '140823',
            parentId: '140800'
          },
          {
            id: '140824',
            label: '稷山县',
            value: '140824',
            parentId: '140800'
          },
          {
            id: '140825',
            label: '新绛县',
            value: '140825',
            parentId: '140800'
          },
          {
            id: '140826',
            label: '绛县',
            value: '140826',
            parentId: '140800'
          },
          {
            id: '140827',
            label: '垣曲县',
            value: '140827',
            parentId: '140800'
          },
          {
            id: '140828',
            label: '夏县',
            value: '140828',
            parentId: '140800'
          },
          {
            id: '140829',
            label: '平陆县',
            value: '140829',
            parentId: '140800'
          },
          {
            id: '140830',
            label: '芮城县',
            value: '140830',
            parentId: '140800'
          },
          {
            id: '140881',
            label: '永济市',
            value: '140881',
            parentId: '140800'
          },
          {
            id: '140882',
            label: '河津市',
            value: '140882',
            parentId: '140800'
          }
        ]
      },
      {
        id: '140900',
        label: '忻州市',
        value: '140900',
        parentId: '140000',
        children: [
          {
            id: '140902',
            label: '忻府区',
            value: '140902',
            parentId: '140900'
          },
          {
            id: '140921',
            label: '定襄县',
            value: '140921',
            parentId: '140900'
          },
          {
            id: '140922',
            label: '五台县',
            value: '140922',
            parentId: '140900'
          },
          {
            id: '140923',
            label: '代县',
            value: '140923',
            parentId: '140900'
          },
          {
            id: '140924',
            label: '繁峙县',
            value: '140924',
            parentId: '140900'
          },
          {
            id: '140925',
            label: '宁武县',
            value: '140925',
            parentId: '140900'
          },
          {
            id: '140926',
            label: '静乐县',
            value: '140926',
            parentId: '140900'
          },
          {
            id: '140927',
            label: '神池县',
            value: '140927',
            parentId: '140900'
          },
          {
            id: '140928',
            label: '五寨县',
            value: '140928',
            parentId: '140900'
          },
          {
            id: '140929',
            label: '岢岚县',
            value: '140929',
            parentId: '140900'
          },
          {
            id: '140930',
            label: '河曲县',
            value: '140930',
            parentId: '140900'
          },
          {
            id: '140931',
            label: '保德县',
            value: '140931',
            parentId: '140900'
          },
          {
            id: '140932',
            label: '偏关县',
            value: '140932',
            parentId: '140900'
          },
          {
            id: '140981',
            label: '原平市',
            value: '140981',
            parentId: '140900'
          }
        ]
      },
      {
        id: '141000',
        label: '临汾市',
        value: '141000',
        parentId: '140000',
        children: [
          {
            id: '141002',
            label: '尧都区',
            value: '141002',
            parentId: '141000'
          },
          {
            id: '141021',
            label: '曲沃县',
            value: '141021',
            parentId: '141000'
          },
          {
            id: '141022',
            label: '翼城县',
            value: '141022',
            parentId: '141000'
          },
          {
            id: '141023',
            label: '襄汾县',
            value: '141023',
            parentId: '141000'
          },
          {
            id: '141024',
            label: '洪洞县',
            value: '141024',
            parentId: '141000'
          },
          {
            id: '141025',
            label: '古县',
            value: '141025',
            parentId: '141000'
          },
          {
            id: '141026',
            label: '安泽县',
            value: '141026',
            parentId: '141000'
          },
          {
            id: '141027',
            label: '浮山县',
            value: '141027',
            parentId: '141000'
          },
          {
            id: '141028',
            label: '吉县',
            value: '141028',
            parentId: '141000'
          },
          {
            id: '141029',
            label: '乡宁县',
            value: '141029',
            parentId: '141000'
          },
          {
            id: '141030',
            label: '大宁县',
            value: '141030',
            parentId: '141000'
          },
          {
            id: '141031',
            label: '隰县',
            value: '141031',
            parentId: '141000'
          },
          {
            id: '141032',
            label: '永和县',
            value: '141032',
            parentId: '141000'
          },
          {
            id: '141033',
            label: '蒲县',
            value: '141033',
            parentId: '141000'
          },
          {
            id: '141034',
            label: '汾西县',
            value: '141034',
            parentId: '141000'
          },
          {
            id: '141081',
            label: '侯马市',
            value: '141081',
            parentId: '141000'
          },
          {
            id: '141082',
            label: '霍州市',
            value: '141082',
            parentId: '141000'
          }
        ]
      },
      {
        id: '141100',
        label: '吕梁市',
        value: '141100',
        parentId: '140000',
        children: [
          {
            id: '141102',
            label: '离石区',
            value: '141102',
            parentId: '141100'
          },
          {
            id: '141121',
            label: '文水县',
            value: '141121',
            parentId: '141100'
          },
          {
            id: '141122',
            label: '交城县',
            value: '141122',
            parentId: '141100'
          },
          {
            id: '141123',
            label: '兴县',
            value: '141123',
            parentId: '141100'
          },
          {
            id: '141124',
            label: '临县',
            value: '141124',
            parentId: '141100'
          },
          {
            id: '141125',
            label: '柳林县',
            value: '141125',
            parentId: '141100'
          },
          {
            id: '141126',
            label: '石楼县',
            value: '141126',
            parentId: '141100'
          },
          {
            id: '141127',
            label: '岚县',
            value: '141127',
            parentId: '141100'
          },
          {
            id: '141128',
            label: '方山县',
            value: '141128',
            parentId: '141100'
          },
          {
            id: '141129',
            label: '中阳县',
            value: '141129',
            parentId: '141100'
          },
          {
            id: '141130',
            label: '交口县',
            value: '141130',
            parentId: '141100'
          },
          {
            id: '141181',
            label: '孝义市',
            value: '141181',
            parentId: '141100'
          },
          {
            id: '141182',
            label: '汾阳市',
            value: '141182',
            parentId: '141100'
          }
        ]
      }
    ]
  },
  {
    id: '150000',
    label: '内蒙古自治区',
    value: '150000',
    children: [
      {
        id: '150100',
        label: '呼和浩特市',
        value: '150100',
        parentId: '150000',
        children: [
          {
            id: '150102',
            label: '新城区',
            value: '150102',
            parentId: '150100'
          },
          {
            id: '150103',
            label: '回民区',
            value: '150103',
            parentId: '150100'
          },
          {
            id: '150104',
            label: '玉泉区',
            value: '150104',
            parentId: '150100'
          },
          {
            id: '150105',
            label: '赛罕区',
            value: '150105',
            parentId: '150100'
          },
          {
            id: '150121',
            label: '土默特左旗',
            value: '150121',
            parentId: '150100'
          },
          {
            id: '150122',
            label: '托克托县',
            value: '150122',
            parentId: '150100'
          },
          {
            id: '150123',
            label: '和林格尔县',
            value: '150123',
            parentId: '150100'
          },
          {
            id: '150124',
            label: '清水河县',
            value: '150124',
            parentId: '150100'
          },
          {
            id: '150125',
            label: '武川县',
            value: '150125',
            parentId: '150100'
          }
        ]
      },
      {
        id: '150200',
        label: '包头市',
        value: '150200',
        parentId: '150000',
        children: [
          {
            id: '150202',
            label: '东河区',
            value: '150202',
            parentId: '150200'
          },
          {
            id: '150203',
            label: '昆都仑区',
            value: '150203',
            parentId: '150200'
          },
          {
            id: '150204',
            label: '青山区',
            value: '150204',
            parentId: '150200'
          },
          {
            id: '150205',
            label: '石拐区',
            value: '150205',
            parentId: '150200'
          },
          {
            id: '150206',
            label: '白云鄂博矿区',
            value: '150206',
            parentId: '150200'
          },
          {
            id: '150207',
            label: '九原区',
            value: '150207',
            parentId: '150200'
          },
          {
            id: '150221',
            label: '土默特右旗',
            value: '150221',
            parentId: '150200'
          },
          {
            id: '150222',
            label: '固阳县',
            value: '150222',
            parentId: '150200'
          },
          {
            id: '150223',
            label: '达尔罕茂明安联合旗',
            value: '150223',
            parentId: '150200'
          }
        ]
      },
      {
        id: '150300',
        label: '乌海市',
        value: '150300',
        parentId: '150000',
        children: [
          {
            id: '150302',
            label: '海勃湾区',
            value: '150302',
            parentId: '150300'
          },
          {
            id: '150303',
            label: '海南区',
            value: '150303',
            parentId: '150300'
          },
          {
            id: '150304',
            label: '乌达区',
            value: '150304',
            parentId: '150300'
          }
        ]
      },
      {
        id: '150400',
        label: '赤峰市',
        value: '150400',
        parentId: '150000',
        children: [
          {
            id: '150402',
            label: '红山区',
            value: '150402',
            parentId: '150400'
          },
          {
            id: '150403',
            label: '元宝山区',
            value: '150403',
            parentId: '150400'
          },
          {
            id: '150404',
            label: '松山区',
            value: '150404',
            parentId: '150400'
          },
          {
            id: '150421',
            label: '阿鲁科尔沁旗',
            value: '150421',
            parentId: '150400'
          },
          {
            id: '150422',
            label: '巴林左旗',
            value: '150422',
            parentId: '150400'
          },
          {
            id: '150423',
            label: '巴林右旗',
            value: '150423',
            parentId: '150400'
          },
          {
            id: '150424',
            label: '林西县',
            value: '150424',
            parentId: '150400'
          },
          {
            id: '150425',
            label: '克什克腾旗',
            value: '150425',
            parentId: '150400'
          },
          {
            id: '150426',
            label: '翁牛特旗',
            value: '150426',
            parentId: '150400'
          },
          {
            id: '150428',
            label: '喀喇沁旗',
            value: '150428',
            parentId: '150400'
          },
          {
            id: '150429',
            label: '宁城县',
            value: '150429',
            parentId: '150400'
          },
          {
            id: '150430',
            label: '敖汉旗',
            value: '150430',
            parentId: '150400'
          }
        ]
      },
      {
        id: '150500',
        label: '通辽市',
        value: '150500',
        parentId: '150000',
        children: [
          {
            id: '150502',
            label: '科尔沁区',
            value: '150502',
            parentId: '150500'
          },
          {
            id: '150521',
            label: '科尔沁左翼中旗',
            value: '150521',
            parentId: '150500'
          },
          {
            id: '150522',
            label: '科尔沁左翼后旗',
            value: '150522',
            parentId: '150500'
          },
          {
            id: '150523',
            label: '开鲁县',
            value: '150523',
            parentId: '150500'
          },
          {
            id: '150524',
            label: '库伦旗',
            value: '150524',
            parentId: '150500'
          },
          {
            id: '150525',
            label: '奈曼旗',
            value: '150525',
            parentId: '150500'
          },
          {
            id: '150526',
            label: '扎鲁特旗',
            value: '150526',
            parentId: '150500'
          },
          {
            id: '150581',
            label: '霍林郭勒市',
            value: '150581',
            parentId: '150500'
          }
        ]
      },
      {
        id: '150600',
        label: '鄂尔多斯市',
        value: '150600',
        parentId: '150000',
        children: [
          {
            id: '150602',
            label: '东胜区',
            value: '150602',
            parentId: '150600'
          },
          {
            id: '150603',
            label: '康巴什区',
            value: '150603',
            parentId: '150600'
          },
          {
            id: '150621',
            label: '达拉特旗',
            value: '150621',
            parentId: '150600'
          },
          {
            id: '150622',
            label: '准格尔旗',
            value: '150622',
            parentId: '150600'
          },
          {
            id: '150623',
            label: '鄂托克前旗',
            value: '150623',
            parentId: '150600'
          },
          {
            id: '150624',
            label: '鄂托克旗',
            value: '150624',
            parentId: '150600'
          },
          {
            id: '150625',
            label: '杭锦旗',
            value: '150625',
            parentId: '150600'
          },
          {
            id: '150626',
            label: '乌审旗',
            value: '150626',
            parentId: '150600'
          },
          {
            id: '150627',
            label: '伊金霍洛旗',
            value: '150627',
            parentId: '150600'
          }
        ]
      },
      {
        id: '150700',
        label: '呼伦贝尔市',
        value: '150700',
        parentId: '150000',
        children: [
          {
            id: '150702',
            label: '海拉尔区',
            value: '150702',
            parentId: '150700'
          },
          {
            id: '150703',
            label: '扎赉诺尔区',
            value: '150703',
            parentId: '150700'
          },
          {
            id: '150721',
            label: '阿荣旗',
            value: '150721',
            parentId: '150700'
          },
          {
            id: '150722',
            label: '莫力达瓦达斡尔族自治旗',
            value: '150722',
            parentId: '150700'
          },
          {
            id: '150723',
            label: '鄂伦春自治旗',
            value: '150723',
            parentId: '150700'
          },
          {
            id: '150724',
            label: '鄂温克族自治旗',
            value: '150724',
            parentId: '150700'
          },
          {
            id: '150725',
            label: '陈巴尔虎旗',
            value: '150725',
            parentId: '150700'
          },
          {
            id: '150726',
            label: '新巴尔虎左旗',
            value: '150726',
            parentId: '150700'
          },
          {
            id: '150727',
            label: '新巴尔虎右旗',
            value: '150727',
            parentId: '150700'
          },
          {
            id: '150781',
            label: '满洲里市',
            value: '150781',
            parentId: '150700'
          },
          {
            id: '150782',
            label: '牙克石市',
            value: '150782',
            parentId: '150700'
          },
          {
            id: '150783',
            label: '扎兰屯市',
            value: '150783',
            parentId: '150700'
          },
          {
            id: '150784',
            label: '额尔古纳市',
            value: '150784',
            parentId: '150700'
          },
          {
            id: '150785',
            label: '根河市',
            value: '150785',
            parentId: '150700'
          }
        ]
      },
      {
        id: '150800',
        label: '巴彦淖尔市',
        value: '150800',
        parentId: '150000',
        children: [
          {
            id: '150802',
            label: '临河区',
            value: '150802',
            parentId: '150800'
          },
          {
            id: '150821',
            label: '五原县',
            value: '150821',
            parentId: '150800'
          },
          {
            id: '150822',
            label: '磴口县',
            value: '150822',
            parentId: '150800'
          },
          {
            id: '150823',
            label: '乌拉特前旗',
            value: '150823',
            parentId: '150800'
          },
          {
            id: '150824',
            label: '乌拉特中旗',
            value: '150824',
            parentId: '150800'
          },
          {
            id: '150825',
            label: '乌拉特后旗',
            value: '150825',
            parentId: '150800'
          },
          {
            id: '150826',
            label: '杭锦后旗',
            value: '150826',
            parentId: '150800'
          }
        ]
      },
      {
        id: '150900',
        label: '乌兰察布市',
        value: '150900',
        parentId: '150000',
        children: [
          {
            id: '150902',
            label: '集宁区',
            value: '150902',
            parentId: '150900'
          },
          {
            id: '150921',
            label: '卓资县',
            value: '150921',
            parentId: '150900'
          },
          {
            id: '150922',
            label: '化德县',
            value: '150922',
            parentId: '150900'
          },
          {
            id: '150923',
            label: '商都县',
            value: '150923',
            parentId: '150900'
          },
          {
            id: '150924',
            label: '兴和县',
            value: '150924',
            parentId: '150900'
          },
          {
            id: '150925',
            label: '凉城县',
            value: '150925',
            parentId: '150900'
          },
          {
            id: '150926',
            label: '察哈尔右翼前旗',
            value: '150926',
            parentId: '150900'
          },
          {
            id: '150927',
            label: '察哈尔右翼中旗',
            value: '150927',
            parentId: '150900'
          },
          {
            id: '150928',
            label: '察哈尔右翼后旗',
            value: '150928',
            parentId: '150900'
          },
          {
            id: '150929',
            label: '四子王旗',
            value: '150929',
            parentId: '150900'
          },
          {
            id: '150981',
            label: '丰镇市',
            value: '150981',
            parentId: '150900'
          }
        ]
      },
      {
        id: '152200',
        label: '兴安盟',
        value: '152200',
        parentId: '150000',
        children: [
          {
            id: '152201',
            label: '乌兰浩特市',
            value: '152201',
            parentId: '152200'
          },
          {
            id: '152202',
            label: '阿尔山市',
            value: '152202',
            parentId: '152200'
          },
          {
            id: '152221',
            label: '科尔沁右翼前旗',
            value: '152221',
            parentId: '152200'
          },
          {
            id: '152222',
            label: '科尔沁右翼中旗',
            value: '152222',
            parentId: '152200'
          },
          {
            id: '152223',
            label: '扎赉特旗',
            value: '152223',
            parentId: '152200'
          },
          {
            id: '152224',
            label: '突泉县',
            value: '152224',
            parentId: '152200'
          }
        ]
      },
      {
        id: '152500',
        label: '锡林郭勒盟',
        value: '152500',
        parentId: '150000',
        children: [
          {
            id: '152501',
            label: '二连浩特市',
            value: '152501',
            parentId: '152500'
          },
          {
            id: '152502',
            label: '锡林浩特市',
            value: '152502',
            parentId: '152500'
          },
          {
            id: '152522',
            label: '阿巴嘎旗',
            value: '152522',
            parentId: '152500'
          },
          {
            id: '152523',
            label: '苏尼特左旗',
            value: '152523',
            parentId: '152500'
          },
          {
            id: '152524',
            label: '苏尼特右旗',
            value: '152524',
            parentId: '152500'
          },
          {
            id: '152525',
            label: '东乌珠穆沁旗',
            value: '152525',
            parentId: '152500'
          },
          {
            id: '152526',
            label: '西乌珠穆沁旗',
            value: '152526',
            parentId: '152500'
          },
          {
            id: '152527',
            label: '太仆寺旗',
            value: '152527',
            parentId: '152500'
          },
          {
            id: '152528',
            label: '镶黄旗',
            value: '152528',
            parentId: '152500'
          },
          {
            id: '152529',
            label: '正镶白旗',
            value: '152529',
            parentId: '152500'
          },
          {
            id: '152530',
            label: '正蓝旗',
            value: '152530',
            parentId: '152500'
          },
          {
            id: '152531',
            label: '多伦县',
            value: '152531',
            parentId: '152500'
          }
        ]
      },
      {
        id: '152900',
        label: '阿拉善盟',
        value: '152900',
        parentId: '150000',
        children: [
          {
            id: '152921',
            label: '阿拉善左旗',
            value: '152921',
            parentId: '152900'
          },
          {
            id: '152922',
            label: '阿拉善右旗',
            value: '152922',
            parentId: '152900'
          },
          {
            id: '152923',
            label: '额济纳旗',
            value: '152923',
            parentId: '152900'
          }
        ]
      }
    ]
  },
  {
    id: '210000',
    label: '辽宁省',
    value: '210000',
    children: [
      {
        id: '210100',
        label: '沈阳市',
        value: '210100',
        parentId: '210000',
        children: [
          {
            id: '210102',
            label: '和平区',
            value: '210102',
            parentId: '210100'
          },
          {
            id: '210103',
            label: '沈河区',
            value: '210103',
            parentId: '210100'
          },
          {
            id: '210104',
            label: '大东区',
            value: '210104',
            parentId: '210100'
          },
          {
            id: '210105',
            label: '皇姑区',
            value: '210105',
            parentId: '210100'
          },
          {
            id: '210106',
            label: '铁西区',
            value: '210106',
            parentId: '210100'
          },
          {
            id: '210111',
            label: '苏家屯区',
            value: '210111',
            parentId: '210100'
          },
          {
            id: '210112',
            label: '浑南区',
            value: '210112',
            parentId: '210100'
          },
          {
            id: '210113',
            label: '沈北新区',
            value: '210113',
            parentId: '210100'
          },
          {
            id: '210114',
            label: '于洪区',
            value: '210114',
            parentId: '210100'
          },
          {
            id: '210115',
            label: '辽中区',
            value: '210115',
            parentId: '210100'
          },
          {
            id: '210123',
            label: '康平县',
            value: '210123',
            parentId: '210100'
          },
          {
            id: '210124',
            label: '法库县',
            value: '210124',
            parentId: '210100'
          },
          {
            id: '210181',
            label: '新民市',
            value: '210181',
            parentId: '210100'
          }
        ]
      },
      {
        id: '210200',
        label: '大连市',
        value: '210200',
        parentId: '210000',
        children: [
          {
            id: '210202',
            label: '中山区',
            value: '210202',
            parentId: '210200'
          },
          {
            id: '210203',
            label: '西岗区',
            value: '210203',
            parentId: '210200'
          },
          {
            id: '210204',
            label: '沙河口区',
            value: '210204',
            parentId: '210200'
          },
          {
            id: '210211',
            label: '甘井子区',
            value: '210211',
            parentId: '210200'
          },
          {
            id: '210212',
            label: '旅顺口区',
            value: '210212',
            parentId: '210200'
          },
          {
            id: '210213',
            label: '金州区',
            value: '210213',
            parentId: '210200'
          },
          {
            id: '210214',
            label: '普兰店区',
            value: '210214',
            parentId: '210200'
          },
          {
            id: '210224',
            label: '长海县',
            value: '210224',
            parentId: '210200'
          },
          {
            id: '210281',
            label: '瓦房店市',
            value: '210281',
            parentId: '210200'
          },
          {
            id: '210283',
            label: '庄河市',
            value: '210283',
            parentId: '210200'
          }
        ]
      },
      {
        id: '210300',
        label: '鞍山市',
        value: '210300',
        parentId: '210000',
        children: [
          {
            id: '210302',
            label: '铁东区',
            value: '210302',
            parentId: '210300'
          },
          {
            id: '210303',
            label: '铁西区',
            value: '210303',
            parentId: '210300'
          },
          {
            id: '210304',
            label: '立山区',
            value: '210304',
            parentId: '210300'
          },
          {
            id: '210311',
            label: '千山区',
            value: '210311',
            parentId: '210300'
          },
          {
            id: '210321',
            label: '台安县',
            value: '210321',
            parentId: '210300'
          },
          {
            id: '210323',
            label: '岫岩满族自治县',
            value: '210323',
            parentId: '210300'
          },
          {
            id: '210381',
            label: '海城市',
            value: '210381',
            parentId: '210300'
          }
        ]
      },
      {
        id: '210400',
        label: '抚顺市',
        value: '210400',
        parentId: '210000',
        children: [
          {
            id: '210402',
            label: '新抚区',
            value: '210402',
            parentId: '210400'
          },
          {
            id: '210403',
            label: '东洲区',
            value: '210403',
            parentId: '210400'
          },
          {
            id: '210404',
            label: '望花区',
            value: '210404',
            parentId: '210400'
          },
          {
            id: '210411',
            label: '顺城区',
            value: '210411',
            parentId: '210400'
          },
          {
            id: '210421',
            label: '抚顺县',
            value: '210421',
            parentId: '210400'
          },
          {
            id: '210422',
            label: '新宾满族自治县',
            value: '210422',
            parentId: '210400'
          },
          {
            id: '210423',
            label: '清原满族自治县',
            value: '210423',
            parentId: '210400'
          }
        ]
      },
      {
        id: '210500',
        label: '本溪市',
        value: '210500',
        parentId: '210000',
        children: [
          {
            id: '210502',
            label: '平山区',
            value: '210502',
            parentId: '210500'
          },
          {
            id: '210503',
            label: '溪湖区',
            value: '210503',
            parentId: '210500'
          },
          {
            id: '210504',
            label: '明山区',
            value: '210504',
            parentId: '210500'
          },
          {
            id: '210505',
            label: '南芬区',
            value: '210505',
            parentId: '210500'
          },
          {
            id: '210521',
            label: '本溪满族自治县',
            value: '210521',
            parentId: '210500'
          },
          {
            id: '210522',
            label: '桓仁满族自治县',
            value: '210522',
            parentId: '210500'
          }
        ]
      },
      {
        id: '210600',
        label: '丹东市',
        value: '210600',
        parentId: '210000',
        children: [
          {
            id: '210602',
            label: '元宝区',
            value: '210602',
            parentId: '210600'
          },
          {
            id: '210603',
            label: '振兴区',
            value: '210603',
            parentId: '210600'
          },
          {
            id: '210604',
            label: '振安区',
            value: '210604',
            parentId: '210600'
          },
          {
            id: '210624',
            label: '宽甸满族自治县',
            value: '210624',
            parentId: '210600'
          },
          {
            id: '210681',
            label: '东港市',
            value: '210681',
            parentId: '210600'
          },
          {
            id: '210682',
            label: '凤城市',
            value: '210682',
            parentId: '210600'
          }
        ]
      },
      {
        id: '210700',
        label: '锦州市',
        value: '210700',
        parentId: '210000',
        children: [
          {
            id: '210702',
            label: '古塔区',
            value: '210702',
            parentId: '210700'
          },
          {
            id: '210703',
            label: '凌河区',
            value: '210703',
            parentId: '210700'
          },
          {
            id: '210711',
            label: '太和区',
            value: '210711',
            parentId: '210700'
          },
          {
            id: '210726',
            label: '黑山县',
            value: '210726',
            parentId: '210700'
          },
          {
            id: '210727',
            label: '义县',
            value: '210727',
            parentId: '210700'
          },
          {
            id: '210781',
            label: '凌海市',
            value: '210781',
            parentId: '210700'
          },
          {
            id: '210782',
            label: '北镇市',
            value: '210782',
            parentId: '210700'
          }
        ]
      },
      {
        id: '210800',
        label: '营口市',
        value: '210800',
        parentId: '210000',
        children: [
          {
            id: '210802',
            label: '站前区',
            value: '210802',
            parentId: '210800'
          },
          {
            id: '210803',
            label: '西市区',
            value: '210803',
            parentId: '210800'
          },
          {
            id: '210804',
            label: '鲅鱼圈区',
            value: '210804',
            parentId: '210800'
          },
          {
            id: '210811',
            label: '老边区',
            value: '210811',
            parentId: '210800'
          },
          {
            id: '210881',
            label: '盖州市',
            value: '210881',
            parentId: '210800'
          },
          {
            id: '210882',
            label: '大石桥市',
            value: '210882',
            parentId: '210800'
          }
        ]
      },
      {
        id: '210900',
        label: '阜新市',
        value: '210900',
        parentId: '210000',
        children: [
          {
            id: '210902',
            label: '海州区',
            value: '210902',
            parentId: '210900'
          },
          {
            id: '210903',
            label: '新邱区',
            value: '210903',
            parentId: '210900'
          },
          {
            id: '210904',
            label: '太平区',
            value: '210904',
            parentId: '210900'
          },
          {
            id: '210905',
            label: '清河门区',
            value: '210905',
            parentId: '210900'
          },
          {
            id: '210911',
            label: '细河区',
            value: '210911',
            parentId: '210900'
          },
          {
            id: '210921',
            label: '阜新蒙古族自治县',
            value: '210921',
            parentId: '210900'
          },
          {
            id: '210922',
            label: '彰武县',
            value: '210922',
            parentId: '210900'
          }
        ]
      },
      {
        id: '211000',
        label: '辽阳市',
        value: '211000',
        parentId: '210000',
        children: [
          {
            id: '211002',
            label: '白塔区',
            value: '211002',
            parentId: '211000'
          },
          {
            id: '211003',
            label: '文圣区',
            value: '211003',
            parentId: '211000'
          },
          {
            id: '211004',
            label: '宏伟区',
            value: '211004',
            parentId: '211000'
          },
          {
            id: '211005',
            label: '弓长岭区',
            value: '211005',
            parentId: '211000'
          },
          {
            id: '211011',
            label: '太子河区',
            value: '211011',
            parentId: '211000'
          },
          {
            id: '211021',
            label: '辽阳县',
            value: '211021',
            parentId: '211000'
          },
          {
            id: '211081',
            label: '灯塔市',
            value: '211081',
            parentId: '211000'
          }
        ]
      },
      {
        id: '211100',
        label: '盘锦市',
        value: '211100',
        parentId: '210000',
        children: [
          {
            id: '211102',
            label: '双台子区',
            value: '211102',
            parentId: '211100'
          },
          {
            id: '211103',
            label: '兴隆台区',
            value: '211103',
            parentId: '211100'
          },
          {
            id: '211104',
            label: '大洼区',
            value: '211104',
            parentId: '211100'
          },
          {
            id: '211122',
            label: '盘山县',
            value: '211122',
            parentId: '211100'
          }
        ]
      },
      {
        id: '211200',
        label: '铁岭市',
        value: '211200',
        parentId: '210000',
        children: [
          {
            id: '211202',
            label: '银州区',
            value: '211202',
            parentId: '211200'
          },
          {
            id: '211204',
            label: '清河区',
            value: '211204',
            parentId: '211200'
          },
          {
            id: '211221',
            label: '铁岭县',
            value: '211221',
            parentId: '211200'
          },
          {
            id: '211223',
            label: '西丰县',
            value: '211223',
            parentId: '211200'
          },
          {
            id: '211224',
            label: '昌图县',
            value: '211224',
            parentId: '211200'
          },
          {
            id: '211281',
            label: '调兵山市',
            value: '211281',
            parentId: '211200'
          },
          {
            id: '211282',
            label: '开原市',
            value: '211282',
            parentId: '211200'
          }
        ]
      },
      {
        id: '211300',
        label: '朝阳市',
        value: '211300',
        parentId: '210000',
        children: [
          {
            id: '211302',
            label: '双塔区',
            value: '211302',
            parentId: '211300'
          },
          {
            id: '211303',
            label: '龙城区',
            value: '211303',
            parentId: '211300'
          },
          {
            id: '211321',
            label: '朝阳县',
            value: '211321',
            parentId: '211300'
          },
          {
            id: '211322',
            label: '建平县',
            value: '211322',
            parentId: '211300'
          },
          {
            id: '211324',
            label: '喀喇沁左翼蒙古族自治县',
            value: '211324',
            parentId: '211300'
          },
          {
            id: '211381',
            label: '北票市',
            value: '211381',
            parentId: '211300'
          },
          {
            id: '211382',
            label: '凌源市',
            value: '211382',
            parentId: '211300'
          }
        ]
      },
      {
        id: '211400',
        label: '葫芦岛市',
        value: '211400',
        parentId: '210000',
        children: [
          {
            id: '211402',
            label: '连山区',
            value: '211402',
            parentId: '211400'
          },
          {
            id: '211403',
            label: '龙港区',
            value: '211403',
            parentId: '211400'
          },
          {
            id: '211404',
            label: '南票区',
            value: '211404',
            parentId: '211400'
          },
          {
            id: '211421',
            label: '绥中县',
            value: '211421',
            parentId: '211400'
          },
          {
            id: '211422',
            label: '建昌县',
            value: '211422',
            parentId: '211400'
          },
          {
            id: '211481',
            label: '兴城市',
            value: '211481',
            parentId: '211400'
          }
        ]
      }
    ]
  },
  {
    id: '220000',
    label: '吉林省',
    value: '220000',
    children: [
      {
        id: '220100',
        label: '长春市',
        value: '220100',
        parentId: '220000',
        children: [
          {
            id: '220102',
            label: '南关区',
            value: '220102',
            parentId: '220100'
          },
          {
            id: '220103',
            label: '宽城区',
            value: '220103',
            parentId: '220100'
          },
          {
            id: '220104',
            label: '朝阳区',
            value: '220104',
            parentId: '220100'
          },
          {
            id: '220105',
            label: '二道区',
            value: '220105',
            parentId: '220100'
          },
          {
            id: '220106',
            label: '绿园区',
            value: '220106',
            parentId: '220100'
          },
          {
            id: '220112',
            label: '双阳区',
            value: '220112',
            parentId: '220100'
          },
          {
            id: '220113',
            label: '九台区',
            value: '220113',
            parentId: '220100'
          },
          {
            id: '220122',
            label: '农安县',
            value: '220122',
            parentId: '220100'
          },
          {
            id: '220182',
            label: '榆树市',
            value: '220182',
            parentId: '220100'
          },
          {
            id: '220183',
            label: '德惠市',
            value: '220183',
            parentId: '220100'
          },
          {
            id: '220184',
            label: '公主岭市',
            value: '220184',
            parentId: '220100'
          }
        ]
      },
      {
        id: '220200',
        label: '吉林市',
        value: '220200',
        parentId: '220000',
        children: [
          {
            id: '220202',
            label: '昌邑区',
            value: '220202',
            parentId: '220200'
          },
          {
            id: '220203',
            label: '龙潭区',
            value: '220203',
            parentId: '220200'
          },
          {
            id: '220204',
            label: '船营区',
            value: '220204',
            parentId: '220200'
          },
          {
            id: '220211',
            label: '丰满区',
            value: '220211',
            parentId: '220200'
          },
          {
            id: '220221',
            label: '永吉县',
            value: '220221',
            parentId: '220200'
          },
          {
            id: '220281',
            label: '蛟河市',
            value: '220281',
            parentId: '220200'
          },
          {
            id: '220282',
            label: '桦甸市',
            value: '220282',
            parentId: '220200'
          },
          {
            id: '220283',
            label: '舒兰市',
            value: '220283',
            parentId: '220200'
          },
          {
            id: '220284',
            label: '磐石市',
            value: '220284',
            parentId: '220200'
          }
        ]
      },
      {
        id: '220300',
        label: '四平市',
        value: '220300',
        parentId: '220000',
        children: [
          {
            id: '220302',
            label: '铁西区',
            value: '220302',
            parentId: '220300'
          },
          {
            id: '220303',
            label: '铁东区',
            value: '220303',
            parentId: '220300'
          },
          {
            id: '220322',
            label: '梨树县',
            value: '220322',
            parentId: '220300'
          },
          {
            id: '220323',
            label: '伊通满族自治县',
            value: '220323',
            parentId: '220300'
          },
          {
            id: '220382',
            label: '双辽市',
            value: '220382',
            parentId: '220300'
          }
        ]
      },
      {
        id: '220400',
        label: '辽源市',
        value: '220400',
        parentId: '220000',
        children: [
          {
            id: '220402',
            label: '龙山区',
            value: '220402',
            parentId: '220400'
          },
          {
            id: '220403',
            label: '西安区',
            value: '220403',
            parentId: '220400'
          },
          {
            id: '220421',
            label: '东丰县',
            value: '220421',
            parentId: '220400'
          },
          {
            id: '220422',
            label: '东辽县',
            value: '220422',
            parentId: '220400'
          }
        ]
      },
      {
        id: '220500',
        label: '通化市',
        value: '220500',
        parentId: '220000',
        children: [
          {
            id: '220502',
            label: '东昌区',
            value: '220502',
            parentId: '220500'
          },
          {
            id: '220503',
            label: '二道江区',
            value: '220503',
            parentId: '220500'
          },
          {
            id: '220521',
            label: '通化县',
            value: '220521',
            parentId: '220500'
          },
          {
            id: '220523',
            label: '辉南县',
            value: '220523',
            parentId: '220500'
          },
          {
            id: '220524',
            label: '柳河县',
            value: '220524',
            parentId: '220500'
          },
          {
            id: '220581',
            label: '梅河口市',
            value: '220581',
            parentId: '220500'
          },
          {
            id: '220582',
            label: '集安市',
            value: '220582',
            parentId: '220500'
          }
        ]
      },
      {
        id: '220600',
        label: '白山市',
        value: '220600',
        parentId: '220000',
        children: [
          {
            id: '220602',
            label: '浑江区',
            value: '220602',
            parentId: '220600'
          },
          {
            id: '220605',
            label: '江源区',
            value: '220605',
            parentId: '220600'
          },
          {
            id: '220621',
            label: '抚松县',
            value: '220621',
            parentId: '220600'
          },
          {
            id: '220622',
            label: '靖宇县',
            value: '220622',
            parentId: '220600'
          },
          {
            id: '220623',
            label: '长白朝鲜族自治县',
            value: '220623',
            parentId: '220600'
          },
          {
            id: '220681',
            label: '临江市',
            value: '220681',
            parentId: '220600'
          }
        ]
      },
      {
        id: '220700',
        label: '松原市',
        value: '220700',
        parentId: '220000',
        children: [
          {
            id: '220702',
            label: '宁江区',
            value: '220702',
            parentId: '220700'
          },
          {
            id: '220721',
            label: '前郭尔罗斯蒙古族自治县',
            value: '220721',
            parentId: '220700'
          },
          {
            id: '220722',
            label: '长岭县',
            value: '220722',
            parentId: '220700'
          },
          {
            id: '220723',
            label: '乾安县',
            value: '220723',
            parentId: '220700'
          },
          {
            id: '220781',
            label: '扶余市',
            value: '220781',
            parentId: '220700'
          }
        ]
      },
      {
        id: '220800',
        label: '白城市',
        value: '220800',
        parentId: '220000',
        children: [
          {
            id: '220802',
            label: '洮北区',
            value: '220802',
            parentId: '220800'
          },
          {
            id: '220821',
            label: '镇赉县',
            value: '220821',
            parentId: '220800'
          },
          {
            id: '220822',
            label: '通榆县',
            value: '220822',
            parentId: '220800'
          },
          {
            id: '220881',
            label: '洮南市',
            value: '220881',
            parentId: '220800'
          },
          {
            id: '220882',
            label: '大安市',
            value: '220882',
            parentId: '220800'
          }
        ]
      },
      {
        id: '222400',
        label: '延边朝鲜族自治州',
        value: '222400',
        parentId: '220000',
        children: [
          {
            id: '222401',
            label: '延吉市',
            value: '222401',
            parentId: '222400'
          },
          {
            id: '222402',
            label: '图们市',
            value: '222402',
            parentId: '222400'
          },
          {
            id: '222403',
            label: '敦化市',
            value: '222403',
            parentId: '222400'
          },
          {
            id: '222404',
            label: '珲春市',
            value: '222404',
            parentId: '222400'
          },
          {
            id: '222405',
            label: '龙井市',
            value: '222405',
            parentId: '222400'
          },
          {
            id: '222406',
            label: '和龙市',
            value: '222406',
            parentId: '222400'
          },
          {
            id: '222424',
            label: '汪清县',
            value: '222424',
            parentId: '222400'
          },
          {
            id: '222426',
            label: '安图县',
            value: '222426',
            parentId: '222400'
          }
        ]
      }
    ]
  },
  {
    id: '230000',
    label: '黑龙江省',
    value: '230000',
    children: [
      {
        id: '230100',
        label: '哈尔滨市',
        value: '230100',
        parentId: '230000',
        children: [
          {
            id: '230102',
            label: '道里区',
            value: '230102',
            parentId: '230100'
          },
          {
            id: '230103',
            label: '南岗区',
            value: '230103',
            parentId: '230100'
          },
          {
            id: '230104',
            label: '道外区',
            value: '230104',
            parentId: '230100'
          },
          {
            id: '230108',
            label: '平房区',
            value: '230108',
            parentId: '230100'
          },
          {
            id: '230109',
            label: '松北区',
            value: '230109',
            parentId: '230100'
          },
          {
            id: '230110',
            label: '香坊区',
            value: '230110',
            parentId: '230100'
          },
          {
            id: '230111',
            label: '呼兰区',
            value: '230111',
            parentId: '230100'
          },
          {
            id: '230112',
            label: '阿城区',
            value: '230112',
            parentId: '230100'
          },
          {
            id: '230113',
            label: '双城区',
            value: '230113',
            parentId: '230100'
          },
          {
            id: '230123',
            label: '依兰县',
            value: '230123',
            parentId: '230100'
          },
          {
            id: '230124',
            label: '方正县',
            value: '230124',
            parentId: '230100'
          },
          {
            id: '230125',
            label: '宾县',
            value: '230125',
            parentId: '230100'
          },
          {
            id: '230126',
            label: '巴彦县',
            value: '230126',
            parentId: '230100'
          },
          {
            id: '230127',
            label: '木兰县',
            value: '230127',
            parentId: '230100'
          },
          {
            id: '230128',
            label: '通河县',
            value: '230128',
            parentId: '230100'
          },
          {
            id: '230129',
            label: '延寿县',
            value: '230129',
            parentId: '230100'
          },
          {
            id: '230183',
            label: '尚志市',
            value: '230183',
            parentId: '230100'
          },
          {
            id: '230184',
            label: '五常市',
            value: '230184',
            parentId: '230100'
          }
        ]
      },
      {
        id: '230200',
        label: '齐齐哈尔市',
        value: '230200',
        parentId: '230000',
        children: [
          {
            id: '230202',
            label: '龙沙区',
            value: '230202',
            parentId: '230200'
          },
          {
            id: '230203',
            label: '建华区',
            value: '230203',
            parentId: '230200'
          },
          {
            id: '230204',
            label: '铁锋区',
            value: '230204',
            parentId: '230200'
          },
          {
            id: '230205',
            label: '昂昂溪区',
            value: '230205',
            parentId: '230200'
          },
          {
            id: '230206',
            label: '富拉尔基区',
            value: '230206',
            parentId: '230200'
          },
          {
            id: '230207',
            label: '碾子山区',
            value: '230207',
            parentId: '230200'
          },
          {
            id: '230208',
            label: '梅里斯达斡尔族区',
            value: '230208',
            parentId: '230200'
          },
          {
            id: '230221',
            label: '龙江县',
            value: '230221',
            parentId: '230200'
          },
          {
            id: '230223',
            label: '依安县',
            value: '230223',
            parentId: '230200'
          },
          {
            id: '230224',
            label: '泰来县',
            value: '230224',
            parentId: '230200'
          },
          {
            id: '230225',
            label: '甘南县',
            value: '230225',
            parentId: '230200'
          },
          {
            id: '230227',
            label: '富裕县',
            value: '230227',
            parentId: '230200'
          },
          {
            id: '230229',
            label: '克山县',
            value: '230229',
            parentId: '230200'
          },
          {
            id: '230230',
            label: '克东县',
            value: '230230',
            parentId: '230200'
          },
          {
            id: '230231',
            label: '拜泉县',
            value: '230231',
            parentId: '230200'
          },
          {
            id: '230281',
            label: '讷河市',
            value: '230281',
            parentId: '230200'
          }
        ]
      },
      {
        id: '230300',
        label: '鸡西市',
        value: '230300',
        parentId: '230000',
        children: [
          {
            id: '230302',
            label: '鸡冠区',
            value: '230302',
            parentId: '230300'
          },
          {
            id: '230303',
            label: '恒山区',
            value: '230303',
            parentId: '230300'
          },
          {
            id: '230304',
            label: '滴道区',
            value: '230304',
            parentId: '230300'
          },
          {
            id: '230305',
            label: '梨树区',
            value: '230305',
            parentId: '230300'
          },
          {
            id: '230306',
            label: '城子河区',
            value: '230306',
            parentId: '230300'
          },
          {
            id: '230307',
            label: '麻山区',
            value: '230307',
            parentId: '230300'
          },
          {
            id: '230321',
            label: '鸡东县',
            value: '230321',
            parentId: '230300'
          },
          {
            id: '230381',
            label: '虎林市',
            value: '230381',
            parentId: '230300'
          },
          {
            id: '230382',
            label: '密山市',
            value: '230382',
            parentId: '230300'
          }
        ]
      },
      {
        id: '230400',
        label: '鹤岗市',
        value: '230400',
        parentId: '230000',
        children: [
          {
            id: '230402',
            label: '向阳区',
            value: '230402',
            parentId: '230400'
          },
          {
            id: '230403',
            label: '工农区',
            value: '230403',
            parentId: '230400'
          },
          {
            id: '230404',
            label: '南山区',
            value: '230404',
            parentId: '230400'
          },
          {
            id: '230405',
            label: '兴安区',
            value: '230405',
            parentId: '230400'
          },
          {
            id: '230406',
            label: '东山区',
            value: '230406',
            parentId: '230400'
          },
          {
            id: '230407',
            label: '兴山区',
            value: '230407',
            parentId: '230400'
          },
          {
            id: '230421',
            label: '萝北县',
            value: '230421',
            parentId: '230400'
          },
          {
            id: '230422',
            label: '绥滨县',
            value: '230422',
            parentId: '230400'
          }
        ]
      },
      {
        id: '230500',
        label: '双鸭山市',
        value: '230500',
        parentId: '230000',
        children: [
          {
            id: '230502',
            label: '尖山区',
            value: '230502',
            parentId: '230500'
          },
          {
            id: '230503',
            label: '岭东区',
            value: '230503',
            parentId: '230500'
          },
          {
            id: '230505',
            label: '四方台区',
            value: '230505',
            parentId: '230500'
          },
          {
            id: '230506',
            label: '宝山区',
            value: '230506',
            parentId: '230500'
          },
          {
            id: '230521',
            label: '集贤县',
            value: '230521',
            parentId: '230500'
          },
          {
            id: '230522',
            label: '友谊县',
            value: '230522',
            parentId: '230500'
          },
          {
            id: '230523',
            label: '宝清县',
            value: '230523',
            parentId: '230500'
          },
          {
            id: '230524',
            label: '饶河县',
            value: '230524',
            parentId: '230500'
          }
        ]
      },
      {
        id: '230600',
        label: '大庆市',
        value: '230600',
        parentId: '230000',
        children: [
          {
            id: '230602',
            label: '萨尔图区',
            value: '230602',
            parentId: '230600'
          },
          {
            id: '230603',
            label: '龙凤区',
            value: '230603',
            parentId: '230600'
          },
          {
            id: '230604',
            label: '让胡路区',
            value: '230604',
            parentId: '230600'
          },
          {
            id: '230605',
            label: '红岗区',
            value: '230605',
            parentId: '230600'
          },
          {
            id: '230606',
            label: '大同区',
            value: '230606',
            parentId: '230600'
          },
          {
            id: '230621',
            label: '肇州县',
            value: '230621',
            parentId: '230600'
          },
          {
            id: '230622',
            label: '肇源县',
            value: '230622',
            parentId: '230600'
          },
          {
            id: '230623',
            label: '林甸县',
            value: '230623',
            parentId: '230600'
          },
          {
            id: '230624',
            label: '杜尔伯特蒙古族自治县',
            value: '230624',
            parentId: '230600'
          }
        ]
      },
      {
        id: '230700',
        label: '伊春市',
        value: '230700',
        parentId: '230000',
        children: [
          {
            id: '230717',
            label: '伊美区',
            value: '230717',
            parentId: '230700'
          },
          {
            id: '230718',
            label: '乌翠区',
            value: '230718',
            parentId: '230700'
          },
          {
            id: '230719',
            label: '友好区',
            value: '230719',
            parentId: '230700'
          },
          {
            id: '230722',
            label: '嘉荫县',
            value: '230722',
            parentId: '230700'
          },
          {
            id: '230723',
            label: '汤旺县',
            value: '230723',
            parentId: '230700'
          },
          {
            id: '230724',
            label: '丰林县',
            value: '230724',
            parentId: '230700'
          },
          {
            id: '230725',
            label: '大箐山县',
            value: '230725',
            parentId: '230700'
          },
          {
            id: '230726',
            label: '南岔县',
            value: '230726',
            parentId: '230700'
          },
          {
            id: '230751',
            label: '金林区',
            value: '230751',
            parentId: '230700'
          },
          {
            id: '230781',
            label: '铁力市',
            value: '230781',
            parentId: '230700'
          }
        ]
      },
      {
        id: '230800',
        label: '佳木斯市',
        value: '230800',
        parentId: '230000',
        children: [
          {
            id: '230803',
            label: '向阳区',
            value: '230803',
            parentId: '230800'
          },
          {
            id: '230804',
            label: '前进区',
            value: '230804',
            parentId: '230800'
          },
          {
            id: '230805',
            label: '东风区',
            value: '230805',
            parentId: '230800'
          },
          {
            id: '230811',
            label: '郊区',
            value: '230811',
            parentId: '230800'
          },
          {
            id: '230822',
            label: '桦南县',
            value: '230822',
            parentId: '230800'
          },
          {
            id: '230826',
            label: '桦川县',
            value: '230826',
            parentId: '230800'
          },
          {
            id: '230828',
            label: '汤原县',
            value: '230828',
            parentId: '230800'
          },
          {
            id: '230881',
            label: '同江市',
            value: '230881',
            parentId: '230800'
          },
          {
            id: '230882',
            label: '富锦市',
            value: '230882',
            parentId: '230800'
          },
          {
            id: '230883',
            label: '抚远市',
            value: '230883',
            parentId: '230800'
          }
        ]
      },
      {
        id: '230900',
        label: '七台河市',
        value: '230900',
        parentId: '230000',
        children: [
          {
            id: '230902',
            label: '新兴区',
            value: '230902',
            parentId: '230900'
          },
          {
            id: '230903',
            label: '桃山区',
            value: '230903',
            parentId: '230900'
          },
          {
            id: '230904',
            label: '茄子河区',
            value: '230904',
            parentId: '230900'
          },
          {
            id: '230921',
            label: '勃利县',
            value: '230921',
            parentId: '230900'
          }
        ]
      },
      {
        id: '231000',
        label: '牡丹江市',
        value: '231000',
        parentId: '230000',
        children: [
          {
            id: '231002',
            label: '东安区',
            value: '231002',
            parentId: '231000'
          },
          {
            id: '231003',
            label: '阳明区',
            value: '231003',
            parentId: '231000'
          },
          {
            id: '231004',
            label: '爱民区',
            value: '231004',
            parentId: '231000'
          },
          {
            id: '231005',
            label: '西安区',
            value: '231005',
            parentId: '231000'
          },
          {
            id: '231025',
            label: '林口县',
            value: '231025',
            parentId: '231000'
          },
          {
            id: '231081',
            label: '绥芬河市',
            value: '231081',
            parentId: '231000'
          },
          {
            id: '231083',
            label: '海林市',
            value: '231083',
            parentId: '231000'
          },
          {
            id: '231084',
            label: '宁安市',
            value: '231084',
            parentId: '231000'
          },
          {
            id: '231085',
            label: '穆棱市',
            value: '231085',
            parentId: '231000'
          },
          {
            id: '231086',
            label: '东宁市',
            value: '231086',
            parentId: '231000'
          }
        ]
      },
      {
        id: '231100',
        label: '黑河市',
        value: '231100',
        parentId: '230000',
        children: [
          {
            id: '231102',
            label: '爱辉区',
            value: '231102',
            parentId: '231100'
          },
          {
            id: '231123',
            label: '逊克县',
            value: '231123',
            parentId: '231100'
          },
          {
            id: '231124',
            label: '孙吴县',
            value: '231124',
            parentId: '231100'
          },
          {
            id: '231181',
            label: '北安市',
            value: '231181',
            parentId: '231100'
          },
          {
            id: '231182',
            label: '五大连池市',
            value: '231182',
            parentId: '231100'
          },
          {
            id: '231183',
            label: '嫩江市',
            value: '231183',
            parentId: '231100'
          }
        ]
      },
      {
        id: '231200',
        label: '绥化市',
        value: '231200',
        parentId: '230000',
        children: [
          {
            id: '231202',
            label: '北林区',
            value: '231202',
            parentId: '231200'
          },
          {
            id: '231221',
            label: '望奎县',
            value: '231221',
            parentId: '231200'
          },
          {
            id: '231222',
            label: '兰西县',
            value: '231222',
            parentId: '231200'
          },
          {
            id: '231223',
            label: '青冈县',
            value: '231223',
            parentId: '231200'
          },
          {
            id: '231224',
            label: '庆安县',
            value: '231224',
            parentId: '231200'
          },
          {
            id: '231225',
            label: '明水县',
            value: '231225',
            parentId: '231200'
          },
          {
            id: '231226',
            label: '绥棱县',
            value: '231226',
            parentId: '231200'
          },
          {
            id: '231281',
            label: '安达市',
            value: '231281',
            parentId: '231200'
          },
          {
            id: '231282',
            label: '肇东市',
            value: '231282',
            parentId: '231200'
          },
          {
            id: '231283',
            label: '海伦市',
            value: '231283',
            parentId: '231200'
          }
        ]
      },
      {
        id: '232700',
        label: '大兴安岭地区',
        value: '232700',
        parentId: '230000',
        children: [
          {
            id: '232701',
            label: '漠河市',
            value: '232701',
            parentId: '232700'
          },
          {
            id: '232718',
            label: '加格达奇区',
            value: '232718',
            parentId: '232700'
          },
          {
            id: '232721',
            label: '呼玛县',
            value: '232721',
            parentId: '232700'
          },
          {
            id: '232722',
            label: '塔河县',
            value: '232722',
            parentId: '232700'
          }
        ]
      }
    ]
  },
  {
    id: '310000',
    label: '上海市',
    value: '310000',
    children: [
      {
        id: '310100',
        label: '上海市',
        value: '310100',
        parentId: '310000',
        children: [
          {
            id: '310101',
            label: '黄浦区',
            value: '310101',
            parentId: '310100'
          },
          {
            id: '310104',
            label: '徐汇区',
            value: '310104',
            parentId: '310100'
          },
          {
            id: '310105',
            label: '长宁区',
            value: '310105',
            parentId: '310100'
          },
          {
            id: '310106',
            label: '静安区',
            value: '310106',
            parentId: '310100'
          },
          {
            id: '310107',
            label: '普陀区',
            value: '310107',
            parentId: '310100'
          },
          {
            id: '310109',
            label: '虹口区',
            value: '310109',
            parentId: '310100'
          },
          {
            id: '310110',
            label: '杨浦区',
            value: '310110',
            parentId: '310100'
          },
          {
            id: '310112',
            label: '闵行区',
            value: '310112',
            parentId: '310100'
          },
          {
            id: '310113',
            label: '宝山区',
            value: '310113',
            parentId: '310100'
          },
          {
            id: '310114',
            label: '嘉定区',
            value: '310114',
            parentId: '310100'
          },
          {
            id: '310115',
            label: '浦东新区',
            value: '310115',
            parentId: '310100'
          },
          {
            id: '310116',
            label: '金山区',
            value: '310116',
            parentId: '310100'
          },
          {
            id: '310117',
            label: '松江区',
            value: '310117',
            parentId: '310100'
          },
          {
            id: '310118',
            label: '青浦区',
            value: '310118',
            parentId: '310100'
          },
          {
            id: '310120',
            label: '奉贤区',
            value: '310120',
            parentId: '310100'
          },
          {
            id: '310151',
            label: '崇明区',
            value: '310151',
            parentId: '310100'
          }
        ]
      }
    ]
  },
  {
    id: '320000',
    label: '江苏省',
    value: '320000',
    children: [
      {
        id: '320100',
        label: '南京市',
        value: '320100',
        parentId: '320000',
        children: [
          {
            id: '320102',
            label: '玄武区',
            value: '320102',
            parentId: '320100'
          },
          {
            id: '320104',
            label: '秦淮区',
            value: '320104',
            parentId: '320100'
          },
          {
            id: '320105',
            label: '建邺区',
            value: '320105',
            parentId: '320100'
          },
          {
            id: '320106',
            label: '鼓楼区',
            value: '320106',
            parentId: '320100'
          },
          {
            id: '320111',
            label: '浦口区',
            value: '320111',
            parentId: '320100'
          },
          {
            id: '320113',
            label: '栖霞区',
            value: '320113',
            parentId: '320100'
          },
          {
            id: '320114',
            label: '雨花台区',
            value: '320114',
            parentId: '320100'
          },
          {
            id: '320115',
            label: '江宁区',
            value: '320115',
            parentId: '320100'
          },
          {
            id: '320116',
            label: '六合区',
            value: '320116',
            parentId: '320100'
          },
          {
            id: '320117',
            label: '溧水区',
            value: '320117',
            parentId: '320100'
          },
          {
            id: '320118',
            label: '高淳区',
            value: '320118',
            parentId: '320100'
          }
        ]
      },
      {
        id: '320200',
        label: '无锡市',
        value: '320200',
        parentId: '320000',
        children: [
          {
            id: '320205',
            label: '锡山区',
            value: '320205',
            parentId: '320200'
          },
          {
            id: '320206',
            label: '惠山区',
            value: '320206',
            parentId: '320200'
          },
          {
            id: '320211',
            label: '滨湖区',
            value: '320211',
            parentId: '320200'
          },
          {
            id: '320213',
            label: '梁溪区',
            value: '320213',
            parentId: '320200'
          },
          {
            id: '320214',
            label: '新吴区',
            value: '320214',
            parentId: '320200'
          },
          {
            id: '320281',
            label: '江阴市',
            value: '320281',
            parentId: '320200'
          },
          {
            id: '320282',
            label: '宜兴市',
            value: '320282',
            parentId: '320200'
          },
          {
            id: '320283',
            label: '新区',
            value: '320283',
            parentId: '320200'
          }
        ]
      },
      {
        id: '320300',
        label: '徐州市',
        value: '320300',
        parentId: '320000',
        children: [
          {
            id: '320302',
            label: '鼓楼区',
            value: '320302',
            parentId: '320300'
          },
          {
            id: '320303',
            label: '云龙区',
            value: '320303',
            parentId: '320300'
          },
          {
            id: '320305',
            label: '贾汪区',
            value: '320305',
            parentId: '320300'
          },
          {
            id: '320311',
            label: '泉山区',
            value: '320311',
            parentId: '320300'
          },
          {
            id: '320312',
            label: '铜山区',
            value: '320312',
            parentId: '320300'
          },
          {
            id: '320321',
            label: '丰县',
            value: '320321',
            parentId: '320300'
          },
          {
            id: '320322',
            label: '沛县',
            value: '320322',
            parentId: '320300'
          },
          {
            id: '320324',
            label: '睢宁县',
            value: '320324',
            parentId: '320300'
          },
          {
            id: '320381',
            label: '新沂市',
            value: '320381',
            parentId: '320300'
          },
          {
            id: '320382',
            label: '邳州市',
            value: '320382',
            parentId: '320300'
          }
        ]
      },
      {
        id: '320400',
        label: '常州市',
        value: '320400',
        parentId: '320000',
        children: [
          {
            id: '320402',
            label: '天宁区',
            value: '320402',
            parentId: '320400'
          },
          {
            id: '320404',
            label: '钟楼区',
            value: '320404',
            parentId: '320400'
          },
          {
            id: '320411',
            label: '新北区',
            value: '320411',
            parentId: '320400'
          },
          {
            id: '320412',
            label: '武进区',
            value: '320412',
            parentId: '320400'
          },
          {
            id: '320413',
            label: '金坛区',
            value: '320413',
            parentId: '320400'
          },
          {
            id: '320481',
            label: '溧阳市',
            value: '320481',
            parentId: '320400'
          }
        ]
      },
      {
        id: '320500',
        label: '苏州市',
        value: '320500',
        parentId: '320000',
        children: [
          {
            id: '320505',
            label: '虎丘区',
            value: '320505',
            parentId: '320500'
          },
          {
            id: '320506',
            label: '吴中区',
            value: '320506',
            parentId: '320500'
          },
          {
            id: '320507',
            label: '相城区',
            value: '320507',
            parentId: '320500'
          },
          {
            id: '320508',
            label: '姑苏区',
            value: '320508',
            parentId: '320500'
          },
          {
            id: '320509',
            label: '吴江区',
            value: '320509',
            parentId: '320500'
          },
          {
            id: '320571',
            label: '苏州工业园区',
            value: '320571',
            parentId: '320500'
          },
          {
            id: '320581',
            label: '常熟市',
            value: '320581',
            parentId: '320500'
          },
          {
            id: '320582',
            label: '张家港市',
            value: '320582',
            parentId: '320500'
          },
          {
            id: '320583',
            label: '昆山市',
            value: '320583',
            parentId: '320500'
          },
          {
            id: '320585',
            label: '太仓市',
            value: '320585',
            parentId: '320500'
          }
        ]
      },
      {
        id: '320600',
        label: '南通市',
        value: '320600',
        parentId: '320000',
        children: [
          {
            id: '320612',
            label: '通州区',
            value: '320612',
            parentId: '320600'
          },
          {
            id: '320613',
            label: '崇川区',
            value: '320613',
            parentId: '320600'
          },
          {
            id: '320614',
            label: '海门区',
            value: '320614',
            parentId: '320600'
          },
          {
            id: '320623',
            label: '如东县',
            value: '320623',
            parentId: '320600'
          },
          {
            id: '320681',
            label: '启东市',
            value: '320681',
            parentId: '320600'
          },
          {
            id: '320682',
            label: '如皋市',
            value: '320682',
            parentId: '320600'
          },
          {
            id: '320685',
            label: '海安市',
            value: '320685',
            parentId: '320600'
          }
        ]
      },
      {
        id: '320700',
        label: '连云港市',
        value: '320700',
        parentId: '320000',
        children: [
          {
            id: '320703',
            label: '连云区',
            value: '320703',
            parentId: '320700'
          },
          {
            id: '320706',
            label: '海州区',
            value: '320706',
            parentId: '320700'
          },
          {
            id: '320707',
            label: '赣榆区',
            value: '320707',
            parentId: '320700'
          },
          {
            id: '320722',
            label: '东海县',
            value: '320722',
            parentId: '320700'
          },
          {
            id: '320723',
            label: '灌云县',
            value: '320723',
            parentId: '320700'
          },
          {
            id: '320724',
            label: '灌南县',
            value: '320724',
            parentId: '320700'
          }
        ]
      },
      {
        id: '320800',
        label: '淮安市',
        value: '320800',
        parentId: '320000',
        children: [
          {
            id: '320803',
            label: '淮安区',
            value: '320803',
            parentId: '320800'
          },
          {
            id: '320804',
            label: '淮阴区',
            value: '320804',
            parentId: '320800'
          },
          {
            id: '320812',
            label: '清江浦区',
            value: '320812',
            parentId: '320800'
          },
          {
            id: '320813',
            label: '洪泽区',
            value: '320813',
            parentId: '320800'
          },
          {
            id: '320826',
            label: '涟水县',
            value: '320826',
            parentId: '320800'
          },
          {
            id: '320830',
            label: '盱眙县',
            value: '320830',
            parentId: '320800'
          },
          {
            id: '320831',
            label: '金湖县',
            value: '320831',
            parentId: '320800'
          }
        ]
      },
      {
        id: '320900',
        label: '盐城市',
        value: '320900',
        parentId: '320000',
        children: [
          {
            id: '320902',
            label: '亭湖区',
            value: '320902',
            parentId: '320900'
          },
          {
            id: '320903',
            label: '盐都区',
            value: '320903',
            parentId: '320900'
          },
          {
            id: '320904',
            label: '大丰区',
            value: '320904',
            parentId: '320900'
          },
          {
            id: '320921',
            label: '响水县',
            value: '320921',
            parentId: '320900'
          },
          {
            id: '320922',
            label: '滨海县',
            value: '320922',
            parentId: '320900'
          },
          {
            id: '320923',
            label: '阜宁县',
            value: '320923',
            parentId: '320900'
          },
          {
            id: '320924',
            label: '射阳县',
            value: '320924',
            parentId: '320900'
          },
          {
            id: '320925',
            label: '建湖县',
            value: '320925',
            parentId: '320900'
          },
          {
            id: '320981',
            label: '东台市',
            value: '320981',
            parentId: '320900'
          }
        ]
      },
      {
        id: '321000',
        label: '扬州市',
        value: '321000',
        parentId: '320000',
        children: [
          {
            id: '321002',
            label: '广陵区',
            value: '321002',
            parentId: '321000'
          },
          {
            id: '321003',
            label: '邗江区',
            value: '321003',
            parentId: '321000'
          },
          {
            id: '321012',
            label: '江都区',
            value: '321012',
            parentId: '321000'
          },
          {
            id: '321023',
            label: '宝应县',
            value: '321023',
            parentId: '321000'
          },
          {
            id: '321081',
            label: '仪征市',
            value: '321081',
            parentId: '321000'
          },
          {
            id: '321084',
            label: '高邮市',
            value: '321084',
            parentId: '321000'
          }
        ]
      },
      {
        id: '321100',
        label: '镇江市',
        value: '321100',
        parentId: '320000',
        children: [
          {
            id: '321102',
            label: '京口区',
            value: '321102',
            parentId: '321100'
          },
          {
            id: '321111',
            label: '润州区',
            value: '321111',
            parentId: '321100'
          },
          {
            id: '321112',
            label: '丹徒区',
            value: '321112',
            parentId: '321100'
          },
          {
            id: '321181',
            label: '丹阳市',
            value: '321181',
            parentId: '321100'
          },
          {
            id: '321182',
            label: '扬中市',
            value: '321182',
            parentId: '321100'
          },
          {
            id: '321183',
            label: '句容市',
            value: '321183',
            parentId: '321100'
          }
        ]
      },
      {
        id: '321200',
        label: '泰州市',
        value: '321200',
        parentId: '320000',
        children: [
          {
            id: '321202',
            label: '海陵区',
            value: '321202',
            parentId: '321200'
          },
          {
            id: '321203',
            label: '高港区',
            value: '321203',
            parentId: '321200'
          },
          {
            id: '321204',
            label: '姜堰区',
            value: '321204',
            parentId: '321200'
          },
          {
            id: '321281',
            label: '兴化市',
            value: '321281',
            parentId: '321200'
          },
          {
            id: '321282',
            label: '靖江市',
            value: '321282',
            parentId: '321200'
          },
          {
            id: '321283',
            label: '泰兴市',
            value: '321283',
            parentId: '321200'
          }
        ]
      },
      {
        id: '321300',
        label: '宿迁市',
        value: '321300',
        parentId: '320000',
        children: [
          {
            id: '321302',
            label: '宿城区',
            value: '321302',
            parentId: '321300'
          },
          {
            id: '321311',
            label: '宿豫区',
            value: '321311',
            parentId: '321300'
          },
          {
            id: '321322',
            label: '沭阳县',
            value: '321322',
            parentId: '321300'
          },
          {
            id: '321323',
            label: '泗阳县',
            value: '321323',
            parentId: '321300'
          },
          {
            id: '321324',
            label: '泗洪县',
            value: '321324',
            parentId: '321300'
          }
        ]
      }
    ]
  },
  {
    id: '330000',
    label: '浙江省',
    value: '330000',
    children: [
      {
        id: '330100',
        label: '杭州市',
        value: '330100',
        parentId: '330000',
        children: [
          {
            id: '330102',
            label: '上城区',
            value: '330102',
            parentId: '330100'
          },
          {
            id: '330105',
            label: '拱墅区',
            value: '330105',
            parentId: '330100'
          },
          {
            id: '330106',
            label: '西湖区',
            value: '330106',
            parentId: '330100'
          },
          {
            id: '330108',
            label: '滨江区',
            value: '330108',
            parentId: '330100'
          },
          {
            id: '330109',
            label: '萧山区',
            value: '330109',
            parentId: '330100'
          },
          {
            id: '330110',
            label: '余杭区',
            value: '330110',
            parentId: '330100'
          },
          {
            id: '330111',
            label: '富阳区',
            value: '330111',
            parentId: '330100'
          },
          {
            id: '330112',
            label: '临安区',
            value: '330112',
            parentId: '330100'
          },
          {
            id: '330113',
            label: '临平区',
            value: '330113',
            parentId: '330100'
          },
          {
            id: '330114',
            label: '钱塘区',
            value: '330114',
            parentId: '330100'
          },
          {
            id: '330122',
            label: '桐庐县',
            value: '330122',
            parentId: '330100'
          },
          {
            id: '330127',
            label: '淳安县',
            value: '330127',
            parentId: '330100'
          },
          {
            id: '330182',
            label: '建德市',
            value: '330182',
            parentId: '330100'
          }
        ]
      },
      {
        id: '330200',
        label: '宁波市',
        value: '330200',
        parentId: '330000',
        children: [
          {
            id: '330203',
            label: '海曙区',
            value: '330203',
            parentId: '330200'
          },
          {
            id: '330205',
            label: '江北区',
            value: '330205',
            parentId: '330200'
          },
          {
            id: '330206',
            label: '北仑区',
            value: '330206',
            parentId: '330200'
          },
          {
            id: '330211',
            label: '镇海区',
            value: '330211',
            parentId: '330200'
          },
          {
            id: '330212',
            label: '鄞州区',
            value: '330212',
            parentId: '330200'
          },
          {
            id: '330213',
            label: '奉化区',
            value: '330213',
            parentId: '330200'
          },
          {
            id: '330225',
            label: '象山县',
            value: '330225',
            parentId: '330200'
          },
          {
            id: '330226',
            label: '宁海县',
            value: '330226',
            parentId: '330200'
          },
          {
            id: '330281',
            label: '余姚市',
            value: '330281',
            parentId: '330200'
          },
          {
            id: '330282',
            label: '慈溪市',
            value: '330282',
            parentId: '330200'
          }
        ]
      },
      {
        id: '330300',
        label: '温州市',
        value: '330300',
        parentId: '330000',
        children: [
          {
            id: '330302',
            label: '鹿城区',
            value: '330302',
            parentId: '330300'
          },
          {
            id: '330303',
            label: '龙湾区',
            value: '330303',
            parentId: '330300'
          },
          {
            id: '330304',
            label: '瓯海区',
            value: '330304',
            parentId: '330300'
          },
          {
            id: '330305',
            label: '洞头区',
            value: '330305',
            parentId: '330300'
          },
          {
            id: '330324',
            label: '永嘉县',
            value: '330324',
            parentId: '330300'
          },
          {
            id: '330326',
            label: '平阳县',
            value: '330326',
            parentId: '330300'
          },
          {
            id: '330327',
            label: '苍南县',
            value: '330327',
            parentId: '330300'
          },
          {
            id: '330328',
            label: '文成县',
            value: '330328',
            parentId: '330300'
          },
          {
            id: '330329',
            label: '泰顺县',
            value: '330329',
            parentId: '330300'
          },
          {
            id: '330381',
            label: '瑞安市',
            value: '330381',
            parentId: '330300'
          },
          {
            id: '330382',
            label: '乐清市',
            value: '330382',
            parentId: '330300'
          },
          {
            id: '330383',
            label: '龙港市',
            value: '330383',
            parentId: '330300'
          }
        ]
      },
      {
        id: '330400',
        label: '嘉兴市',
        value: '330400',
        parentId: '330000',
        children: [
          {
            id: '330402',
            label: '南湖区',
            value: '330402',
            parentId: '330400'
          },
          {
            id: '330411',
            label: '秀洲区',
            value: '330411',
            parentId: '330400'
          },
          {
            id: '330421',
            label: '嘉善县',
            value: '330421',
            parentId: '330400'
          },
          {
            id: '330424',
            label: '海盐县',
            value: '330424',
            parentId: '330400'
          },
          {
            id: '330481',
            label: '海宁市',
            value: '330481',
            parentId: '330400'
          },
          {
            id: '330482',
            label: '平湖市',
            value: '330482',
            parentId: '330400'
          },
          {
            id: '330483',
            label: '桐乡市',
            value: '330483',
            parentId: '330400'
          }
        ]
      },
      {
        id: '330500',
        label: '湖州市',
        value: '330500',
        parentId: '330000',
        children: [
          {
            id: '330502',
            label: '吴兴区',
            value: '330502',
            parentId: '330500'
          },
          {
            id: '330503',
            label: '南浔区',
            value: '330503',
            parentId: '330500'
          },
          {
            id: '330521',
            label: '德清县',
            value: '330521',
            parentId: '330500'
          },
          {
            id: '330522',
            label: '长兴县',
            value: '330522',
            parentId: '330500'
          },
          {
            id: '330523',
            label: '安吉县',
            value: '330523',
            parentId: '330500'
          }
        ]
      },
      {
        id: '330600',
        label: '绍兴市',
        value: '330600',
        parentId: '330000',
        children: [
          {
            id: '330602',
            label: '越城区',
            value: '330602',
            parentId: '330600'
          },
          {
            id: '330603',
            label: '柯桥区',
            value: '330603',
            parentId: '330600'
          },
          {
            id: '330604',
            label: '上虞区',
            value: '330604',
            parentId: '330600'
          },
          {
            id: '330624',
            label: '新昌县',
            value: '330624',
            parentId: '330600'
          },
          {
            id: '330681',
            label: '诸暨市',
            value: '330681',
            parentId: '330600'
          },
          {
            id: '330683',
            label: '嵊州市',
            value: '330683',
            parentId: '330600'
          }
        ]
      },
      {
        id: '330700',
        label: '金华市',
        value: '330700',
        parentId: '330000',
        children: [
          {
            id: '330702',
            label: '婺城区',
            value: '330702',
            parentId: '330700'
          },
          {
            id: '330703',
            label: '金东区',
            value: '330703',
            parentId: '330700'
          },
          {
            id: '330723',
            label: '武义县',
            value: '330723',
            parentId: '330700'
          },
          {
            id: '330726',
            label: '浦江县',
            value: '330726',
            parentId: '330700'
          },
          {
            id: '330727',
            label: '磐安县',
            value: '330727',
            parentId: '330700'
          },
          {
            id: '330781',
            label: '兰溪市',
            value: '330781',
            parentId: '330700'
          },
          {
            id: '330782',
            label: '义乌市',
            value: '330782',
            parentId: '330700'
          },
          {
            id: '330783',
            label: '东阳市',
            value: '330783',
            parentId: '330700'
          },
          {
            id: '330784',
            label: '永康市',
            value: '330784',
            parentId: '330700'
          }
        ]
      },
      {
        id: '330800',
        label: '衢州市',
        value: '330800',
        parentId: '330000',
        children: [
          {
            id: '330802',
            label: '柯城区',
            value: '330802',
            parentId: '330800'
          },
          {
            id: '330803',
            label: '衢江区',
            value: '330803',
            parentId: '330800'
          },
          {
            id: '330822',
            label: '常山县',
            value: '330822',
            parentId: '330800'
          },
          {
            id: '330824',
            label: '开化县',
            value: '330824',
            parentId: '330800'
          },
          {
            id: '330825',
            label: '龙游县',
            value: '330825',
            parentId: '330800'
          },
          {
            id: '330881',
            label: '江山市',
            value: '330881',
            parentId: '330800'
          }
        ]
      },
      {
        id: '330900',
        label: '舟山市',
        value: '330900',
        parentId: '330000',
        children: [
          {
            id: '330902',
            label: '定海区',
            value: '330902',
            parentId: '330900'
          },
          {
            id: '330903',
            label: '普陀区',
            value: '330903',
            parentId: '330900'
          },
          {
            id: '330921',
            label: '岱山县',
            value: '330921',
            parentId: '330900'
          },
          {
            id: '330922',
            label: '嵊泗县',
            value: '330922',
            parentId: '330900'
          }
        ]
      },
      {
        id: '331000',
        label: '台州市',
        value: '331000',
        parentId: '330000',
        children: [
          {
            id: '331002',
            label: '椒江区',
            value: '331002',
            parentId: '331000'
          },
          {
            id: '331003',
            label: '黄岩区',
            value: '331003',
            parentId: '331000'
          },
          {
            id: '331004',
            label: '路桥区',
            value: '331004',
            parentId: '331000'
          },
          {
            id: '331022',
            label: '三门县',
            value: '331022',
            parentId: '331000'
          },
          {
            id: '331023',
            label: '天台县',
            value: '331023',
            parentId: '331000'
          },
          {
            id: '331024',
            label: '仙居县',
            value: '331024',
            parentId: '331000'
          },
          {
            id: '331081',
            label: '温岭市',
            value: '331081',
            parentId: '331000'
          },
          {
            id: '331082',
            label: '临海市',
            value: '331082',
            parentId: '331000'
          },
          {
            id: '331083',
            label: '玉环市',
            value: '331083',
            parentId: '331000'
          }
        ]
      },
      {
        id: '331100',
        label: '丽水市',
        value: '331100',
        parentId: '330000',
        children: [
          {
            id: '331102',
            label: '莲都区',
            value: '331102',
            parentId: '331100'
          },
          {
            id: '331121',
            label: '青田县',
            value: '331121',
            parentId: '331100'
          },
          {
            id: '331122',
            label: '缙云县',
            value: '331122',
            parentId: '331100'
          },
          {
            id: '331123',
            label: '遂昌县',
            value: '331123',
            parentId: '331100'
          },
          {
            id: '331124',
            label: '松阳县',
            value: '331124',
            parentId: '331100'
          },
          {
            id: '331125',
            label: '云和县',
            value: '331125',
            parentId: '331100'
          },
          {
            id: '331126',
            label: '庆元县',
            value: '331126',
            parentId: '331100'
          },
          {
            id: '331127',
            label: '景宁畲族自治县',
            value: '331127',
            parentId: '331100'
          },
          {
            id: '331181',
            label: '龙泉市',
            value: '331181',
            parentId: '331100'
          }
        ]
      }
    ]
  },
  {
    id: '340000',
    label: '安徽省',
    value: '340000',
    children: [
      {
        id: '340100',
        label: '合肥市',
        value: '340100',
        parentId: '340000',
        children: [
          {
            id: '340102',
            label: '瑶海区',
            value: '340102',
            parentId: '340100'
          },
          {
            id: '340103',
            label: '庐阳区',
            value: '340103',
            parentId: '340100'
          },
          {
            id: '340104',
            label: '蜀山区',
            value: '340104',
            parentId: '340100'
          },
          {
            id: '340111',
            label: '包河区',
            value: '340111',
            parentId: '340100'
          },
          {
            id: '340121',
            label: '长丰县',
            value: '340121',
            parentId: '340100'
          },
          {
            id: '340122',
            label: '肥东县',
            value: '340122',
            parentId: '340100'
          },
          {
            id: '340123',
            label: '肥西县',
            value: '340123',
            parentId: '340100'
          },
          {
            id: '340124',
            label: '庐江县',
            value: '340124',
            parentId: '340100'
          },
          {
            id: '340181',
            label: '巢湖市',
            value: '340181',
            parentId: '340100'
          }
        ]
      },
      {
        id: '340200',
        label: '芜湖市',
        value: '340200',
        parentId: '340000',
        children: [
          {
            id: '340202',
            label: '镜湖区',
            value: '340202',
            parentId: '340200'
          },
          {
            id: '340207',
            label: '鸠江区',
            value: '340207',
            parentId: '340200'
          },
          {
            id: '340209',
            label: '弋江区',
            value: '340209',
            parentId: '340200'
          },
          {
            id: '340210',
            label: '湾沚区',
            value: '340210',
            parentId: '340200'
          },
          {
            id: '340212',
            label: '繁昌区',
            value: '340212',
            parentId: '340200'
          },
          {
            id: '340223',
            label: '南陵县',
            value: '340223',
            parentId: '340200'
          },
          {
            id: '340281',
            label: '无为市',
            value: '340281',
            parentId: '340200'
          }
        ]
      },
      {
        id: '340300',
        label: '蚌埠市',
        value: '340300',
        parentId: '340000',
        children: [
          {
            id: '340302',
            label: '龙子湖区',
            value: '340302',
            parentId: '340300'
          },
          {
            id: '340303',
            label: '蚌山区',
            value: '340303',
            parentId: '340300'
          },
          {
            id: '340304',
            label: '禹会区',
            value: '340304',
            parentId: '340300'
          },
          {
            id: '340311',
            label: '淮上区',
            value: '340311',
            parentId: '340300'
          },
          {
            id: '340321',
            label: '怀远县',
            value: '340321',
            parentId: '340300'
          },
          {
            id: '340322',
            label: '五河县',
            value: '340322',
            parentId: '340300'
          },
          {
            id: '340323',
            label: '固镇县',
            value: '340323',
            parentId: '340300'
          }
        ]
      },
      {
        id: '340400',
        label: '淮南市',
        value: '340400',
        parentId: '340000',
        children: [
          {
            id: '340402',
            label: '大通区',
            value: '340402',
            parentId: '340400'
          },
          {
            id: '340403',
            label: '田家庵区',
            value: '340403',
            parentId: '340400'
          },
          {
            id: '340404',
            label: '谢家集区',
            value: '340404',
            parentId: '340400'
          },
          {
            id: '340405',
            label: '八公山区',
            value: '340405',
            parentId: '340400'
          },
          {
            id: '340406',
            label: '潘集区',
            value: '340406',
            parentId: '340400'
          },
          {
            id: '340421',
            label: '凤台县',
            value: '340421',
            parentId: '340400'
          },
          {
            id: '340422',
            label: '寿县',
            value: '340422',
            parentId: '340400'
          }
        ]
      },
      {
        id: '340500',
        label: '马鞍山市',
        value: '340500',
        parentId: '340000',
        children: [
          {
            id: '340503',
            label: '花山区',
            value: '340503',
            parentId: '340500'
          },
          {
            id: '340504',
            label: '雨山区',
            value: '340504',
            parentId: '340500'
          },
          {
            id: '340506',
            label: '博望区',
            value: '340506',
            parentId: '340500'
          },
          {
            id: '340521',
            label: '当涂县',
            value: '340521',
            parentId: '340500'
          },
          {
            id: '340522',
            label: '含山县',
            value: '340522',
            parentId: '340500'
          },
          {
            id: '340523',
            label: '和县',
            value: '340523',
            parentId: '340500'
          }
        ]
      },
      {
        id: '340600',
        label: '淮北市',
        value: '340600',
        parentId: '340000',
        children: [
          {
            id: '340602',
            label: '杜集区',
            value: '340602',
            parentId: '340600'
          },
          {
            id: '340603',
            label: '相山区',
            value: '340603',
            parentId: '340600'
          },
          {
            id: '340604',
            label: '烈山区',
            value: '340604',
            parentId: '340600'
          },
          {
            id: '340621',
            label: '濉溪县',
            value: '340621',
            parentId: '340600'
          }
        ]
      },
      {
        id: '340700',
        label: '铜陵市',
        value: '340700',
        parentId: '340000',
        children: [
          {
            id: '340705',
            label: '铜官区',
            value: '340705',
            parentId: '340700'
          },
          {
            id: '340706',
            label: '义安区',
            value: '340706',
            parentId: '340700'
          },
          {
            id: '340711',
            label: '郊区',
            value: '340711',
            parentId: '340700'
          },
          {
            id: '340722',
            label: '枞阳县',
            value: '340722',
            parentId: '340700'
          }
        ]
      },
      {
        id: '340800',
        label: '安庆市',
        value: '340800',
        parentId: '340000',
        children: [
          {
            id: '340802',
            label: '迎江区',
            value: '340802',
            parentId: '340800'
          },
          {
            id: '340803',
            label: '大观区',
            value: '340803',
            parentId: '340800'
          },
          {
            id: '340811',
            label: '宜秀区',
            value: '340811',
            parentId: '340800'
          },
          {
            id: '340822',
            label: '怀宁县',
            value: '340822',
            parentId: '340800'
          },
          {
            id: '340825',
            label: '太湖县',
            value: '340825',
            parentId: '340800'
          },
          {
            id: '340826',
            label: '宿松县',
            value: '340826',
            parentId: '340800'
          },
          {
            id: '340827',
            label: '望江县',
            value: '340827',
            parentId: '340800'
          },
          {
            id: '340828',
            label: '岳西县',
            value: '340828',
            parentId: '340800'
          },
          {
            id: '340881',
            label: '桐城市',
            value: '340881',
            parentId: '340800'
          },
          {
            id: '340882',
            label: '潜山市',
            value: '340882',
            parentId: '340800'
          }
        ]
      },
      {
        id: '341000',
        label: '黄山市',
        value: '341000',
        parentId: '340000',
        children: [
          {
            id: '341002',
            label: '屯溪区',
            value: '341002',
            parentId: '341000'
          },
          {
            id: '341003',
            label: '黄山区',
            value: '341003',
            parentId: '341000'
          },
          {
            id: '341004',
            label: '徽州区',
            value: '341004',
            parentId: '341000'
          },
          {
            id: '341021',
            label: '歙县',
            value: '341021',
            parentId: '341000'
          },
          {
            id: '341022',
            label: '休宁县',
            value: '341022',
            parentId: '341000'
          },
          {
            id: '341023',
            label: '黟县',
            value: '341023',
            parentId: '341000'
          },
          {
            id: '341024',
            label: '祁门县',
            value: '341024',
            parentId: '341000'
          }
        ]
      },
      {
        id: '341100',
        label: '滁州市',
        value: '341100',
        parentId: '340000',
        children: [
          {
            id: '341102',
            label: '琅琊区',
            value: '341102',
            parentId: '341100'
          },
          {
            id: '341103',
            label: '南谯区',
            value: '341103',
            parentId: '341100'
          },
          {
            id: '341122',
            label: '来安县',
            value: '341122',
            parentId: '341100'
          },
          {
            id: '341124',
            label: '全椒县',
            value: '341124',
            parentId: '341100'
          },
          {
            id: '341125',
            label: '定远县',
            value: '341125',
            parentId: '341100'
          },
          {
            id: '341126',
            label: '凤阳县',
            value: '341126',
            parentId: '341100'
          },
          {
            id: '341181',
            label: '天长市',
            value: '341181',
            parentId: '341100'
          },
          {
            id: '341182',
            label: '明光市',
            value: '341182',
            parentId: '341100'
          }
        ]
      },
      {
        id: '341200',
        label: '阜阳市',
        value: '341200',
        parentId: '340000',
        children: [
          {
            id: '341202',
            label: '颍州区',
            value: '341202',
            parentId: '341200'
          },
          {
            id: '341203',
            label: '颍东区',
            value: '341203',
            parentId: '341200'
          },
          {
            id: '341204',
            label: '颍泉区',
            value: '341204',
            parentId: '341200'
          },
          {
            id: '341221',
            label: '临泉县',
            value: '341221',
            parentId: '341200'
          },
          {
            id: '341222',
            label: '太和县',
            value: '341222',
            parentId: '341200'
          },
          {
            id: '341225',
            label: '阜南县',
            value: '341225',
            parentId: '341200'
          },
          {
            id: '341226',
            label: '颍上县',
            value: '341226',
            parentId: '341200'
          },
          {
            id: '341282',
            label: '界首市',
            value: '341282',
            parentId: '341200'
          }
        ]
      },
      {
        id: '341300',
        label: '宿州市',
        value: '341300',
        parentId: '340000',
        children: [
          {
            id: '341302',
            label: '埇桥区',
            value: '341302',
            parentId: '341300'
          },
          {
            id: '341321',
            label: '砀山县',
            value: '341321',
            parentId: '341300'
          },
          {
            id: '341322',
            label: '萧县',
            value: '341322',
            parentId: '341300'
          },
          {
            id: '341323',
            label: '灵璧县',
            value: '341323',
            parentId: '341300'
          },
          {
            id: '341324',
            label: '泗县',
            value: '341324',
            parentId: '341300'
          }
        ]
      },
      {
        id: '341500',
        label: '六安市',
        value: '341500',
        parentId: '340000',
        children: [
          {
            id: '341502',
            label: '金安区',
            value: '341502',
            parentId: '341500'
          },
          {
            id: '341503',
            label: '裕安区',
            value: '341503',
            parentId: '341500'
          },
          {
            id: '341504',
            label: '叶集区',
            value: '341504',
            parentId: '341500'
          },
          {
            id: '341522',
            label: '霍邱县',
            value: '341522',
            parentId: '341500'
          },
          {
            id: '341523',
            label: '舒城县',
            value: '341523',
            parentId: '341500'
          },
          {
            id: '341524',
            label: '金寨县',
            value: '341524',
            parentId: '341500'
          },
          {
            id: '341525',
            label: '霍山县',
            value: '341525',
            parentId: '341500'
          }
        ]
      },
      {
        id: '341600',
        label: '亳州市',
        value: '341600',
        parentId: '340000',
        children: [
          {
            id: '341602',
            label: '谯城区',
            value: '341602',
            parentId: '341600'
          },
          {
            id: '341621',
            label: '涡阳县',
            value: '341621',
            parentId: '341600'
          },
          {
            id: '341622',
            label: '蒙城县',
            value: '341622',
            parentId: '341600'
          },
          {
            id: '341623',
            label: '利辛县',
            value: '341623',
            parentId: '341600'
          }
        ]
      },
      {
        id: '341700',
        label: '池州市',
        value: '341700',
        parentId: '340000',
        children: [
          {
            id: '341702',
            label: '贵池区',
            value: '341702',
            parentId: '341700'
          },
          {
            id: '341721',
            label: '东至县',
            value: '341721',
            parentId: '341700'
          },
          {
            id: '341722',
            label: '石台县',
            value: '341722',
            parentId: '341700'
          },
          {
            id: '341723',
            label: '青阳县',
            value: '341723',
            parentId: '341700'
          }
        ]
      },
      {
        id: '341800',
        label: '宣城市',
        value: '341800',
        parentId: '340000',
        children: [
          {
            id: '341802',
            label: '宣州区',
            value: '341802',
            parentId: '341800'
          },
          {
            id: '341821',
            label: '郎溪县',
            value: '341821',
            parentId: '341800'
          },
          {
            id: '341823',
            label: '泾县',
            value: '341823',
            parentId: '341800'
          },
          {
            id: '341824',
            label: '绩溪县',
            value: '341824',
            parentId: '341800'
          },
          {
            id: '341825',
            label: '旌德县',
            value: '341825',
            parentId: '341800'
          },
          {
            id: '341881',
            label: '宁国市',
            value: '341881',
            parentId: '341800'
          },
          {
            id: '341882',
            label: '广德市',
            value: '341882',
            parentId: '341800'
          }
        ]
      }
    ]
  },
  {
    id: '350000',
    label: '福建省',
    value: '350000',
    children: [
      {
        id: '350100',
        label: '福州市',
        value: '350100',
        parentId: '350000',
        children: [
          {
            id: '350102',
            label: '鼓楼区',
            value: '350102',
            parentId: '350100'
          },
          {
            id: '350103',
            label: '台江区',
            value: '350103',
            parentId: '350100'
          },
          {
            id: '350104',
            label: '仓山区',
            value: '350104',
            parentId: '350100'
          },
          {
            id: '350105',
            label: '马尾区',
            value: '350105',
            parentId: '350100'
          },
          {
            id: '350111',
            label: '晋安区',
            value: '350111',
            parentId: '350100'
          },
          {
            id: '350112',
            label: '长乐区',
            value: '350112',
            parentId: '350100'
          },
          {
            id: '350121',
            label: '闽侯县',
            value: '350121',
            parentId: '350100'
          },
          {
            id: '350122',
            label: '连江县',
            value: '350122',
            parentId: '350100'
          },
          {
            id: '350123',
            label: '罗源县',
            value: '350123',
            parentId: '350100'
          },
          {
            id: '350124',
            label: '闽清县',
            value: '350124',
            parentId: '350100'
          },
          {
            id: '350125',
            label: '永泰县',
            value: '350125',
            parentId: '350100'
          },
          {
            id: '350128',
            label: '平潭县',
            value: '350128',
            parentId: '350100'
          },
          {
            id: '350181',
            label: '福清市',
            value: '350181',
            parentId: '350100'
          }
        ]
      },
      {
        id: '350200',
        label: '厦门市',
        value: '350200',
        parentId: '350000',
        children: [
          {
            id: '350203',
            label: '思明区',
            value: '350203',
            parentId: '350200'
          },
          {
            id: '350205',
            label: '海沧区',
            value: '350205',
            parentId: '350200'
          },
          {
            id: '350206',
            label: '湖里区',
            value: '350206',
            parentId: '350200'
          },
          {
            id: '350211',
            label: '集美区',
            value: '350211',
            parentId: '350200'
          },
          {
            id: '350212',
            label: '同安区',
            value: '350212',
            parentId: '350200'
          },
          {
            id: '350213',
            label: '翔安区',
            value: '350213',
            parentId: '350200'
          }
        ]
      },
      {
        id: '350300',
        label: '莆田市',
        value: '350300',
        parentId: '350000',
        children: [
          {
            id: '350302',
            label: '城厢区',
            value: '350302',
            parentId: '350300'
          },
          {
            id: '350303',
            label: '涵江区',
            value: '350303',
            parentId: '350300'
          },
          {
            id: '350304',
            label: '荔城区',
            value: '350304',
            parentId: '350300'
          },
          {
            id: '350305',
            label: '秀屿区',
            value: '350305',
            parentId: '350300'
          },
          {
            id: '350322',
            label: '仙游县',
            value: '350322',
            parentId: '350300'
          }
        ]
      },
      {
        id: '350400',
        label: '三明市',
        value: '350400',
        parentId: '350000',
        children: [
          {
            id: '350402',
            label: '梅列区',
            value: '350402',
            parentId: '350400'
          },
          {
            id: '350403',
            label: '三元区',
            value: '350403',
            parentId: '350400'
          },
          {
            id: '350405',
            label: '沙县区',
            value: '350405',
            parentId: '350400'
          },
          {
            id: '350421',
            label: '明溪县',
            value: '350421',
            parentId: '350400'
          },
          {
            id: '350423',
            label: '清流县',
            value: '350423',
            parentId: '350400'
          },
          {
            id: '350424',
            label: '宁化县',
            value: '350424',
            parentId: '350400'
          },
          {
            id: '350425',
            label: '大田县',
            value: '350425',
            parentId: '350400'
          },
          {
            id: '350426',
            label: '尤溪县',
            value: '350426',
            parentId: '350400'
          },
          {
            id: '350428',
            label: '将乐县',
            value: '350428',
            parentId: '350400'
          },
          {
            id: '350429',
            label: '泰宁县',
            value: '350429',
            parentId: '350400'
          },
          {
            id: '350430',
            label: '建宁县',
            value: '350430',
            parentId: '350400'
          },
          {
            id: '350481',
            label: '永安市',
            value: '350481',
            parentId: '350400'
          }
        ]
      },
      {
        id: '350500',
        label: '泉州市',
        value: '350500',
        parentId: '350000',
        children: [
          {
            id: '350502',
            label: '鲤城区',
            value: '350502',
            parentId: '350500'
          },
          {
            id: '350503',
            label: '丰泽区',
            value: '350503',
            parentId: '350500'
          },
          {
            id: '350504',
            label: '洛江区',
            value: '350504',
            parentId: '350500'
          },
          {
            id: '350505',
            label: '泉港区',
            value: '350505',
            parentId: '350500'
          },
          {
            id: '350521',
            label: '惠安县',
            value: '350521',
            parentId: '350500'
          },
          {
            id: '350524',
            label: '安溪县',
            value: '350524',
            parentId: '350500'
          },
          {
            id: '350525',
            label: '永春县',
            value: '350525',
            parentId: '350500'
          },
          {
            id: '350526',
            label: '德化县',
            value: '350526',
            parentId: '350500'
          },
          {
            id: '350527',
            label: '金门县',
            value: '350527',
            parentId: '350500'
          },
          {
            id: '350581',
            label: '石狮市',
            value: '350581',
            parentId: '350500'
          },
          {
            id: '350582',
            label: '晋江市',
            value: '350582',
            parentId: '350500'
          },
          {
            id: '350583',
            label: '南安市',
            value: '350583',
            parentId: '350500'
          }
        ]
      },
      {
        id: '350600',
        label: '漳州市',
        value: '350600',
        parentId: '350000',
        children: [
          {
            id: '350602',
            label: '芗城区',
            value: '350602',
            parentId: '350600'
          },
          {
            id: '350603',
            label: '龙文区',
            value: '350603',
            parentId: '350600'
          },
          {
            id: '350604',
            label: '龙海区',
            value: '350604',
            parentId: '350600'
          },
          {
            id: '350605',
            label: '长泰区',
            value: '350605',
            parentId: '350600'
          },
          {
            id: '350622',
            label: '云霄县',
            value: '350622',
            parentId: '350600'
          },
          {
            id: '350623',
            label: '漳浦县',
            value: '350623',
            parentId: '350600'
          },
          {
            id: '350624',
            label: '诏安县',
            value: '350624',
            parentId: '350600'
          },
          {
            id: '350626',
            label: '东山县',
            value: '350626',
            parentId: '350600'
          },
          {
            id: '350627',
            label: '南靖县',
            value: '350627',
            parentId: '350600'
          },
          {
            id: '350628',
            label: '平和县',
            value: '350628',
            parentId: '350600'
          },
          {
            id: '350629',
            label: '华安县',
            value: '350629',
            parentId: '350600'
          }
        ]
      },
      {
        id: '350700',
        label: '南平市',
        value: '350700',
        parentId: '350000',
        children: [
          {
            id: '350702',
            label: '延平区',
            value: '350702',
            parentId: '350700'
          },
          {
            id: '350703',
            label: '建阳区',
            value: '350703',
            parentId: '350700'
          },
          {
            id: '350721',
            label: '顺昌县',
            value: '350721',
            parentId: '350700'
          },
          {
            id: '350722',
            label: '浦城县',
            value: '350722',
            parentId: '350700'
          },
          {
            id: '350723',
            label: '光泽县',
            value: '350723',
            parentId: '350700'
          },
          {
            id: '350724',
            label: '松溪县',
            value: '350724',
            parentId: '350700'
          },
          {
            id: '350725',
            label: '政和县',
            value: '350725',
            parentId: '350700'
          },
          {
            id: '350781',
            label: '邵武市',
            value: '350781',
            parentId: '350700'
          },
          {
            id: '350782',
            label: '武夷山市',
            value: '350782',
            parentId: '350700'
          },
          {
            id: '350783',
            label: '建瓯市',
            value: '350783',
            parentId: '350700'
          }
        ]
      },
      {
        id: '350800',
        label: '龙岩市',
        value: '350800',
        parentId: '350000',
        children: [
          {
            id: '350802',
            label: '新罗区',
            value: '350802',
            parentId: '350800'
          },
          {
            id: '350803',
            label: '永定区',
            value: '350803',
            parentId: '350800'
          },
          {
            id: '350821',
            label: '长汀县',
            value: '350821',
            parentId: '350800'
          },
          {
            id: '350823',
            label: '上杭县',
            value: '350823',
            parentId: '350800'
          },
          {
            id: '350824',
            label: '武平县',
            value: '350824',
            parentId: '350800'
          },
          {
            id: '350825',
            label: '连城县',
            value: '350825',
            parentId: '350800'
          },
          {
            id: '350881',
            label: '漳平市',
            value: '350881',
            parentId: '350800'
          }
        ]
      },
      {
        id: '350900',
        label: '宁德市',
        value: '350900',
        parentId: '350000',
        children: [
          {
            id: '350902',
            label: '蕉城区',
            value: '350902',
            parentId: '350900'
          },
          {
            id: '350921',
            label: '霞浦县',
            value: '350921',
            parentId: '350900'
          },
          {
            id: '350922',
            label: '古田县',
            value: '350922',
            parentId: '350900'
          },
          {
            id: '350923',
            label: '屏南县',
            value: '350923',
            parentId: '350900'
          },
          {
            id: '350924',
            label: '寿宁县',
            value: '350924',
            parentId: '350900'
          },
          {
            id: '350925',
            label: '周宁县',
            value: '350925',
            parentId: '350900'
          },
          {
            id: '350926',
            label: '柘荣县',
            value: '350926',
            parentId: '350900'
          },
          {
            id: '350981',
            label: '福安市',
            value: '350981',
            parentId: '350900'
          },
          {
            id: '350982',
            label: '福鼎市',
            value: '350982',
            parentId: '350900'
          }
        ]
      }
    ]
  },
  {
    id: '360000',
    label: '江西省',
    value: '360000',
    children: [
      {
        id: '360100',
        label: '南昌市',
        value: '360100',
        parentId: '360000',
        children: [
          {
            id: '360102',
            label: '东湖区',
            value: '360102',
            parentId: '360100'
          },
          {
            id: '360103',
            label: '西湖区',
            value: '360103',
            parentId: '360100'
          },
          {
            id: '360104',
            label: '青云谱区',
            value: '360104',
            parentId: '360100'
          },
          {
            id: '360111',
            label: '青山湖区',
            value: '360111',
            parentId: '360100'
          },
          {
            id: '360112',
            label: '新建区',
            value: '360112',
            parentId: '360100'
          },
          {
            id: '360113',
            label: '红谷滩区',
            value: '360113',
            parentId: '360100'
          },
          {
            id: '360121',
            label: '南昌县',
            value: '360121',
            parentId: '360100'
          },
          {
            id: '360123',
            label: '安义县',
            value: '360123',
            parentId: '360100'
          },
          {
            id: '360124',
            label: '进贤县',
            value: '360124',
            parentId: '360100'
          }
        ]
      },
      {
        id: '360200',
        label: '景德镇市',
        value: '360200',
        parentId: '360000',
        children: [
          {
            id: '360202',
            label: '昌江区',
            value: '360202',
            parentId: '360200'
          },
          {
            id: '360203',
            label: '珠山区',
            value: '360203',
            parentId: '360200'
          },
          {
            id: '360222',
            label: '浮梁县',
            value: '360222',
            parentId: '360200'
          },
          {
            id: '360281',
            label: '乐平市',
            value: '360281',
            parentId: '360200'
          }
        ]
      },
      {
        id: '360300',
        label: '萍乡市',
        value: '360300',
        parentId: '360000',
        children: [
          {
            id: '360302',
            label: '安源区',
            value: '360302',
            parentId: '360300'
          },
          {
            id: '360313',
            label: '湘东区',
            value: '360313',
            parentId: '360300'
          },
          {
            id: '360321',
            label: '莲花县',
            value: '360321',
            parentId: '360300'
          },
          {
            id: '360322',
            label: '上栗县',
            value: '360322',
            parentId: '360300'
          },
          {
            id: '360323',
            label: '芦溪县',
            value: '360323',
            parentId: '360300'
          }
        ]
      },
      {
        id: '360400',
        label: '九江市',
        value: '360400',
        parentId: '360000',
        children: [
          {
            id: '360402',
            label: '濂溪区',
            value: '360402',
            parentId: '360400'
          },
          {
            id: '360403',
            label: '浔阳区',
            value: '360403',
            parentId: '360400'
          },
          {
            id: '360404',
            label: '柴桑区',
            value: '360404',
            parentId: '360400'
          },
          {
            id: '360423',
            label: '武宁县',
            value: '360423',
            parentId: '360400'
          },
          {
            id: '360424',
            label: '修水县',
            value: '360424',
            parentId: '360400'
          },
          {
            id: '360425',
            label: '永修县',
            value: '360425',
            parentId: '360400'
          },
          {
            id: '360426',
            label: '德安县',
            value: '360426',
            parentId: '360400'
          },
          {
            id: '360428',
            label: '都昌县',
            value: '360428',
            parentId: '360400'
          },
          {
            id: '360429',
            label: '湖口县',
            value: '360429',
            parentId: '360400'
          },
          {
            id: '360430',
            label: '彭泽县',
            value: '360430',
            parentId: '360400'
          },
          {
            id: '360481',
            label: '瑞昌市',
            value: '360481',
            parentId: '360400'
          },
          {
            id: '360482',
            label: '共青城市',
            value: '360482',
            parentId: '360400'
          },
          {
            id: '360483',
            label: '庐山市',
            value: '360483',
            parentId: '360400'
          }
        ]
      },
      {
        id: '360500',
        label: '新余市',
        value: '360500',
        parentId: '360000',
        children: [
          {
            id: '360502',
            label: '渝水区',
            value: '360502',
            parentId: '360500'
          },
          {
            id: '360521',
            label: '分宜县',
            value: '360521',
            parentId: '360500'
          }
        ]
      },
      {
        id: '360600',
        label: '鹰潭市',
        value: '360600',
        parentId: '360000',
        children: [
          {
            id: '360602',
            label: '月湖区',
            value: '360602',
            parentId: '360600'
          },
          {
            id: '360603',
            label: '余江区',
            value: '360603',
            parentId: '360600'
          },
          {
            id: '360681',
            label: '贵溪市',
            value: '360681',
            parentId: '360600'
          }
        ]
      },
      {
        id: '360700',
        label: '赣州市',
        value: '360700',
        parentId: '360000',
        children: [
          {
            id: '360702',
            label: '章贡区',
            value: '360702',
            parentId: '360700'
          },
          {
            id: '360703',
            label: '南康区',
            value: '360703',
            parentId: '360700'
          },
          {
            id: '360704',
            label: '赣县区',
            value: '360704',
            parentId: '360700'
          },
          {
            id: '360722',
            label: '信丰县',
            value: '360722',
            parentId: '360700'
          },
          {
            id: '360723',
            label: '大余县',
            value: '360723',
            parentId: '360700'
          },
          {
            id: '360724',
            label: '上犹县',
            value: '360724',
            parentId: '360700'
          },
          {
            id: '360725',
            label: '崇义县',
            value: '360725',
            parentId: '360700'
          },
          {
            id: '360726',
            label: '安远县',
            value: '360726',
            parentId: '360700'
          },
          {
            id: '360728',
            label: '定南县',
            value: '360728',
            parentId: '360700'
          },
          {
            id: '360729',
            label: '全南县',
            value: '360729',
            parentId: '360700'
          },
          {
            id: '360730',
            label: '宁都县',
            value: '360730',
            parentId: '360700'
          },
          {
            id: '360731',
            label: '于都县',
            value: '360731',
            parentId: '360700'
          },
          {
            id: '360732',
            label: '兴国县',
            value: '360732',
            parentId: '360700'
          },
          {
            id: '360733',
            label: '会昌县',
            value: '360733',
            parentId: '360700'
          },
          {
            id: '360734',
            label: '寻乌县',
            value: '360734',
            parentId: '360700'
          },
          {
            id: '360735',
            label: '石城县',
            value: '360735',
            parentId: '360700'
          },
          {
            id: '360781',
            label: '瑞金市',
            value: '360781',
            parentId: '360700'
          },
          {
            id: '360783',
            label: '龙南市',
            value: '360783',
            parentId: '360700'
          }
        ]
      },
      {
        id: '360800',
        label: '吉安市',
        value: '360800',
        parentId: '360000',
        children: [
          {
            id: '360802',
            label: '吉州区',
            value: '360802',
            parentId: '360800'
          },
          {
            id: '360803',
            label: '青原区',
            value: '360803',
            parentId: '360800'
          },
          {
            id: '360821',
            label: '吉安县',
            value: '360821',
            parentId: '360800'
          },
          {
            id: '360822',
            label: '吉水县',
            value: '360822',
            parentId: '360800'
          },
          {
            id: '360823',
            label: '峡江县',
            value: '360823',
            parentId: '360800'
          },
          {
            id: '360824',
            label: '新干县',
            value: '360824',
            parentId: '360800'
          },
          {
            id: '360825',
            label: '永丰县',
            value: '360825',
            parentId: '360800'
          },
          {
            id: '360826',
            label: '泰和县',
            value: '360826',
            parentId: '360800'
          },
          {
            id: '360827',
            label: '遂川县',
            value: '360827',
            parentId: '360800'
          },
          {
            id: '360828',
            label: '万安县',
            value: '360828',
            parentId: '360800'
          },
          {
            id: '360829',
            label: '安福县',
            value: '360829',
            parentId: '360800'
          },
          {
            id: '360830',
            label: '永新县',
            value: '360830',
            parentId: '360800'
          },
          {
            id: '360881',
            label: '井冈山市',
            value: '360881',
            parentId: '360800'
          }
        ]
      },
      {
        id: '360900',
        label: '宜春市',
        value: '360900',
        parentId: '360000',
        children: [
          {
            id: '360902',
            label: '袁州区',
            value: '360902',
            parentId: '360900'
          },
          {
            id: '360921',
            label: '奉新县',
            value: '360921',
            parentId: '360900'
          },
          {
            id: '360922',
            label: '万载县',
            value: '360922',
            parentId: '360900'
          },
          {
            id: '360923',
            label: '上高县',
            value: '360923',
            parentId: '360900'
          },
          {
            id: '360924',
            label: '宜丰县',
            value: '360924',
            parentId: '360900'
          },
          {
            id: '360925',
            label: '靖安县',
            value: '360925',
            parentId: '360900'
          },
          {
            id: '360926',
            label: '铜鼓县',
            value: '360926',
            parentId: '360900'
          },
          {
            id: '360981',
            label: '丰城市',
            value: '360981',
            parentId: '360900'
          },
          {
            id: '360982',
            label: '樟树市',
            value: '360982',
            parentId: '360900'
          },
          {
            id: '360983',
            label: '高安市',
            value: '360983',
            parentId: '360900'
          }
        ]
      },
      {
        id: '361000',
        label: '抚州市',
        value: '361000',
        parentId: '360000',
        children: [
          {
            id: '361002',
            label: '临川区',
            value: '361002',
            parentId: '361000'
          },
          {
            id: '361003',
            label: '东乡区',
            value: '361003',
            parentId: '361000'
          },
          {
            id: '361021',
            label: '南城县',
            value: '361021',
            parentId: '361000'
          },
          {
            id: '361022',
            label: '黎川县',
            value: '361022',
            parentId: '361000'
          },
          {
            id: '361023',
            label: '南丰县',
            value: '361023',
            parentId: '361000'
          },
          {
            id: '361024',
            label: '崇仁县',
            value: '361024',
            parentId: '361000'
          },
          {
            id: '361025',
            label: '乐安县',
            value: '361025',
            parentId: '361000'
          },
          {
            id: '361026',
            label: '宜黄县',
            value: '361026',
            parentId: '361000'
          },
          {
            id: '361027',
            label: '金溪县',
            value: '361027',
            parentId: '361000'
          },
          {
            id: '361028',
            label: '资溪县',
            value: '361028',
            parentId: '361000'
          },
          {
            id: '361030',
            label: '广昌县',
            value: '361030',
            parentId: '361000'
          }
        ]
      },
      {
        id: '361100',
        label: '上饶市',
        value: '361100',
        parentId: '360000',
        children: [
          {
            id: '361102',
            label: '信州区',
            value: '361102',
            parentId: '361100'
          },
          {
            id: '361103',
            label: '广丰区',
            value: '361103',
            parentId: '361100'
          },
          {
            id: '361104',
            label: '广信区',
            value: '361104',
            parentId: '361100'
          },
          {
            id: '361123',
            label: '玉山县',
            value: '361123',
            parentId: '361100'
          },
          {
            id: '361124',
            label: '铅山县',
            value: '361124',
            parentId: '361100'
          },
          {
            id: '361125',
            label: '横峰县',
            value: '361125',
            parentId: '361100'
          },
          {
            id: '361126',
            label: '弋阳县',
            value: '361126',
            parentId: '361100'
          },
          {
            id: '361127',
            label: '余干县',
            value: '361127',
            parentId: '361100'
          },
          {
            id: '361128',
            label: '鄱阳县',
            value: '361128',
            parentId: '361100'
          },
          {
            id: '361129',
            label: '万年县',
            value: '361129',
            parentId: '361100'
          },
          {
            id: '361130',
            label: '婺源县',
            value: '361130',
            parentId: '361100'
          },
          {
            id: '361181',
            label: '德兴市',
            value: '361181',
            parentId: '361100'
          }
        ]
      }
    ]
  },
  {
    id: '370000',
    label: '山东省',
    value: '370000',
    children: [
      {
        id: '370100',
        label: '济南市',
        value: '370100',
        parentId: '370000',
        children: [
          {
            id: '370102',
            label: '历下区',
            value: '370102',
            parentId: '370100'
          },
          {
            id: '370103',
            label: '市中区',
            value: '370103',
            parentId: '370100'
          },
          {
            id: '370104',
            label: '槐荫区',
            value: '370104',
            parentId: '370100'
          },
          {
            id: '370105',
            label: '天桥区',
            value: '370105',
            parentId: '370100'
          },
          {
            id: '370112',
            label: '历城区',
            value: '370112',
            parentId: '370100'
          },
          {
            id: '370113',
            label: '长清区',
            value: '370113',
            parentId: '370100'
          },
          {
            id: '370114',
            label: '章丘区',
            value: '370114',
            parentId: '370100'
          },
          {
            id: '370115',
            label: '济阳区',
            value: '370115',
            parentId: '370100'
          },
          {
            id: '370116',
            label: '莱芜区',
            value: '370116',
            parentId: '370100'
          },
          {
            id: '370117',
            label: '钢城区',
            value: '370117',
            parentId: '370100'
          },
          {
            id: '370124',
            label: '平阴县',
            value: '370124',
            parentId: '370100'
          },
          {
            id: '370126',
            label: '商河县',
            value: '370126',
            parentId: '370100'
          },
          {
            id: '370127',
            label: '高新区',
            value: '370127',
            parentId: '370100'
          },
          {
            id: '370128',
            label: '自贸区',
            value: '370128',
            parentId: '370100'
          },
          {
            id: '370129',
            label: '南山区',
            value: '370129',
            parentId: '370100'
          }
        ]
      },
      {
        id: '370200',
        label: '青岛市',
        value: '370200',
        parentId: '370000',
        children: [
          {
            id: '370202',
            label: '市南区',
            value: '370202',
            parentId: '370200'
          },
          {
            id: '370203',
            label: '市北区',
            value: '370203',
            parentId: '370200'
          },
          {
            id: '370211',
            label: '黄岛区',
            value: '370211',
            parentId: '370200'
          },
          {
            id: '370212',
            label: '崂山区',
            value: '370212',
            parentId: '370200'
          },
          {
            id: '370213',
            label: '李沧区',
            value: '370213',
            parentId: '370200'
          },
          {
            id: '370214',
            label: '城阳区',
            value: '370214',
            parentId: '370200'
          },
          {
            id: '370215',
            label: '即墨区',
            value: '370215',
            parentId: '370200'
          },
          {
            id: '370281',
            label: '胶州市',
            value: '370281',
            parentId: '370200'
          },
          {
            id: '370283',
            label: '平度市',
            value: '370283',
            parentId: '370200'
          },
          {
            id: '370285',
            label: '莱西市',
            value: '370285',
            parentId: '370200'
          }
        ]
      },
      {
        id: '370300',
        label: '淄博市',
        value: '370300',
        parentId: '370000',
        children: [
          {
            id: '370302',
            label: '淄川区',
            value: '370302',
            parentId: '370300'
          },
          {
            id: '370303',
            label: '张店区',
            value: '370303',
            parentId: '370300'
          },
          {
            id: '370304',
            label: '博山区',
            value: '370304',
            parentId: '370300'
          },
          {
            id: '370305',
            label: '临淄区',
            value: '370305',
            parentId: '370300'
          },
          {
            id: '370306',
            label: '周村区',
            value: '370306',
            parentId: '370300'
          },
          {
            id: '370321',
            label: '桓台县',
            value: '370321',
            parentId: '370300'
          },
          {
            id: '370322',
            label: '高青县',
            value: '370322',
            parentId: '370300'
          },
          {
            id: '370323',
            label: '沂源县',
            value: '370323',
            parentId: '370300'
          }
        ]
      },
      {
        id: '370400',
        label: '枣庄市',
        value: '370400',
        parentId: '370000',
        children: [
          {
            id: '370402',
            label: '市中区',
            value: '370402',
            parentId: '370400'
          },
          {
            id: '370403',
            label: '薛城区',
            value: '370403',
            parentId: '370400'
          },
          {
            id: '370404',
            label: '峄城区',
            value: '370404',
            parentId: '370400'
          },
          {
            id: '370405',
            label: '台儿庄区',
            value: '370405',
            parentId: '370400'
          },
          {
            id: '370406',
            label: '山亭区',
            value: '370406',
            parentId: '370400'
          },
          {
            id: '370481',
            label: '滕州市',
            value: '370481',
            parentId: '370400'
          }
        ]
      },
      {
        id: '370500',
        label: '东营市',
        value: '370500',
        parentId: '370000',
        children: [
          {
            id: '370502',
            label: '东营区',
            value: '370502',
            parentId: '370500'
          },
          {
            id: '370503',
            label: '河口区',
            value: '370503',
            parentId: '370500'
          },
          {
            id: '370505',
            label: '垦利区',
            value: '370505',
            parentId: '370500'
          },
          {
            id: '370522',
            label: '利津县',
            value: '370522',
            parentId: '370500'
          },
          {
            id: '370523',
            label: '广饶县',
            value: '370523',
            parentId: '370500'
          }
        ]
      },
      {
        id: '370600',
        label: '烟台市',
        value: '370600',
        parentId: '370000',
        children: [
          {
            id: '370602',
            label: '芝罘区',
            value: '370602',
            parentId: '370600'
          },
          {
            id: '370611',
            label: '福山区',
            value: '370611',
            parentId: '370600'
          },
          {
            id: '370612',
            label: '牟平区',
            value: '370612',
            parentId: '370600'
          },
          {
            id: '370613',
            label: '莱山区',
            value: '370613',
            parentId: '370600'
          },
          {
            id: '370614',
            label: '蓬莱区',
            value: '370614',
            parentId: '370600'
          },
          {
            id: '370681',
            label: '龙口市',
            value: '370681',
            parentId: '370600'
          },
          {
            id: '370682',
            label: '莱阳市',
            value: '370682',
            parentId: '370600'
          },
          {
            id: '370683',
            label: '莱州市',
            value: '370683',
            parentId: '370600'
          },
          {
            id: '370685',
            label: '招远市',
            value: '370685',
            parentId: '370600'
          },
          {
            id: '370686',
            label: '栖霞市',
            value: '370686',
            parentId: '370600'
          },
          {
            id: '370687',
            label: '海阳市',
            value: '370687',
            parentId: '370600'
          }
        ]
      },
      {
        id: '370700',
        label: '潍坊市',
        value: '370700',
        parentId: '370000',
        children: [
          {
            id: '370702',
            label: '潍城区',
            value: '370702',
            parentId: '370700'
          },
          {
            id: '370703',
            label: '寒亭区',
            value: '370703',
            parentId: '370700'
          },
          {
            id: '370704',
            label: '坊子区',
            value: '370704',
            parentId: '370700'
          },
          {
            id: '370705',
            label: '奎文区',
            value: '370705',
            parentId: '370700'
          },
          {
            id: '370724',
            label: '临朐县',
            value: '370724',
            parentId: '370700'
          },
          {
            id: '370725',
            label: '昌乐县',
            value: '370725',
            parentId: '370700'
          },
          {
            id: '370781',
            label: '青州市',
            value: '370781',
            parentId: '370700'
          },
          {
            id: '370782',
            label: '诸城市',
            value: '370782',
            parentId: '370700'
          },
          {
            id: '370783',
            label: '寿光市',
            value: '370783',
            parentId: '370700'
          },
          {
            id: '370784',
            label: '安丘市',
            value: '370784',
            parentId: '370700'
          },
          {
            id: '370785',
            label: '高密市',
            value: '370785',
            parentId: '370700'
          },
          {
            id: '370786',
            label: '昌邑市',
            value: '370786',
            parentId: '370700'
          }
        ]
      },
      {
        id: '370800',
        label: '济宁市',
        value: '370800',
        parentId: '370000',
        children: [
          {
            id: '370811',
            label: '任城区',
            value: '370811',
            parentId: '370800'
          },
          {
            id: '370812',
            label: '兖州区',
            value: '370812',
            parentId: '370800'
          },
          {
            id: '370826',
            label: '微山县',
            value: '370826',
            parentId: '370800'
          },
          {
            id: '370827',
            label: '鱼台县',
            value: '370827',
            parentId: '370800'
          },
          {
            id: '370828',
            label: '金乡县',
            value: '370828',
            parentId: '370800'
          },
          {
            id: '370829',
            label: '嘉祥县',
            value: '370829',
            parentId: '370800'
          },
          {
            id: '370830',
            label: '汶上县',
            value: '370830',
            parentId: '370800'
          },
          {
            id: '370831',
            label: '泗水县',
            value: '370831',
            parentId: '370800'
          },
          {
            id: '370832',
            label: '梁山县',
            value: '370832',
            parentId: '370800'
          },
          {
            id: '370881',
            label: '曲阜市',
            value: '370881',
            parentId: '370800'
          },
          {
            id: '370883',
            label: '邹城市',
            value: '370883',
            parentId: '370800'
          }
        ]
      },
      {
        id: '370900',
        label: '泰安市',
        value: '370900',
        parentId: '370000',
        children: [
          {
            id: '370902',
            label: '泰山区',
            value: '370902',
            parentId: '370900'
          },
          {
            id: '370911',
            label: '岱岳区',
            value: '370911',
            parentId: '370900'
          },
          {
            id: '370921',
            label: '宁阳县',
            value: '370921',
            parentId: '370900'
          },
          {
            id: '370923',
            label: '东平县',
            value: '370923',
            parentId: '370900'
          },
          {
            id: '370982',
            label: '新泰市',
            value: '370982',
            parentId: '370900'
          },
          {
            id: '370983',
            label: '肥城市',
            value: '370983',
            parentId: '370900'
          }
        ]
      },
      {
        id: '371000',
        label: '威海市',
        value: '371000',
        parentId: '370000',
        children: [
          {
            id: '371002',
            label: '环翠区',
            value: '371002',
            parentId: '371000'
          },
          {
            id: '371003',
            label: '文登区',
            value: '371003',
            parentId: '371000'
          },
          {
            id: '371082',
            label: '荣成市',
            value: '371082',
            parentId: '371000'
          },
          {
            id: '371083',
            label: '乳山市',
            value: '371083',
            parentId: '371000'
          }
        ]
      },
      {
        id: '371100',
        label: '日照市',
        value: '371100',
        parentId: '370000',
        children: [
          {
            id: '371102',
            label: '东港区',
            value: '371102',
            parentId: '371100'
          },
          {
            id: '371103',
            label: '岚山区',
            value: '371103',
            parentId: '371100'
          },
          {
            id: '371121',
            label: '五莲县',
            value: '371121',
            parentId: '371100'
          },
          {
            id: '371122',
            label: '莒县',
            value: '371122',
            parentId: '371100'
          }
        ]
      },
      {
        id: '371300',
        label: '临沂市',
        value: '371300',
        parentId: '370000',
        children: [
          {
            id: '371302',
            label: '兰山区',
            value: '371302',
            parentId: '371300'
          },
          {
            id: '371311',
            label: '罗庄区',
            value: '371311',
            parentId: '371300'
          },
          {
            id: '371312',
            label: '河东区',
            value: '371312',
            parentId: '371300'
          },
          {
            id: '371321',
            label: '沂南县',
            value: '371321',
            parentId: '371300'
          },
          {
            id: '371322',
            label: '郯城县',
            value: '371322',
            parentId: '371300'
          },
          {
            id: '371323',
            label: '沂水县',
            value: '371323',
            parentId: '371300'
          },
          {
            id: '371324',
            label: '兰陵县',
            value: '371324',
            parentId: '371300'
          },
          {
            id: '371325',
            label: '费县',
            value: '371325',
            parentId: '371300'
          },
          {
            id: '371326',
            label: '平邑县',
            value: '371326',
            parentId: '371300'
          },
          {
            id: '371327',
            label: '莒南县',
            value: '371327',
            parentId: '371300'
          },
          {
            id: '371328',
            label: '蒙阴县',
            value: '371328',
            parentId: '371300'
          },
          {
            id: '371329',
            label: '临沭县',
            value: '371329',
            parentId: '371300'
          }
        ]
      },
      {
        id: '371400',
        label: '德州市',
        value: '371400',
        parentId: '370000',
        children: [
          {
            id: '371402',
            label: '德城区',
            value: '371402',
            parentId: '371400'
          },
          {
            id: '371403',
            label: '陵城区',
            value: '371403',
            parentId: '371400'
          },
          {
            id: '371422',
            label: '宁津县',
            value: '371422',
            parentId: '371400'
          },
          {
            id: '371423',
            label: '庆云县',
            value: '371423',
            parentId: '371400'
          },
          {
            id: '371424',
            label: '临邑县',
            value: '371424',
            parentId: '371400'
          },
          {
            id: '371425',
            label: '齐河县',
            value: '371425',
            parentId: '371400'
          },
          {
            id: '371426',
            label: '平原县',
            value: '371426',
            parentId: '371400'
          },
          {
            id: '371427',
            label: '夏津县',
            value: '371427',
            parentId: '371400'
          },
          {
            id: '371428',
            label: '武城县',
            value: '371428',
            parentId: '371400'
          },
          {
            id: '371481',
            label: '乐陵市',
            value: '371481',
            parentId: '371400'
          },
          {
            id: '371482',
            label: '禹城市',
            value: '371482',
            parentId: '371400'
          }
        ]
      },
      {
        id: '371500',
        label: '聊城市',
        value: '371500',
        parentId: '370000',
        children: [
          {
            id: '371502',
            label: '东昌府区',
            value: '371502',
            parentId: '371500'
          },
          {
            id: '371503',
            label: '茌平区',
            value: '371503',
            parentId: '371500'
          },
          {
            id: '371521',
            label: '阳谷县',
            value: '371521',
            parentId: '371500'
          },
          {
            id: '371522',
            label: '莘县',
            value: '371522',
            parentId: '371500'
          },
          {
            id: '371524',
            label: '东阿县',
            value: '371524',
            parentId: '371500'
          },
          {
            id: '371525',
            label: '冠县',
            value: '371525',
            parentId: '371500'
          },
          {
            id: '371526',
            label: '高唐县',
            value: '371526',
            parentId: '371500'
          },
          {
            id: '371581',
            label: '临清市',
            value: '371581',
            parentId: '371500'
          }
        ]
      },
      {
        id: '371600',
        label: '滨州市',
        value: '371600',
        parentId: '370000',
        children: [
          {
            id: '371602',
            label: '滨城区',
            value: '371602',
            parentId: '371600'
          },
          {
            id: '371603',
            label: '沾化区',
            value: '371603',
            parentId: '371600'
          },
          {
            id: '371621',
            label: '惠民县',
            value: '371621',
            parentId: '371600'
          },
          {
            id: '371622',
            label: '阳信县',
            value: '371622',
            parentId: '371600'
          },
          {
            id: '371623',
            label: '无棣县',
            value: '371623',
            parentId: '371600'
          },
          {
            id: '371625',
            label: '博兴县',
            value: '371625',
            parentId: '371600'
          },
          {
            id: '371681',
            label: '邹平市',
            value: '371681',
            parentId: '371600'
          }
        ]
      },
      {
        id: '371700',
        label: '菏泽市',
        value: '371700',
        parentId: '370000',
        children: [
          {
            id: '371702',
            label: '牡丹区',
            value: '371702',
            parentId: '371700'
          },
          {
            id: '371703',
            label: '定陶区',
            value: '371703',
            parentId: '371700'
          },
          {
            id: '371721',
            label: '曹县',
            value: '371721',
            parentId: '371700'
          },
          {
            id: '371722',
            label: '单县',
            value: '371722',
            parentId: '371700'
          },
          {
            id: '371723',
            label: '成武县',
            value: '371723',
            parentId: '371700'
          },
          {
            id: '371724',
            label: '巨野县',
            value: '371724',
            parentId: '371700'
          },
          {
            id: '371725',
            label: '郓城县',
            value: '371725',
            parentId: '371700'
          },
          {
            id: '371726',
            label: '鄄城县',
            value: '371726',
            parentId: '371700'
          },
          {
            id: '371728',
            label: '东明县',
            value: '371728',
            parentId: '371700'
          }
        ]
      }
    ]
  },
  {
    id: '410000',
    label: '河南省',
    value: '410000',
    children: [
      {
        id: '410100',
        label: '郑州市',
        value: '410100',
        parentId: '410000',
        children: [
          {
            id: '410102',
            label: '中原区',
            value: '410102',
            parentId: '410100'
          },
          {
            id: '410103',
            label: '二七区',
            value: '410103',
            parentId: '410100'
          },
          {
            id: '410104',
            label: '管城回族区',
            value: '410104',
            parentId: '410100'
          },
          {
            id: '410105',
            label: '金水区',
            value: '410105',
            parentId: '410100'
          },
          {
            id: '410106',
            label: '上街区',
            value: '410106',
            parentId: '410100'
          },
          {
            id: '410108',
            label: '惠济区',
            value: '410108',
            parentId: '410100'
          },
          {
            id: '410122',
            label: '中牟县',
            value: '410122',
            parentId: '410100'
          },
          {
            id: '410181',
            label: '巩义市',
            value: '410181',
            parentId: '410100'
          },
          {
            id: '410182',
            label: '荥阳市',
            value: '410182',
            parentId: '410100'
          },
          {
            id: '410183',
            label: '新密市',
            value: '410183',
            parentId: '410100'
          },
          {
            id: '410184',
            label: '新郑市',
            value: '410184',
            parentId: '410100'
          },
          {
            id: '410185',
            label: '登封市',
            value: '410185',
            parentId: '410100'
          }
        ]
      },
      {
        id: '410200',
        label: '开封市',
        value: '410200',
        parentId: '410000',
        children: [
          {
            id: '410202',
            label: '龙亭区',
            value: '410202',
            parentId: '410200'
          },
          {
            id: '410203',
            label: '顺河回族区',
            value: '410203',
            parentId: '410200'
          },
          {
            id: '410204',
            label: '鼓楼区',
            value: '410204',
            parentId: '410200'
          },
          {
            id: '410205',
            label: '禹王台区',
            value: '410205',
            parentId: '410200'
          },
          {
            id: '410212',
            label: '祥符区',
            value: '410212',
            parentId: '410200'
          },
          {
            id: '410221',
            label: '杞县',
            value: '410221',
            parentId: '410200'
          },
          {
            id: '410222',
            label: '通许县',
            value: '410222',
            parentId: '410200'
          },
          {
            id: '410223',
            label: '尉氏县',
            value: '410223',
            parentId: '410200'
          },
          {
            id: '410225',
            label: '兰考县',
            value: '410225',
            parentId: '410200'
          }
        ]
      },
      {
        id: '410300',
        label: '洛阳市',
        value: '410300',
        parentId: '410000',
        children: [
          {
            id: '410302',
            label: '老城区',
            value: '410302',
            parentId: '410300'
          },
          {
            id: '410303',
            label: '西工区',
            value: '410303',
            parentId: '410300'
          },
          {
            id: '410304',
            label: '瀍河回族区',
            value: '410304',
            parentId: '410300'
          },
          {
            id: '410305',
            label: '涧西区',
            value: '410305',
            parentId: '410300'
          },
          {
            id: '410307',
            label: '偃师区',
            value: '410307',
            parentId: '410300'
          },
          {
            id: '410308',
            label: '孟津区',
            value: '410308',
            parentId: '410300'
          },
          {
            id: '410311',
            label: '洛龙区',
            value: '410311',
            parentId: '410300'
          },
          {
            id: '410323',
            label: '新安县',
            value: '410323',
            parentId: '410300'
          },
          {
            id: '410324',
            label: '栾川县',
            value: '410324',
            parentId: '410300'
          },
          {
            id: '410325',
            label: '嵩县',
            value: '410325',
            parentId: '410300'
          },
          {
            id: '410326',
            label: '汝阳县',
            value: '410326',
            parentId: '410300'
          },
          {
            id: '410327',
            label: '宜阳县',
            value: '410327',
            parentId: '410300'
          },
          {
            id: '410328',
            label: '洛宁县',
            value: '410328',
            parentId: '410300'
          },
          {
            id: '410329',
            label: '伊川县',
            value: '410329',
            parentId: '410300'
          }
        ]
      },
      {
        id: '410400',
        label: '平顶山市',
        value: '410400',
        parentId: '410000',
        children: [
          {
            id: '410402',
            label: '新华区',
            value: '410402',
            parentId: '410400'
          },
          {
            id: '410403',
            label: '卫东区',
            value: '410403',
            parentId: '410400'
          },
          {
            id: '410404',
            label: '石龙区',
            value: '410404',
            parentId: '410400'
          },
          {
            id: '410411',
            label: '湛河区',
            value: '410411',
            parentId: '410400'
          },
          {
            id: '410421',
            label: '宝丰县',
            value: '410421',
            parentId: '410400'
          },
          {
            id: '410422',
            label: '叶县',
            value: '410422',
            parentId: '410400'
          },
          {
            id: '410423',
            label: '鲁山县',
            value: '410423',
            parentId: '410400'
          },
          {
            id: '410425',
            label: '郏县',
            value: '410425',
            parentId: '410400'
          },
          {
            id: '410481',
            label: '舞钢市',
            value: '410481',
            parentId: '410400'
          },
          {
            id: '410482',
            label: '汝州市',
            value: '410482',
            parentId: '410400'
          }
        ]
      },
      {
        id: '410500',
        label: '安阳市',
        value: '410500',
        parentId: '410000',
        children: [
          {
            id: '410502',
            label: '文峰区',
            value: '410502',
            parentId: '410500'
          },
          {
            id: '410503',
            label: '北关区',
            value: '410503',
            parentId: '410500'
          },
          {
            id: '410505',
            label: '殷都区',
            value: '410505',
            parentId: '410500'
          },
          {
            id: '410506',
            label: '龙安区',
            value: '410506',
            parentId: '410500'
          },
          {
            id: '410522',
            label: '安阳县',
            value: '410522',
            parentId: '410500'
          },
          {
            id: '410523',
            label: '汤阴县',
            value: '410523',
            parentId: '410500'
          },
          {
            id: '410526',
            label: '滑县',
            value: '410526',
            parentId: '410500'
          },
          {
            id: '410527',
            label: '内黄县',
            value: '410527',
            parentId: '410500'
          },
          {
            id: '410581',
            label: '林州市',
            value: '410581',
            parentId: '410500'
          }
        ]
      },
      {
        id: '410600',
        label: '鹤壁市',
        value: '410600',
        parentId: '410000',
        children: [
          {
            id: '410602',
            label: '鹤山区',
            value: '410602',
            parentId: '410600'
          },
          {
            id: '410603',
            label: '山城区',
            value: '410603',
            parentId: '410600'
          },
          {
            id: '410611',
            label: '淇滨区',
            value: '410611',
            parentId: '410600'
          },
          {
            id: '410621',
            label: '浚县',
            value: '410621',
            parentId: '410600'
          },
          {
            id: '410622',
            label: '淇县',
            value: '410622',
            parentId: '410600'
          }
        ]
      },
      {
        id: '410700',
        label: '新乡市',
        value: '410700',
        parentId: '410000',
        children: [
          {
            id: '410702',
            label: '红旗区',
            value: '410702',
            parentId: '410700'
          },
          {
            id: '410703',
            label: '卫滨区',
            value: '410703',
            parentId: '410700'
          },
          {
            id: '410704',
            label: '凤泉区',
            value: '410704',
            parentId: '410700'
          },
          {
            id: '410711',
            label: '牧野区',
            value: '410711',
            parentId: '410700'
          },
          {
            id: '410721',
            label: '新乡县',
            value: '410721',
            parentId: '410700'
          },
          {
            id: '410724',
            label: '获嘉县',
            value: '410724',
            parentId: '410700'
          },
          {
            id: '410725',
            label: '原阳县',
            value: '410725',
            parentId: '410700'
          },
          {
            id: '410726',
            label: '延津县',
            value: '410726',
            parentId: '410700'
          },
          {
            id: '410727',
            label: '封丘县',
            value: '410727',
            parentId: '410700'
          },
          {
            id: '410781',
            label: '卫辉市',
            value: '410781',
            parentId: '410700'
          },
          {
            id: '410782',
            label: '辉县市',
            value: '410782',
            parentId: '410700'
          },
          {
            id: '410783',
            label: '长垣市',
            value: '410783',
            parentId: '410700'
          }
        ]
      },
      {
        id: '410800',
        label: '焦作市',
        value: '410800',
        parentId: '410000',
        children: [
          {
            id: '410802',
            label: '解放区',
            value: '410802',
            parentId: '410800'
          },
          {
            id: '410803',
            label: '中站区',
            value: '410803',
            parentId: '410800'
          },
          {
            id: '410804',
            label: '马村区',
            value: '410804',
            parentId: '410800'
          },
          {
            id: '410811',
            label: '山阳区',
            value: '410811',
            parentId: '410800'
          },
          {
            id: '410821',
            label: '修武县',
            value: '410821',
            parentId: '410800'
          },
          {
            id: '410822',
            label: '博爱县',
            value: '410822',
            parentId: '410800'
          },
          {
            id: '410823',
            label: '武陟县',
            value: '410823',
            parentId: '410800'
          },
          {
            id: '410825',
            label: '温县',
            value: '410825',
            parentId: '410800'
          },
          {
            id: '410882',
            label: '沁阳市',
            value: '410882',
            parentId: '410800'
          },
          {
            id: '410883',
            label: '孟州市',
            value: '410883',
            parentId: '410800'
          }
        ]
      },
      {
        id: '410900',
        label: '濮阳市',
        value: '410900',
        parentId: '410000',
        children: [
          {
            id: '410902',
            label: '华龙区',
            value: '410902',
            parentId: '410900'
          },
          {
            id: '410922',
            label: '清丰县',
            value: '410922',
            parentId: '410900'
          },
          {
            id: '410923',
            label: '南乐县',
            value: '410923',
            parentId: '410900'
          },
          {
            id: '410926',
            label: '范县',
            value: '410926',
            parentId: '410900'
          },
          {
            id: '410927',
            label: '台前县',
            value: '410927',
            parentId: '410900'
          },
          {
            id: '410928',
            label: '濮阳县',
            value: '410928',
            parentId: '410900'
          }
        ]
      },
      {
        id: '411000',
        label: '许昌市',
        value: '411000',
        parentId: '410000',
        children: [
          {
            id: '411002',
            label: '魏都区',
            value: '411002',
            parentId: '411000'
          },
          {
            id: '411003',
            label: '建安区',
            value: '411003',
            parentId: '411000'
          },
          {
            id: '411024',
            label: '鄢陵县',
            value: '411024',
            parentId: '411000'
          },
          {
            id: '411025',
            label: '襄城县',
            value: '411025',
            parentId: '411000'
          },
          {
            id: '411081',
            label: '禹州市',
            value: '411081',
            parentId: '411000'
          },
          {
            id: '411082',
            label: '长葛市',
            value: '411082',
            parentId: '411000'
          }
        ]
      },
      {
        id: '411100',
        label: '漯河市',
        value: '411100',
        parentId: '410000',
        children: [
          {
            id: '411102',
            label: '源汇区',
            value: '411102',
            parentId: '411100'
          },
          {
            id: '411103',
            label: '郾城区',
            value: '411103',
            parentId: '411100'
          },
          {
            id: '411104',
            label: '召陵区',
            value: '411104',
            parentId: '411100'
          },
          {
            id: '411121',
            label: '舞阳县',
            value: '411121',
            parentId: '411100'
          },
          {
            id: '411122',
            label: '临颍县',
            value: '411122',
            parentId: '411100'
          }
        ]
      },
      {
        id: '411200',
        label: '三门峡市',
        value: '411200',
        parentId: '410000',
        children: [
          {
            id: '411202',
            label: '湖滨区',
            value: '411202',
            parentId: '411200'
          },
          {
            id: '411203',
            label: '陕州区',
            value: '411203',
            parentId: '411200'
          },
          {
            id: '411221',
            label: '渑池县',
            value: '411221',
            parentId: '411200'
          },
          {
            id: '411224',
            label: '卢氏县',
            value: '411224',
            parentId: '411200'
          },
          {
            id: '411281',
            label: '义马市',
            value: '411281',
            parentId: '411200'
          },
          {
            id: '411282',
            label: '灵宝市',
            value: '411282',
            parentId: '411200'
          }
        ]
      },
      {
        id: '411300',
        label: '南阳市',
        value: '411300',
        parentId: '410000',
        children: [
          {
            id: '411302',
            label: '宛城区',
            value: '411302',
            parentId: '411300'
          },
          {
            id: '411303',
            label: '卧龙区',
            value: '411303',
            parentId: '411300'
          },
          {
            id: '411321',
            label: '南召县',
            value: '411321',
            parentId: '411300'
          },
          {
            id: '411322',
            label: '方城县',
            value: '411322',
            parentId: '411300'
          },
          {
            id: '411323',
            label: '西峡县',
            value: '411323',
            parentId: '411300'
          },
          {
            id: '411324',
            label: '镇平县',
            value: '411324',
            parentId: '411300'
          },
          {
            id: '411325',
            label: '内乡县',
            value: '411325',
            parentId: '411300'
          },
          {
            id: '411326',
            label: '淅川县',
            value: '411326',
            parentId: '411300'
          },
          {
            id: '411327',
            label: '社旗县',
            value: '411327',
            parentId: '411300'
          },
          {
            id: '411328',
            label: '唐河县',
            value: '411328',
            parentId: '411300'
          },
          {
            id: '411329',
            label: '新野县',
            value: '411329',
            parentId: '411300'
          },
          {
            id: '411330',
            label: '桐柏县',
            value: '411330',
            parentId: '411300'
          },
          {
            id: '411381',
            label: '邓州市',
            value: '411381',
            parentId: '411300'
          }
        ]
      },
      {
        id: '411400',
        label: '商丘市',
        value: '411400',
        parentId: '410000',
        children: [
          {
            id: '411402',
            label: '梁园区',
            value: '411402',
            parentId: '411400'
          },
          {
            id: '411403',
            label: '睢阳区',
            value: '411403',
            parentId: '411400'
          },
          {
            id: '411421',
            label: '民权县',
            value: '411421',
            parentId: '411400'
          },
          {
            id: '411422',
            label: '睢县',
            value: '411422',
            parentId: '411400'
          },
          {
            id: '411423',
            label: '宁陵县',
            value: '411423',
            parentId: '411400'
          },
          {
            id: '411424',
            label: '柘城县',
            value: '411424',
            parentId: '411400'
          },
          {
            id: '411425',
            label: '虞城县',
            value: '411425',
            parentId: '411400'
          },
          {
            id: '411426',
            label: '夏邑县',
            value: '411426',
            parentId: '411400'
          },
          {
            id: '411481',
            label: '永城市',
            value: '411481',
            parentId: '411400'
          }
        ]
      },
      {
        id: '411500',
        label: '信阳市',
        value: '411500',
        parentId: '410000',
        children: [
          {
            id: '411502',
            label: '浉河区',
            value: '411502',
            parentId: '411500'
          },
          {
            id: '411503',
            label: '平桥区',
            value: '411503',
            parentId: '411500'
          },
          {
            id: '411521',
            label: '罗山县',
            value: '411521',
            parentId: '411500'
          },
          {
            id: '411522',
            label: '光山县',
            value: '411522',
            parentId: '411500'
          },
          {
            id: '411523',
            label: '新县',
            value: '411523',
            parentId: '411500'
          },
          {
            id: '411524',
            label: '商城县',
            value: '411524',
            parentId: '411500'
          },
          {
            id: '411525',
            label: '固始县',
            value: '411525',
            parentId: '411500'
          },
          {
            id: '411526',
            label: '潢川县',
            value: '411526',
            parentId: '411500'
          },
          {
            id: '411527',
            label: '淮滨县',
            value: '411527',
            parentId: '411500'
          },
          {
            id: '411528',
            label: '息县',
            value: '411528',
            parentId: '411500'
          }
        ]
      },
      {
        id: '411600',
        label: '周口市',
        value: '411600',
        parentId: '410000',
        children: [
          {
            id: '411602',
            label: '川汇区',
            value: '411602',
            parentId: '411600'
          },
          {
            id: '411603',
            label: '淮阳区',
            value: '411603',
            parentId: '411600'
          },
          {
            id: '411621',
            label: '扶沟县',
            value: '411621',
            parentId: '411600'
          },
          {
            id: '411622',
            label: '西华县',
            value: '411622',
            parentId: '411600'
          },
          {
            id: '411623',
            label: '商水县',
            value: '411623',
            parentId: '411600'
          },
          {
            id: '411624',
            label: '沈丘县',
            value: '411624',
            parentId: '411600'
          },
          {
            id: '411625',
            label: '郸城县',
            value: '411625',
            parentId: '411600'
          },
          {
            id: '411627',
            label: '太康县',
            value: '411627',
            parentId: '411600'
          },
          {
            id: '411628',
            label: '鹿邑县',
            value: '411628',
            parentId: '411600'
          },
          {
            id: '411681',
            label: '项城市',
            value: '411681',
            parentId: '411600'
          }
        ]
      },
      {
        id: '411700',
        label: '驻马店市',
        value: '411700',
        parentId: '410000',
        children: [
          {
            id: '411702',
            label: '驿城区',
            value: '411702',
            parentId: '411700'
          },
          {
            id: '411721',
            label: '西平县',
            value: '411721',
            parentId: '411700'
          },
          {
            id: '411722',
            label: '上蔡县',
            value: '411722',
            parentId: '411700'
          },
          {
            id: '411723',
            label: '平舆县',
            value: '411723',
            parentId: '411700'
          },
          {
            id: '411724',
            label: '正阳县',
            value: '411724',
            parentId: '411700'
          },
          {
            id: '411725',
            label: '确山县',
            value: '411725',
            parentId: '411700'
          },
          {
            id: '411726',
            label: '泌阳县',
            value: '411726',
            parentId: '411700'
          },
          {
            id: '411727',
            label: '汝南县',
            value: '411727',
            parentId: '411700'
          },
          {
            id: '411728',
            label: '遂平县',
            value: '411728',
            parentId: '411700'
          },
          {
            id: '411729',
            label: '新蔡县',
            value: '411729',
            parentId: '411700'
          }
        ]
      },
      {
        id: '419001',
        label: '济源市',
        value: '419001',
        parentId: '410000',
        children: [
          {
            id: '419001',
            label: '济源市',
            value: '419001',
            parentId: '419001'
          }
        ]
      }
    ]
  },
  {
    id: '420000',
    label: '湖北省',
    value: '420000',
    children: [
      {
        id: '420100',
        label: '武汉市',
        value: '420100',
        parentId: '420000',
        children: [
          {
            id: '420102',
            label: '江岸区',
            value: '420102',
            parentId: '420100'
          },
          {
            id: '420103',
            label: '江汉区',
            value: '420103',
            parentId: '420100'
          },
          {
            id: '420104',
            label: '硚口区',
            value: '420104',
            parentId: '420100'
          },
          {
            id: '420105',
            label: '汉阳区',
            value: '420105',
            parentId: '420100'
          },
          {
            id: '420106',
            label: '武昌区',
            value: '420106',
            parentId: '420100'
          },
          {
            id: '420107',
            label: '青山区',
            value: '420107',
            parentId: '420100'
          },
          {
            id: '420111',
            label: '洪山区',
            value: '420111',
            parentId: '420100'
          },
          {
            id: '420112',
            label: '东西湖区',
            value: '420112',
            parentId: '420100'
          },
          {
            id: '420113',
            label: '汉南区',
            value: '420113',
            parentId: '420100'
          },
          {
            id: '420114',
            label: '蔡甸区',
            value: '420114',
            parentId: '420100'
          },
          {
            id: '420115',
            label: '江夏区',
            value: '420115',
            parentId: '420100'
          },
          {
            id: '420116',
            label: '黄陂区',
            value: '420116',
            parentId: '420100'
          },
          {
            id: '420117',
            label: '新洲区',
            value: '420117',
            parentId: '420100'
          }
        ]
      },
      {
        id: '420200',
        label: '黄石市',
        value: '420200',
        parentId: '420000',
        children: [
          {
            id: '420202',
            label: '黄石港区',
            value: '420202',
            parentId: '420200'
          },
          {
            id: '420203',
            label: '西塞山区',
            value: '420203',
            parentId: '420200'
          },
          {
            id: '420204',
            label: '下陆区',
            value: '420204',
            parentId: '420200'
          },
          {
            id: '420205',
            label: '铁山区',
            value: '420205',
            parentId: '420200'
          },
          {
            id: '420222',
            label: '阳新县',
            value: '420222',
            parentId: '420200'
          },
          {
            id: '420281',
            label: '大冶市',
            value: '420281',
            parentId: '420200'
          }
        ]
      },
      {
        id: '420300',
        label: '十堰市',
        value: '420300',
        parentId: '420000',
        children: [
          {
            id: '420302',
            label: '茅箭区',
            value: '420302',
            parentId: '420300'
          },
          {
            id: '420303',
            label: '张湾区',
            value: '420303',
            parentId: '420300'
          },
          {
            id: '420304',
            label: '郧阳区',
            value: '420304',
            parentId: '420300'
          },
          {
            id: '420322',
            label: '郧西县',
            value: '420322',
            parentId: '420300'
          },
          {
            id: '420323',
            label: '竹山县',
            value: '420323',
            parentId: '420300'
          },
          {
            id: '420324',
            label: '竹溪县',
            value: '420324',
            parentId: '420300'
          },
          {
            id: '420325',
            label: '房县',
            value: '420325',
            parentId: '420300'
          },
          {
            id: '420381',
            label: '丹江口市',
            value: '420381',
            parentId: '420300'
          }
        ]
      },
      {
        id: '420500',
        label: '宜昌市',
        value: '420500',
        parentId: '420000',
        children: [
          {
            id: '420502',
            label: '西陵区',
            value: '420502',
            parentId: '420500'
          },
          {
            id: '420503',
            label: '伍家岗区',
            value: '420503',
            parentId: '420500'
          },
          {
            id: '420504',
            label: '点军区',
            value: '420504',
            parentId: '420500'
          },
          {
            id: '420505',
            label: '猇亭区',
            value: '420505',
            parentId: '420500'
          },
          {
            id: '420506',
            label: '夷陵区',
            value: '420506',
            parentId: '420500'
          },
          {
            id: '420525',
            label: '远安县',
            value: '420525',
            parentId: '420500'
          },
          {
            id: '420526',
            label: '兴山县',
            value: '420526',
            parentId: '420500'
          },
          {
            id: '420527',
            label: '秭归县',
            value: '420527',
            parentId: '420500'
          },
          {
            id: '420528',
            label: '长阳土家族自治县',
            value: '420528',
            parentId: '420500'
          },
          {
            id: '420529',
            label: '五峰土家族自治县',
            value: '420529',
            parentId: '420500'
          },
          {
            id: '420581',
            label: '宜都市',
            value: '420581',
            parentId: '420500'
          },
          {
            id: '420582',
            label: '当阳市',
            value: '420582',
            parentId: '420500'
          },
          {
            id: '420583',
            label: '枝江市',
            value: '420583',
            parentId: '420500'
          }
        ]
      },
      {
        id: '420600',
        label: '襄阳市',
        value: '420600',
        parentId: '420000',
        children: [
          {
            id: '420602',
            label: '襄城区',
            value: '420602',
            parentId: '420600'
          },
          {
            id: '420606',
            label: '樊城区',
            value: '420606',
            parentId: '420600'
          },
          {
            id: '420607',
            label: '襄州区',
            value: '420607',
            parentId: '420600'
          },
          {
            id: '420624',
            label: '南漳县',
            value: '420624',
            parentId: '420600'
          },
          {
            id: '420625',
            label: '谷城县',
            value: '420625',
            parentId: '420600'
          },
          {
            id: '420626',
            label: '保康县',
            value: '420626',
            parentId: '420600'
          },
          {
            id: '420682',
            label: '老河口市',
            value: '420682',
            parentId: '420600'
          },
          {
            id: '420683',
            label: '枣阳市',
            value: '420683',
            parentId: '420600'
          },
          {
            id: '420684',
            label: '宜城市',
            value: '420684',
            parentId: '420600'
          }
        ]
      },
      {
        id: '420700',
        label: '鄂州市',
        value: '420700',
        parentId: '420000',
        children: [
          {
            id: '420702',
            label: '梁子湖区',
            value: '420702',
            parentId: '420700'
          },
          {
            id: '420703',
            label: '华容区',
            value: '420703',
            parentId: '420700'
          },
          {
            id: '420704',
            label: '鄂城区',
            value: '420704',
            parentId: '420700'
          }
        ]
      },
      {
        id: '420800',
        label: '荆门市',
        value: '420800',
        parentId: '420000',
        children: [
          {
            id: '420802',
            label: '东宝区',
            value: '420802',
            parentId: '420800'
          },
          {
            id: '420804',
            label: '掇刀区',
            value: '420804',
            parentId: '420800'
          },
          {
            id: '420822',
            label: '沙洋县',
            value: '420822',
            parentId: '420800'
          },
          {
            id: '420881',
            label: '钟祥市',
            value: '420881',
            parentId: '420800'
          },
          {
            id: '420882',
            label: '京山市',
            value: '420882',
            parentId: '420800'
          }
        ]
      },
      {
        id: '420900',
        label: '孝感市',
        value: '420900',
        parentId: '420000',
        children: [
          {
            id: '420902',
            label: '孝南区',
            value: '420902',
            parentId: '420900'
          },
          {
            id: '420921',
            label: '孝昌县',
            value: '420921',
            parentId: '420900'
          },
          {
            id: '420922',
            label: '大悟县',
            value: '420922',
            parentId: '420900'
          },
          {
            id: '420923',
            label: '云梦县',
            value: '420923',
            parentId: '420900'
          },
          {
            id: '420981',
            label: '应城市',
            value: '420981',
            parentId: '420900'
          },
          {
            id: '420982',
            label: '安陆市',
            value: '420982',
            parentId: '420900'
          },
          {
            id: '420984',
            label: '汉川市',
            value: '420984',
            parentId: '420900'
          }
        ]
      },
      {
        id: '421000',
        label: '荆州市',
        value: '421000',
        parentId: '420000',
        children: [
          {
            id: '421002',
            label: '沙市区',
            value: '421002',
            parentId: '421000'
          },
          {
            id: '421003',
            label: '荆州区',
            value: '421003',
            parentId: '421000'
          },
          {
            id: '421022',
            label: '公安县',
            value: '421022',
            parentId: '421000'
          },
          {
            id: '421024',
            label: '江陵县',
            value: '421024',
            parentId: '421000'
          },
          {
            id: '421081',
            label: '石首市',
            value: '421081',
            parentId: '421000'
          },
          {
            id: '421083',
            label: '洪湖市',
            value: '421083',
            parentId: '421000'
          },
          {
            id: '421087',
            label: '松滋市',
            value: '421087',
            parentId: '421000'
          },
          {
            id: '421088',
            label: '监利市',
            value: '421088',
            parentId: '421000'
          }
        ]
      },
      {
        id: '421100',
        label: '黄冈市',
        value: '421100',
        parentId: '420000',
        children: [
          {
            id: '421102',
            label: '黄州区',
            value: '421102',
            parentId: '421100'
          },
          {
            id: '421121',
            label: '团风县',
            value: '421121',
            parentId: '421100'
          },
          {
            id: '421122',
            label: '红安县',
            value: '421122',
            parentId: '421100'
          },
          {
            id: '421123',
            label: '罗田县',
            value: '421123',
            parentId: '421100'
          },
          {
            id: '421124',
            label: '英山县',
            value: '421124',
            parentId: '421100'
          },
          {
            id: '421125',
            label: '浠水县',
            value: '421125',
            parentId: '421100'
          },
          {
            id: '421126',
            label: '蕲春县',
            value: '421126',
            parentId: '421100'
          },
          {
            id: '421127',
            label: '黄梅县',
            value: '421127',
            parentId: '421100'
          },
          {
            id: '421181',
            label: '麻城市',
            value: '421181',
            parentId: '421100'
          },
          {
            id: '421182',
            label: '武穴市',
            value: '421182',
            parentId: '421100'
          }
        ]
      },
      {
        id: '421200',
        label: '咸宁市',
        value: '421200',
        parentId: '420000',
        children: [
          {
            id: '421202',
            label: '咸安区',
            value: '421202',
            parentId: '421200'
          },
          {
            id: '421221',
            label: '嘉鱼县',
            value: '421221',
            parentId: '421200'
          },
          {
            id: '421222',
            label: '通城县',
            value: '421222',
            parentId: '421200'
          },
          {
            id: '421223',
            label: '崇阳县',
            value: '421223',
            parentId: '421200'
          },
          {
            id: '421224',
            label: '通山县',
            value: '421224',
            parentId: '421200'
          },
          {
            id: '421281',
            label: '赤壁市',
            value: '421281',
            parentId: '421200'
          }
        ]
      },
      {
        id: '421300',
        label: '随州市',
        value: '421300',
        parentId: '420000',
        children: [
          {
            id: '421303',
            label: '曾都区',
            value: '421303',
            parentId: '421300'
          },
          {
            id: '421321',
            label: '随县',
            value: '421321',
            parentId: '421300'
          },
          {
            id: '421381',
            label: '广水市',
            value: '421381',
            parentId: '421300'
          }
        ]
      },
      {
        id: '422800',
        label: '恩施土家族苗族自治州',
        value: '422800',
        parentId: '420000',
        children: [
          {
            id: '422801',
            label: '恩施市',
            value: '422801',
            parentId: '422800'
          },
          {
            id: '422802',
            label: '利川市',
            value: '422802',
            parentId: '422800'
          },
          {
            id: '422822',
            label: '建始县',
            value: '422822',
            parentId: '422800'
          },
          {
            id: '422823',
            label: '巴东县',
            value: '422823',
            parentId: '422800'
          },
          {
            id: '422825',
            label: '宣恩县',
            value: '422825',
            parentId: '422800'
          },
          {
            id: '422826',
            label: '咸丰县',
            value: '422826',
            parentId: '422800'
          },
          {
            id: '422827',
            label: '来凤县',
            value: '422827',
            parentId: '422800'
          },
          {
            id: '422828',
            label: '鹤峰县',
            value: '422828',
            parentId: '422800'
          }
        ]
      },
      {
        id: '429004',
        label: '仙桃市',
        value: '429004',
        parentId: '420000',
        children: [
          {
            id: '429004',
            label: '仙桃市',
            value: '429004',
            parentId: '429004'
          }
        ]
      },
      {
        id: '429005',
        label: '潜江市',
        value: '429005',
        parentId: '420000',
        children: [
          {
            id: '429005',
            label: '潜江市',
            value: '429005',
            parentId: '429005'
          }
        ]
      },
      {
        id: '429006',
        label: '天门市',
        value: '429006',
        parentId: '420000',
        children: [
          {
            id: '429006',
            label: '天门市',
            value: '429006',
            parentId: '429006'
          }
        ]
      },
      {
        id: '429021',
        label: '神农架林区',
        value: '429021',
        parentId: '420000',
        children: [
          {
            id: '429021',
            label: '神农架林区',
            value: '429021',
            parentId: '429021'
          }
        ]
      }
    ]
  },
  {
    id: '430000',
    label: '湖南省',
    value: '430000',
    children: [
      {
        id: '430100',
        label: '长沙市',
        value: '430100',
        parentId: '430000',
        children: [
          {
            id: '430102',
            label: '芙蓉区',
            value: '430102',
            parentId: '430100'
          },
          {
            id: '430103',
            label: '天心区',
            value: '430103',
            parentId: '430100'
          },
          {
            id: '430104',
            label: '岳麓区',
            value: '430104',
            parentId: '430100'
          },
          {
            id: '430105',
            label: '开福区',
            value: '430105',
            parentId: '430100'
          },
          {
            id: '430111',
            label: '雨花区',
            value: '430111',
            parentId: '430100'
          },
          {
            id: '430112',
            label: '望城区',
            value: '430112',
            parentId: '430100'
          },
          {
            id: '430121',
            label: '长沙县',
            value: '430121',
            parentId: '430100'
          },
          {
            id: '430181',
            label: '浏阳市',
            value: '430181',
            parentId: '430100'
          },
          {
            id: '430182',
            label: '宁乡市',
            value: '430182',
            parentId: '430100'
          }
        ]
      },
      {
        id: '430200',
        label: '株洲市',
        value: '430200',
        parentId: '430000',
        children: [
          {
            id: '430202',
            label: '荷塘区',
            value: '430202',
            parentId: '430200'
          },
          {
            id: '430203',
            label: '芦淞区',
            value: '430203',
            parentId: '430200'
          },
          {
            id: '430204',
            label: '石峰区',
            value: '430204',
            parentId: '430200'
          },
          {
            id: '430211',
            label: '天元区',
            value: '430211',
            parentId: '430200'
          },
          {
            id: '430212',
            label: '渌口区',
            value: '430212',
            parentId: '430200'
          },
          {
            id: '430223',
            label: '攸县',
            value: '430223',
            parentId: '430200'
          },
          {
            id: '430224',
            label: '茶陵县',
            value: '430224',
            parentId: '430200'
          },
          {
            id: '430225',
            label: '炎陵县',
            value: '430225',
            parentId: '430200'
          },
          {
            id: '430281',
            label: '醴陵市',
            value: '430281',
            parentId: '430200'
          }
        ]
      },
      {
        id: '430300',
        label: '湘潭市',
        value: '430300',
        parentId: '430000',
        children: [
          {
            id: '430302',
            label: '雨湖区',
            value: '430302',
            parentId: '430300'
          },
          {
            id: '430304',
            label: '岳塘区',
            value: '430304',
            parentId: '430300'
          },
          {
            id: '430321',
            label: '湘潭县',
            value: '430321',
            parentId: '430300'
          },
          {
            id: '430381',
            label: '湘乡市',
            value: '430381',
            parentId: '430300'
          },
          {
            id: '430382',
            label: '韶山市',
            value: '430382',
            parentId: '430300'
          }
        ]
      },
      {
        id: '430400',
        label: '衡阳市',
        value: '430400',
        parentId: '430000',
        children: [
          {
            id: '430405',
            label: '珠晖区',
            value: '430405',
            parentId: '430400'
          },
          {
            id: '430406',
            label: '雁峰区',
            value: '430406',
            parentId: '430400'
          },
          {
            id: '430407',
            label: '石鼓区',
            value: '430407',
            parentId: '430400'
          },
          {
            id: '430408',
            label: '蒸湘区',
            value: '430408',
            parentId: '430400'
          },
          {
            id: '430412',
            label: '南岳区',
            value: '430412',
            parentId: '430400'
          },
          {
            id: '430421',
            label: '衡阳县',
            value: '430421',
            parentId: '430400'
          },
          {
            id: '430422',
            label: '衡南县',
            value: '430422',
            parentId: '430400'
          },
          {
            id: '430423',
            label: '衡山县',
            value: '430423',
            parentId: '430400'
          },
          {
            id: '430424',
            label: '衡东县',
            value: '430424',
            parentId: '430400'
          },
          {
            id: '430426',
            label: '祁东县',
            value: '430426',
            parentId: '430400'
          },
          {
            id: '430481',
            label: '耒阳市',
            value: '430481',
            parentId: '430400'
          },
          {
            id: '430482',
            label: '常宁市',
            value: '430482',
            parentId: '430400'
          }
        ]
      },
      {
        id: '430500',
        label: '邵阳市',
        value: '430500',
        parentId: '430000',
        children: [
          {
            id: '430502',
            label: '双清区',
            value: '430502',
            parentId: '430500'
          },
          {
            id: '430503',
            label: '大祥区',
            value: '430503',
            parentId: '430500'
          },
          {
            id: '430511',
            label: '北塔区',
            value: '430511',
            parentId: '430500'
          },
          {
            id: '430522',
            label: '新邵县',
            value: '430522',
            parentId: '430500'
          },
          {
            id: '430523',
            label: '邵阳县',
            value: '430523',
            parentId: '430500'
          },
          {
            id: '430524',
            label: '隆回县',
            value: '430524',
            parentId: '430500'
          },
          {
            id: '430525',
            label: '洞口县',
            value: '430525',
            parentId: '430500'
          },
          {
            id: '430527',
            label: '绥宁县',
            value: '430527',
            parentId: '430500'
          },
          {
            id: '430528',
            label: '新宁县',
            value: '430528',
            parentId: '430500'
          },
          {
            id: '430529',
            label: '城步苗族自治县',
            value: '430529',
            parentId: '430500'
          },
          {
            id: '430581',
            label: '武冈市',
            value: '430581',
            parentId: '430500'
          },
          {
            id: '430582',
            label: '邵东市',
            value: '430582',
            parentId: '430500'
          }
        ]
      },
      {
        id: '430600',
        label: '岳阳市',
        value: '430600',
        parentId: '430000',
        children: [
          {
            id: '430602',
            label: '岳阳楼区',
            value: '430602',
            parentId: '430600'
          },
          {
            id: '430603',
            label: '云溪区',
            value: '430603',
            parentId: '430600'
          },
          {
            id: '430611',
            label: '君山区',
            value: '430611',
            parentId: '430600'
          },
          {
            id: '430621',
            label: '岳阳县',
            value: '430621',
            parentId: '430600'
          },
          {
            id: '430623',
            label: '华容县',
            value: '430623',
            parentId: '430600'
          },
          {
            id: '430624',
            label: '湘阴县',
            value: '430624',
            parentId: '430600'
          },
          {
            id: '430626',
            label: '平江县',
            value: '430626',
            parentId: '430600'
          },
          {
            id: '430681',
            label: '汨罗市',
            value: '430681',
            parentId: '430600'
          },
          {
            id: '430682',
            label: '临湘市',
            value: '430682',
            parentId: '430600'
          }
        ]
      },
      {
        id: '430700',
        label: '常德市',
        value: '430700',
        parentId: '430000',
        children: [
          {
            id: '430702',
            label: '武陵区',
            value: '430702',
            parentId: '430700'
          },
          {
            id: '430703',
            label: '鼎城区',
            value: '430703',
            parentId: '430700'
          },
          {
            id: '430721',
            label: '安乡县',
            value: '430721',
            parentId: '430700'
          },
          {
            id: '430722',
            label: '汉寿县',
            value: '430722',
            parentId: '430700'
          },
          {
            id: '430723',
            label: '澧县',
            value: '430723',
            parentId: '430700'
          },
          {
            id: '430724',
            label: '临澧县',
            value: '430724',
            parentId: '430700'
          },
          {
            id: '430725',
            label: '桃源县',
            value: '430725',
            parentId: '430700'
          },
          {
            id: '430726',
            label: '石门县',
            value: '430726',
            parentId: '430700'
          },
          {
            id: '430781',
            label: '津市市',
            value: '430781',
            parentId: '430700'
          }
        ]
      },
      {
        id: '430800',
        label: '张家界市',
        value: '430800',
        parentId: '430000',
        children: [
          {
            id: '430802',
            label: '永定区',
            value: '430802',
            parentId: '430800'
          },
          {
            id: '430811',
            label: '武陵源区',
            value: '430811',
            parentId: '430800'
          },
          {
            id: '430821',
            label: '慈利县',
            value: '430821',
            parentId: '430800'
          },
          {
            id: '430822',
            label: '桑植县',
            value: '430822',
            parentId: '430800'
          }
        ]
      },
      {
        id: '430900',
        label: '益阳市',
        value: '430900',
        parentId: '430000',
        children: [
          {
            id: '430902',
            label: '资阳区',
            value: '430902',
            parentId: '430900'
          },
          {
            id: '430903',
            label: '赫山区',
            value: '430903',
            parentId: '430900'
          },
          {
            id: '430921',
            label: '南县',
            value: '430921',
            parentId: '430900'
          },
          {
            id: '430922',
            label: '桃江县',
            value: '430922',
            parentId: '430900'
          },
          {
            id: '430923',
            label: '安化县',
            value: '430923',
            parentId: '430900'
          },
          {
            id: '430981',
            label: '沅江市',
            value: '430981',
            parentId: '430900'
          }
        ]
      },
      {
        id: '431000',
        label: '郴州市',
        value: '431000',
        parentId: '430000',
        children: [
          {
            id: '431002',
            label: '北湖区',
            value: '431002',
            parentId: '431000'
          },
          {
            id: '431003',
            label: '苏仙区',
            value: '431003',
            parentId: '431000'
          },
          {
            id: '431021',
            label: '桂阳县',
            value: '431021',
            parentId: '431000'
          },
          {
            id: '431022',
            label: '宜章县',
            value: '431022',
            parentId: '431000'
          },
          {
            id: '431023',
            label: '永兴县',
            value: '431023',
            parentId: '431000'
          },
          {
            id: '431024',
            label: '嘉禾县',
            value: '431024',
            parentId: '431000'
          },
          {
            id: '431025',
            label: '临武县',
            value: '431025',
            parentId: '431000'
          },
          {
            id: '431026',
            label: '汝城县',
            value: '431026',
            parentId: '431000'
          },
          {
            id: '431027',
            label: '桂东县',
            value: '431027',
            parentId: '431000'
          },
          {
            id: '431028',
            label: '安仁县',
            value: '431028',
            parentId: '431000'
          },
          {
            id: '431081',
            label: '资兴市',
            value: '431081',
            parentId: '431000'
          }
        ]
      },
      {
        id: '431100',
        label: '永州市',
        value: '431100',
        parentId: '430000',
        children: [
          {
            id: '431102',
            label: '零陵区',
            value: '431102',
            parentId: '431100'
          },
          {
            id: '431103',
            label: '冷水滩区',
            value: '431103',
            parentId: '431100'
          },
          {
            id: '431122',
            label: '东安县',
            value: '431122',
            parentId: '431100'
          },
          {
            id: '431123',
            label: '双牌县',
            value: '431123',
            parentId: '431100'
          },
          {
            id: '431124',
            label: '道县',
            value: '431124',
            parentId: '431100'
          },
          {
            id: '431125',
            label: '江永县',
            value: '431125',
            parentId: '431100'
          },
          {
            id: '431126',
            label: '宁远县',
            value: '431126',
            parentId: '431100'
          },
          {
            id: '431127',
            label: '蓝山县',
            value: '431127',
            parentId: '431100'
          },
          {
            id: '431128',
            label: '新田县',
            value: '431128',
            parentId: '431100'
          },
          {
            id: '431129',
            label: '江华瑶族自治县',
            value: '431129',
            parentId: '431100'
          },
          {
            id: '431181',
            label: '祁阳市',
            value: '431181',
            parentId: '431100'
          }
        ]
      },
      {
        id: '431200',
        label: '怀化市',
        value: '431200',
        parentId: '430000',
        children: [
          {
            id: '431202',
            label: '鹤城区',
            value: '431202',
            parentId: '431200'
          },
          {
            id: '431221',
            label: '中方县',
            value: '431221',
            parentId: '431200'
          },
          {
            id: '431222',
            label: '沅陵县',
            value: '431222',
            parentId: '431200'
          },
          {
            id: '431223',
            label: '辰溪县',
            value: '431223',
            parentId: '431200'
          },
          {
            id: '431224',
            label: '溆浦县',
            value: '431224',
            parentId: '431200'
          },
          {
            id: '431225',
            label: '会同县',
            value: '431225',
            parentId: '431200'
          },
          {
            id: '431226',
            label: '麻阳苗族自治县',
            value: '431226',
            parentId: '431200'
          },
          {
            id: '431227',
            label: '新晃侗族自治县',
            value: '431227',
            parentId: '431200'
          },
          {
            id: '431228',
            label: '芷江侗族自治县',
            value: '431228',
            parentId: '431200'
          },
          {
            id: '431229',
            label: '靖州苗族侗族自治县',
            value: '431229',
            parentId: '431200'
          },
          {
            id: '431230',
            label: '通道侗族自治县',
            value: '431230',
            parentId: '431200'
          },
          {
            id: '431281',
            label: '洪江市',
            value: '431281',
            parentId: '431200'
          }
        ]
      },
      {
        id: '431300',
        label: '娄底市',
        value: '431300',
        parentId: '430000',
        children: [
          {
            id: '431302',
            label: '娄星区',
            value: '431302',
            parentId: '431300'
          },
          {
            id: '431321',
            label: '双峰县',
            value: '431321',
            parentId: '431300'
          },
          {
            id: '431322',
            label: '新化县',
            value: '431322',
            parentId: '431300'
          },
          {
            id: '431381',
            label: '冷水江市',
            value: '431381',
            parentId: '431300'
          },
          {
            id: '431382',
            label: '涟源市',
            value: '431382',
            parentId: '431300'
          }
        ]
      },
      {
        id: '433100',
        label: '湘西土家族苗族自治州',
        value: '433100',
        parentId: '430000',
        children: [
          {
            id: '433101',
            label: '吉首市',
            value: '433101',
            parentId: '433100'
          },
          {
            id: '433122',
            label: '泸溪县',
            value: '433122',
            parentId: '433100'
          },
          {
            id: '433123',
            label: '凤凰县',
            value: '433123',
            parentId: '433100'
          },
          {
            id: '433124',
            label: '花垣县',
            value: '433124',
            parentId: '433100'
          },
          {
            id: '433125',
            label: '保靖县',
            value: '433125',
            parentId: '433100'
          },
          {
            id: '433126',
            label: '古丈县',
            value: '433126',
            parentId: '433100'
          },
          {
            id: '433127',
            label: '永顺县',
            value: '433127',
            parentId: '433100'
          },
          {
            id: '433130',
            label: '龙山县',
            value: '433130',
            parentId: '433100'
          }
        ]
      }
    ]
  },
  {
    id: '440000',
    label: '广东省',
    value: '440000',
    children: [
      {
        id: '440100',
        label: '广州市',
        value: '440100',
        parentId: '440000',
        children: [
          {
            id: '440103',
            label: '荔湾区',
            value: '440103',
            parentId: '440100'
          },
          {
            id: '440104',
            label: '越秀区',
            value: '440104',
            parentId: '440100'
          },
          {
            id: '440105',
            label: '海珠区',
            value: '440105',
            parentId: '440100'
          },
          {
            id: '440106',
            label: '天河区',
            value: '440106',
            parentId: '440100'
          },
          {
            id: '440111',
            label: '白云区',
            value: '440111',
            parentId: '440100'
          },
          {
            id: '440112',
            label: '黄埔区',
            value: '440112',
            parentId: '440100'
          },
          {
            id: '440113',
            label: '番禺区',
            value: '440113',
            parentId: '440100'
          },
          {
            id: '440114',
            label: '花都区',
            value: '440114',
            parentId: '440100'
          },
          {
            id: '440115',
            label: '南沙区',
            value: '440115',
            parentId: '440100'
          },
          {
            id: '440117',
            label: '从化区',
            value: '440117',
            parentId: '440100'
          },
          {
            id: '440118',
            label: '增城区',
            value: '440118',
            parentId: '440100'
          }
        ]
      },
      {
        id: '440200',
        label: '韶关市',
        value: '440200',
        parentId: '440000',
        children: [
          {
            id: '440203',
            label: '武江区',
            value: '440203',
            parentId: '440200'
          },
          {
            id: '440204',
            label: '浈江区',
            value: '440204',
            parentId: '440200'
          },
          {
            id: '440205',
            label: '曲江区',
            value: '440205',
            parentId: '440200'
          },
          {
            id: '440222',
            label: '始兴县',
            value: '440222',
            parentId: '440200'
          },
          {
            id: '440224',
            label: '仁化县',
            value: '440224',
            parentId: '440200'
          },
          {
            id: '440229',
            label: '翁源县',
            value: '440229',
            parentId: '440200'
          },
          {
            id: '440232',
            label: '乳源瑶族自治县',
            value: '440232',
            parentId: '440200'
          },
          {
            id: '440233',
            label: '新丰县',
            value: '440233',
            parentId: '440200'
          },
          {
            id: '440281',
            label: '乐昌市',
            value: '440281',
            parentId: '440200'
          },
          {
            id: '440282',
            label: '南雄市',
            value: '440282',
            parentId: '440200'
          }
        ]
      },
      {
        id: '440300',
        label: '深圳市',
        value: '440300',
        parentId: '440000',
        children: [
          {
            id: '440303',
            label: '罗湖区',
            value: '440303',
            parentId: '440300'
          },
          {
            id: '440304',
            label: '福田区',
            value: '440304',
            parentId: '440300'
          },
          {
            id: '440305',
            label: '南山区',
            value: '440305',
            parentId: '440300'
          },
          {
            id: '440306',
            label: '宝安区',
            value: '440306',
            parentId: '440300'
          },
          {
            id: '440307',
            label: '龙岗区',
            value: '440307',
            parentId: '440300'
          },
          {
            id: '440308',
            label: '盐田区',
            value: '440308',
            parentId: '440300'
          },
          {
            id: '440309',
            label: '龙华区',
            value: '440309',
            parentId: '440300'
          },
          {
            id: '440310',
            label: '坪山区',
            value: '440310',
            parentId: '440300'
          },
          {
            id: '440311',
            label: '光明区',
            value: '440311',
            parentId: '440300'
          }
        ]
      },
      {
        id: '440400',
        label: '珠海市',
        value: '440400',
        parentId: '440000',
        children: [
          {
            id: '440402',
            label: '香洲区',
            value: '440402',
            parentId: '440400'
          },
          {
            id: '440403',
            label: '斗门区',
            value: '440403',
            parentId: '440400'
          },
          {
            id: '440404',
            label: '金湾区',
            value: '440404',
            parentId: '440400'
          }
        ]
      },
      {
        id: '440500',
        label: '汕头市',
        value: '440500',
        parentId: '440000',
        children: [
          {
            id: '440507',
            label: '龙湖区',
            value: '440507',
            parentId: '440500'
          },
          {
            id: '440511',
            label: '金平区',
            value: '440511',
            parentId: '440500'
          },
          {
            id: '440512',
            label: '濠江区',
            value: '440512',
            parentId: '440500'
          },
          {
            id: '440513',
            label: '潮阳区',
            value: '440513',
            parentId: '440500'
          },
          {
            id: '440514',
            label: '潮南区',
            value: '440514',
            parentId: '440500'
          },
          {
            id: '440515',
            label: '澄海区',
            value: '440515',
            parentId: '440500'
          },
          {
            id: '440523',
            label: '南澳县',
            value: '440523',
            parentId: '440500'
          }
        ]
      },
      {
        id: '440600',
        label: '佛山市',
        value: '440600',
        parentId: '440000',
        children: [
          {
            id: '440604',
            label: '禅城区',
            value: '440604',
            parentId: '440600'
          },
          {
            id: '440605',
            label: '南海区',
            value: '440605',
            parentId: '440600'
          },
          {
            id: '440606',
            label: '顺德区',
            value: '440606',
            parentId: '440600'
          },
          {
            id: '440607',
            label: '三水区',
            value: '440607',
            parentId: '440600'
          },
          {
            id: '440608',
            label: '高明区',
            value: '440608',
            parentId: '440600'
          }
        ]
      },
      {
        id: '440700',
        label: '江门市',
        value: '440700',
        parentId: '440000',
        children: [
          {
            id: '440703',
            label: '蓬江区',
            value: '440703',
            parentId: '440700'
          },
          {
            id: '440704',
            label: '江海区',
            value: '440704',
            parentId: '440700'
          },
          {
            id: '440705',
            label: '新会区',
            value: '440705',
            parentId: '440700'
          },
          {
            id: '440781',
            label: '台山市',
            value: '440781',
            parentId: '440700'
          },
          {
            id: '440783',
            label: '开平市',
            value: '440783',
            parentId: '440700'
          },
          {
            id: '440784',
            label: '鹤山市',
            value: '440784',
            parentId: '440700'
          },
          {
            id: '440785',
            label: '恩平市',
            value: '440785',
            parentId: '440700'
          }
        ]
      },
      {
        id: '440800',
        label: '湛江市',
        value: '440800',
        parentId: '440000',
        children: [
          {
            id: '440802',
            label: '赤坎区',
            value: '440802',
            parentId: '440800'
          },
          {
            id: '440803',
            label: '霞山区',
            value: '440803',
            parentId: '440800'
          },
          {
            id: '440804',
            label: '坡头区',
            value: '440804',
            parentId: '440800'
          },
          {
            id: '440811',
            label: '麻章区',
            value: '440811',
            parentId: '440800'
          },
          {
            id: '440823',
            label: '遂溪县',
            value: '440823',
            parentId: '440800'
          },
          {
            id: '440825',
            label: '徐闻县',
            value: '440825',
            parentId: '440800'
          },
          {
            id: '440881',
            label: '廉江市',
            value: '440881',
            parentId: '440800'
          },
          {
            id: '440882',
            label: '雷州市',
            value: '440882',
            parentId: '440800'
          },
          {
            id: '440883',
            label: '吴川市',
            value: '440883',
            parentId: '440800'
          }
        ]
      },
      {
        id: '440900',
        label: '茂名市',
        value: '440900',
        parentId: '440000',
        children: [
          {
            id: '440902',
            label: '茂南区',
            value: '440902',
            parentId: '440900'
          },
          {
            id: '440904',
            label: '电白区',
            value: '440904',
            parentId: '440900'
          },
          {
            id: '440981',
            label: '高州市',
            value: '440981',
            parentId: '440900'
          },
          {
            id: '440982',
            label: '化州市',
            value: '440982',
            parentId: '440900'
          },
          {
            id: '440983',
            label: '信宜市',
            value: '440983',
            parentId: '440900'
          }
        ]
      },
      {
        id: '441200',
        label: '肇庆市',
        value: '441200',
        parentId: '440000',
        children: [
          {
            id: '441202',
            label: '端州区',
            value: '441202',
            parentId: '441200'
          },
          {
            id: '441203',
            label: '鼎湖区',
            value: '441203',
            parentId: '441200'
          },
          {
            id: '441204',
            label: '高要区',
            value: '441204',
            parentId: '441200'
          },
          {
            id: '441223',
            label: '广宁县',
            value: '441223',
            parentId: '441200'
          },
          {
            id: '441224',
            label: '怀集县',
            value: '441224',
            parentId: '441200'
          },
          {
            id: '441225',
            label: '封开县',
            value: '441225',
            parentId: '441200'
          },
          {
            id: '441226',
            label: '德庆县',
            value: '441226',
            parentId: '441200'
          },
          {
            id: '441284',
            label: '四会市',
            value: '441284',
            parentId: '441200'
          }
        ]
      },
      {
        id: '441300',
        label: '惠州市',
        value: '441300',
        parentId: '440000',
        children: [
          {
            id: '441302',
            label: '惠城区',
            value: '441302',
            parentId: '441300'
          },
          {
            id: '441303',
            label: '惠阳区',
            value: '441303',
            parentId: '441300'
          },
          {
            id: '441322',
            label: '博罗县',
            value: '441322',
            parentId: '441300'
          },
          {
            id: '441323',
            label: '惠东县',
            value: '441323',
            parentId: '441300'
          },
          {
            id: '441324',
            label: '龙门县',
            value: '441324',
            parentId: '441300'
          }
        ]
      },
      {
        id: '441400',
        label: '梅州市',
        value: '441400',
        parentId: '440000',
        children: [
          {
            id: '441402',
            label: '梅江区',
            value: '441402',
            parentId: '441400'
          },
          {
            id: '441403',
            label: '梅县区',
            value: '441403',
            parentId: '441400'
          },
          {
            id: '441422',
            label: '大埔县',
            value: '441422',
            parentId: '441400'
          },
          {
            id: '441423',
            label: '丰顺县',
            value: '441423',
            parentId: '441400'
          },
          {
            id: '441424',
            label: '五华县',
            value: '441424',
            parentId: '441400'
          },
          {
            id: '441426',
            label: '平远县',
            value: '441426',
            parentId: '441400'
          },
          {
            id: '441427',
            label: '蕉岭县',
            value: '441427',
            parentId: '441400'
          },
          {
            id: '441481',
            label: '兴宁市',
            value: '441481',
            parentId: '441400'
          }
        ]
      },
      {
        id: '441500',
        label: '汕尾市',
        value: '441500',
        parentId: '440000',
        children: [
          {
            id: '441502',
            label: '城区',
            value: '441502',
            parentId: '441500'
          },
          {
            id: '441521',
            label: '海丰县',
            value: '441521',
            parentId: '441500'
          },
          {
            id: '441523',
            label: '陆河县',
            value: '441523',
            parentId: '441500'
          },
          {
            id: '441581',
            label: '陆丰市',
            value: '441581',
            parentId: '441500'
          }
        ]
      },
      {
        id: '441600',
        label: '河源市',
        value: '441600',
        parentId: '440000',
        children: [
          {
            id: '441602',
            label: '源城区',
            value: '441602',
            parentId: '441600'
          },
          {
            id: '441621',
            label: '紫金县',
            value: '441621',
            parentId: '441600'
          },
          {
            id: '441622',
            label: '龙川县',
            value: '441622',
            parentId: '441600'
          },
          {
            id: '441623',
            label: '连平县',
            value: '441623',
            parentId: '441600'
          },
          {
            id: '441624',
            label: '和平县',
            value: '441624',
            parentId: '441600'
          },
          {
            id: '441625',
            label: '东源县',
            value: '441625',
            parentId: '441600'
          }
        ]
      },
      {
        id: '441700',
        label: '阳江市',
        value: '441700',
        parentId: '440000',
        children: [
          {
            id: '441702',
            label: '江城区',
            value: '441702',
            parentId: '441700'
          },
          {
            id: '441704',
            label: '阳东区',
            value: '441704',
            parentId: '441700'
          },
          {
            id: '441721',
            label: '阳西县',
            value: '441721',
            parentId: '441700'
          },
          {
            id: '441781',
            label: '阳春市',
            value: '441781',
            parentId: '441700'
          }
        ]
      },
      {
        id: '441800',
        label: '清远市',
        value: '441800',
        parentId: '440000',
        children: [
          {
            id: '441802',
            label: '清城区',
            value: '441802',
            parentId: '441800'
          },
          {
            id: '441803',
            label: '清新区',
            value: '441803',
            parentId: '441800'
          },
          {
            id: '441821',
            label: '佛冈县',
            value: '441821',
            parentId: '441800'
          },
          {
            id: '441823',
            label: '阳山县',
            value: '441823',
            parentId: '441800'
          },
          {
            id: '441825',
            label: '连山壮族瑶族自治县',
            value: '441825',
            parentId: '441800'
          },
          {
            id: '441826',
            label: '连南瑶族自治县',
            value: '441826',
            parentId: '441800'
          },
          {
            id: '441881',
            label: '英德市',
            value: '441881',
            parentId: '441800'
          },
          {
            id: '441882',
            label: '连州市',
            value: '441882',
            parentId: '441800'
          }
        ]
      },
      {
        id: '441900',
        label: '东莞市',
        value: '441900',
        parentId: '440000',
        children: [
          {
            id: '441900003000',
            label: '东城街道',
            value: '441900003000',
            parentId: '441900'
          },
          {
            id: '441900004000',
            label: '南城街道',
            value: '441900004000',
            parentId: '441900'
          },
          {
            id: '441900005000',
            label: '万江街道',
            value: '441900005000',
            parentId: '441900'
          },
          {
            id: '441900006000',
            label: '莞城街道',
            value: '441900006000',
            parentId: '441900'
          },
          {
            id: '441900101000',
            label: '石碣镇',
            value: '441900101000',
            parentId: '441900'
          },
          {
            id: '441900102000',
            label: '石龙镇',
            value: '441900102000',
            parentId: '441900'
          },
          {
            id: '441900103000',
            label: '茶山镇',
            value: '441900103000',
            parentId: '441900'
          },
          {
            id: '441900104000',
            label: '石排镇',
            value: '441900104000',
            parentId: '441900'
          },
          {
            id: '441900105000',
            label: '企石镇',
            value: '441900105000',
            parentId: '441900'
          },
          {
            id: '441900106000',
            label: '横沥镇',
            value: '441900106000',
            parentId: '441900'
          },
          {
            id: '441900107000',
            label: '桥头镇',
            value: '441900107000',
            parentId: '441900'
          },
          {
            id: '441900108000',
            label: '谢岗镇',
            value: '441900108000',
            parentId: '441900'
          },
          {
            id: '441900109000',
            label: '东坑镇',
            value: '441900109000',
            parentId: '441900'
          },
          {
            id: '441900110000',
            label: '常平镇',
            value: '441900110000',
            parentId: '441900'
          },
          {
            id: '441900111000',
            label: '寮步镇',
            value: '441900111000',
            parentId: '441900'
          },
          {
            id: '441900112000',
            label: '樟木头镇',
            value: '441900112000',
            parentId: '441900'
          },
          {
            id: '441900113000',
            label: '大朗镇',
            value: '441900113000',
            parentId: '441900'
          },
          {
            id: '441900114000',
            label: '黄江镇',
            value: '441900114000',
            parentId: '441900'
          },
          {
            id: '441900115000',
            label: '清溪镇',
            value: '441900115000',
            parentId: '441900'
          },
          {
            id: '441900116000',
            label: '塘厦镇',
            value: '441900116000',
            parentId: '441900'
          },
          {
            id: '441900117000',
            label: '凤岗镇',
            value: '441900117000',
            parentId: '441900'
          },
          {
            id: '441900118000',
            label: '大岭山镇',
            value: '441900118000',
            parentId: '441900'
          },
          {
            id: '441900119000',
            label: '长安镇',
            value: '441900119000',
            parentId: '441900'
          },
          {
            id: '441900121000',
            label: '虎门镇',
            value: '441900121000',
            parentId: '441900'
          },
          {
            id: '441900122000',
            label: '厚街镇',
            value: '441900122000',
            parentId: '441900'
          },
          {
            id: '441900123000',
            label: '沙田镇',
            value: '441900123000',
            parentId: '441900'
          },
          {
            id: '441900124000',
            label: '道滘镇',
            value: '441900124000',
            parentId: '441900'
          },
          {
            id: '441900125000',
            label: '洪梅镇',
            value: '441900125000',
            parentId: '441900'
          },
          {
            id: '441900126000',
            label: '麻涌镇',
            value: '441900126000',
            parentId: '441900'
          },
          {
            id: '441900127000',
            label: '望牛墩镇',
            value: '441900127000',
            parentId: '441900'
          },
          {
            id: '441900128000',
            label: '中堂镇',
            value: '441900128000',
            parentId: '441900'
          },
          {
            id: '441900129000',
            label: '高埗镇',
            value: '441900129000',
            parentId: '441900'
          },
          {
            id: '441900401000',
            label: '松山湖',
            value: '441900401000',
            parentId: '441900'
          },
          {
            id: '441900402000',
            label: '东莞港',
            value: '441900402000',
            parentId: '441900'
          },
          {
            id: '441900403000',
            label: '东莞生态园',
            value: '441900403000',
            parentId: '441900'
          },
          {
            id: '441900404000',
            label: '东莞滨海湾新区',
            value: '441900404000',
            parentId: '441900'
          }
        ]
      },
      {
        id: '442000',
        label: '中山市',
        value: '442000',
        parentId: '440000',
        children: [
          {
            id: '442000001000',
            label: '石岐街道',
            value: '442000001000',
            parentId: '442000'
          },
          {
            id: '442000002000',
            label: '东区街道',
            value: '442000002000',
            parentId: '442000'
          },
          {
            id: '442000003000',
            label: '中山港街道',
            value: '442000003000',
            parentId: '442000'
          },
          {
            id: '442000004000',
            label: '西区街道',
            value: '442000004000',
            parentId: '442000'
          },
          {
            id: '442000005000',
            label: '南区街道',
            value: '442000005000',
            parentId: '442000'
          },
          {
            id: '442000006000',
            label: '五桂山街道',
            value: '442000006000',
            parentId: '442000'
          },
          {
            id: '442000007000',
            label: '民众街道',
            value: '442000007000',
            parentId: '442000'
          },
          {
            id: '442000008000',
            label: '南朗街道',
            value: '442000008000',
            parentId: '442000'
          },
          {
            id: '442000101000',
            label: '黄圃镇',
            value: '442000101000',
            parentId: '442000'
          },
          {
            id: '442000103000',
            label: '东凤镇',
            value: '442000103000',
            parentId: '442000'
          },
          {
            id: '442000105000',
            label: '古镇镇',
            value: '442000105000',
            parentId: '442000'
          },
          {
            id: '442000106000',
            label: '沙溪镇',
            value: '442000106000',
            parentId: '442000'
          },
          {
            id: '442000107000',
            label: '坦洲镇',
            value: '442000107000',
            parentId: '442000'
          },
          {
            id: '442000108000',
            label: '港口镇',
            value: '442000108000',
            parentId: '442000'
          },
          {
            id: '442000109000',
            label: '三角镇',
            value: '442000109000',
            parentId: '442000'
          },
          {
            id: '442000110000',
            label: '横栏镇',
            value: '442000110000',
            parentId: '442000'
          },
          {
            id: '442000111000',
            label: '南头镇',
            value: '442000111000',
            parentId: '442000'
          },
          {
            id: '442000112000',
            label: '阜沙镇',
            value: '442000112000',
            parentId: '442000'
          },
          {
            id: '442000114000',
            label: '三乡镇',
            value: '442000114000',
            parentId: '442000'
          },
          {
            id: '442000115000',
            label: '板芙镇',
            value: '442000115000',
            parentId: '442000'
          },
          {
            id: '442000116000',
            label: '大涌镇',
            value: '442000116000',
            parentId: '442000'
          },
          {
            id: '442000117000',
            label: '神湾镇',
            value: '442000117000',
            parentId: '442000'
          },
          {
            id: '442000118000',
            label: '小榄镇',
            value: '442000118000',
            parentId: '442000'
          }
        ]
      },
      {
        id: '445100',
        label: '潮州市',
        value: '445100',
        parentId: '440000',
        children: [
          {
            id: '445102',
            label: '湘桥区',
            value: '445102',
            parentId: '445100'
          },
          {
            id: '445103',
            label: '潮安区',
            value: '445103',
            parentId: '445100'
          },
          {
            id: '445122',
            label: '饶平县',
            value: '445122',
            parentId: '445100'
          }
        ]
      },
      {
        id: '445200',
        label: '揭阳市',
        value: '445200',
        parentId: '440000',
        children: [
          {
            id: '445202',
            label: '榕城区',
            value: '445202',
            parentId: '445200'
          },
          {
            id: '445203',
            label: '揭东区',
            value: '445203',
            parentId: '445200'
          },
          {
            id: '445222',
            label: '揭西县',
            value: '445222',
            parentId: '445200'
          },
          {
            id: '445224',
            label: '惠来县',
            value: '445224',
            parentId: '445200'
          },
          {
            id: '445281',
            label: '普宁市',
            value: '445281',
            parentId: '445200'
          }
        ]
      },
      {
        id: '445300',
        label: '云浮市',
        value: '445300',
        parentId: '440000',
        children: [
          {
            id: '445302',
            label: '云城区',
            value: '445302',
            parentId: '445300'
          },
          {
            id: '445303',
            label: '云安区',
            value: '445303',
            parentId: '445300'
          },
          {
            id: '445321',
            label: '新兴县',
            value: '445321',
            parentId: '445300'
          },
          {
            id: '445322',
            label: '郁南县',
            value: '445322',
            parentId: '445300'
          },
          {
            id: '445381',
            label: '罗定市',
            value: '445381',
            parentId: '445300'
          }
        ]
      }
    ]
  },
  {
    id: '450000',
    label: '广西壮族自治区',
    value: '450000',
    children: [
      {
        id: '450100',
        label: '南宁市',
        value: '450100',
        parentId: '450000',
        children: [
          {
            id: '450102',
            label: '兴宁区',
            value: '450102',
            parentId: '450100'
          },
          {
            id: '450103',
            label: '青秀区',
            value: '450103',
            parentId: '450100'
          },
          {
            id: '450105',
            label: '江南区',
            value: '450105',
            parentId: '450100'
          },
          {
            id: '450107',
            label: '西乡塘区',
            value: '450107',
            parentId: '450100'
          },
          {
            id: '450108',
            label: '良庆区',
            value: '450108',
            parentId: '450100'
          },
          {
            id: '450109',
            label: '邕宁区',
            value: '450109',
            parentId: '450100'
          },
          {
            id: '450110',
            label: '武鸣区',
            value: '450110',
            parentId: '450100'
          },
          {
            id: '450123',
            label: '隆安县',
            value: '450123',
            parentId: '450100'
          },
          {
            id: '450124',
            label: '马山县',
            value: '450124',
            parentId: '450100'
          },
          {
            id: '450125',
            label: '上林县',
            value: '450125',
            parentId: '450100'
          },
          {
            id: '450126',
            label: '宾阳县',
            value: '450126',
            parentId: '450100'
          },
          {
            id: '450181',
            label: '横州市',
            value: '450181',
            parentId: '450100'
          }
        ]
      },
      {
        id: '450200',
        label: '柳州市',
        value: '450200',
        parentId: '450000',
        children: [
          {
            id: '450202',
            label: '城中区',
            value: '450202',
            parentId: '450200'
          },
          {
            id: '450203',
            label: '鱼峰区',
            value: '450203',
            parentId: '450200'
          },
          {
            id: '450204',
            label: '柳南区',
            value: '450204',
            parentId: '450200'
          },
          {
            id: '450205',
            label: '柳北区',
            value: '450205',
            parentId: '450200'
          },
          {
            id: '450206',
            label: '柳江区',
            value: '450206',
            parentId: '450200'
          },
          {
            id: '450222',
            label: '柳城县',
            value: '450222',
            parentId: '450200'
          },
          {
            id: '450223',
            label: '鹿寨县',
            value: '450223',
            parentId: '450200'
          },
          {
            id: '450224',
            label: '融安县',
            value: '450224',
            parentId: '450200'
          },
          {
            id: '450225',
            label: '融水苗族自治县',
            value: '450225',
            parentId: '450200'
          },
          {
            id: '450226',
            label: '三江侗族自治县',
            value: '450226',
            parentId: '450200'
          }
        ]
      },
      {
        id: '450300',
        label: '桂林市',
        value: '450300',
        parentId: '450000',
        children: [
          {
            id: '450302',
            label: '秀峰区',
            value: '450302',
            parentId: '450300'
          },
          {
            id: '450303',
            label: '叠彩区',
            value: '450303',
            parentId: '450300'
          },
          {
            id: '450304',
            label: '象山区',
            value: '450304',
            parentId: '450300'
          },
          {
            id: '450305',
            label: '七星区',
            value: '450305',
            parentId: '450300'
          },
          {
            id: '450311',
            label: '雁山区',
            value: '450311',
            parentId: '450300'
          },
          {
            id: '450312',
            label: '临桂区',
            value: '450312',
            parentId: '450300'
          },
          {
            id: '450321',
            label: '阳朔县',
            value: '450321',
            parentId: '450300'
          },
          {
            id: '450323',
            label: '灵川县',
            value: '450323',
            parentId: '450300'
          },
          {
            id: '450324',
            label: '全州县',
            value: '450324',
            parentId: '450300'
          },
          {
            id: '450325',
            label: '兴安县',
            value: '450325',
            parentId: '450300'
          },
          {
            id: '450326',
            label: '永福县',
            value: '450326',
            parentId: '450300'
          },
          {
            id: '450327',
            label: '灌阳县',
            value: '450327',
            parentId: '450300'
          },
          {
            id: '450328',
            label: '龙胜各族自治县',
            value: '450328',
            parentId: '450300'
          },
          {
            id: '450329',
            label: '资源县',
            value: '450329',
            parentId: '450300'
          },
          {
            id: '450330',
            label: '平乐县',
            value: '450330',
            parentId: '450300'
          },
          {
            id: '450332',
            label: '恭城瑶族自治县',
            value: '450332',
            parentId: '450300'
          },
          {
            id: '450381',
            label: '荔浦市',
            value: '450381',
            parentId: '450300'
          }
        ]
      },
      {
        id: '450400',
        label: '梧州市',
        value: '450400',
        parentId: '450000',
        children: [
          {
            id: '450403',
            label: '万秀区',
            value: '450403',
            parentId: '450400'
          },
          {
            id: '450405',
            label: '长洲区',
            value: '450405',
            parentId: '450400'
          },
          {
            id: '450406',
            label: '龙圩区',
            value: '450406',
            parentId: '450400'
          },
          {
            id: '450421',
            label: '苍梧县',
            value: '450421',
            parentId: '450400'
          },
          {
            id: '450422',
            label: '藤县',
            value: '450422',
            parentId: '450400'
          },
          {
            id: '450423',
            label: '蒙山县',
            value: '450423',
            parentId: '450400'
          },
          {
            id: '450481',
            label: '岑溪市',
            value: '450481',
            parentId: '450400'
          }
        ]
      },
      {
        id: '450500',
        label: '北海市',
        value: '450500',
        parentId: '450000',
        children: [
          {
            id: '450502',
            label: '海城区',
            value: '450502',
            parentId: '450500'
          },
          {
            id: '450503',
            label: '银海区',
            value: '450503',
            parentId: '450500'
          },
          {
            id: '450512',
            label: '铁山港区',
            value: '450512',
            parentId: '450500'
          },
          {
            id: '450521',
            label: '合浦县',
            value: '450521',
            parentId: '450500'
          }
        ]
      },
      {
        id: '450600',
        label: '防城港市',
        value: '450600',
        parentId: '450000',
        children: [
          {
            id: '450602',
            label: '港口区',
            value: '450602',
            parentId: '450600'
          },
          {
            id: '450603',
            label: '防城区',
            value: '450603',
            parentId: '450600'
          },
          {
            id: '450621',
            label: '上思县',
            value: '450621',
            parentId: '450600'
          },
          {
            id: '450681',
            label: '东兴市',
            value: '450681',
            parentId: '450600'
          }
        ]
      },
      {
        id: '450700',
        label: '钦州市',
        value: '450700',
        parentId: '450000',
        children: [
          {
            id: '450702',
            label: '钦南区',
            value: '450702',
            parentId: '450700'
          },
          {
            id: '450703',
            label: '钦北区',
            value: '450703',
            parentId: '450700'
          },
          {
            id: '450721',
            label: '灵山县',
            value: '450721',
            parentId: '450700'
          },
          {
            id: '450722',
            label: '浦北县',
            value: '450722',
            parentId: '450700'
          }
        ]
      },
      {
        id: '450800',
        label: '贵港市',
        value: '450800',
        parentId: '450000',
        children: [
          {
            id: '450802',
            label: '港北区',
            value: '450802',
            parentId: '450800'
          },
          {
            id: '450803',
            label: '港南区',
            value: '450803',
            parentId: '450800'
          },
          {
            id: '450804',
            label: '覃塘区',
            value: '450804',
            parentId: '450800'
          },
          {
            id: '450821',
            label: '平南县',
            value: '450821',
            parentId: '450800'
          },
          {
            id: '450881',
            label: '桂平市',
            value: '450881',
            parentId: '450800'
          }
        ]
      },
      {
        id: '450900',
        label: '玉林市',
        value: '450900',
        parentId: '450000',
        children: [
          {
            id: '450902',
            label: '玉州区',
            value: '450902',
            parentId: '450900'
          },
          {
            id: '450903',
            label: '福绵区',
            value: '450903',
            parentId: '450900'
          },
          {
            id: '450921',
            label: '容县',
            value: '450921',
            parentId: '450900'
          },
          {
            id: '450922',
            label: '陆川县',
            value: '450922',
            parentId: '450900'
          },
          {
            id: '450923',
            label: '博白县',
            value: '450923',
            parentId: '450900'
          },
          {
            id: '450924',
            label: '兴业县',
            value: '450924',
            parentId: '450900'
          },
          {
            id: '450981',
            label: '北流市',
            value: '450981',
            parentId: '450900'
          }
        ]
      },
      {
        id: '451000',
        label: '百色市',
        value: '451000',
        parentId: '450000',
        children: [
          {
            id: '451002',
            label: '右江区',
            value: '451002',
            parentId: '451000'
          },
          {
            id: '451003',
            label: '田阳区',
            value: '451003',
            parentId: '451000'
          },
          {
            id: '451022',
            label: '田东县',
            value: '451022',
            parentId: '451000'
          },
          {
            id: '451024',
            label: '德保县',
            value: '451024',
            parentId: '451000'
          },
          {
            id: '451026',
            label: '那坡县',
            value: '451026',
            parentId: '451000'
          },
          {
            id: '451027',
            label: '凌云县',
            value: '451027',
            parentId: '451000'
          },
          {
            id: '451028',
            label: '乐业县',
            value: '451028',
            parentId: '451000'
          },
          {
            id: '451029',
            label: '田林县',
            value: '451029',
            parentId: '451000'
          },
          {
            id: '451030',
            label: '西林县',
            value: '451030',
            parentId: '451000'
          },
          {
            id: '451031',
            label: '隆林各族自治县',
            value: '451031',
            parentId: '451000'
          },
          {
            id: '451081',
            label: '靖西市',
            value: '451081',
            parentId: '451000'
          },
          {
            id: '451082',
            label: '平果市',
            value: '451082',
            parentId: '451000'
          }
        ]
      },
      {
        id: '451100',
        label: '贺州市',
        value: '451100',
        parentId: '450000',
        children: [
          {
            id: '451102',
            label: '八步区',
            value: '451102',
            parentId: '451100'
          },
          {
            id: '451103',
            label: '平桂区',
            value: '451103',
            parentId: '451100'
          },
          {
            id: '451121',
            label: '昭平县',
            value: '451121',
            parentId: '451100'
          },
          {
            id: '451122',
            label: '钟山县',
            value: '451122',
            parentId: '451100'
          },
          {
            id: '451123',
            label: '富川瑶族自治县',
            value: '451123',
            parentId: '451100'
          }
        ]
      },
      {
        id: '451200',
        label: '河池市',
        value: '451200',
        parentId: '450000',
        children: [
          {
            id: '451202',
            label: '金城江区',
            value: '451202',
            parentId: '451200'
          },
          {
            id: '451203',
            label: '宜州区',
            value: '451203',
            parentId: '451200'
          },
          {
            id: '451221',
            label: '南丹县',
            value: '451221',
            parentId: '451200'
          },
          {
            id: '451222',
            label: '天峨县',
            value: '451222',
            parentId: '451200'
          },
          {
            id: '451223',
            label: '凤山县',
            value: '451223',
            parentId: '451200'
          },
          {
            id: '451224',
            label: '东兰县',
            value: '451224',
            parentId: '451200'
          },
          {
            id: '451225',
            label: '罗城仫佬族自治县',
            value: '451225',
            parentId: '451200'
          },
          {
            id: '451226',
            label: '环江毛南族自治县',
            value: '451226',
            parentId: '451200'
          },
          {
            id: '451227',
            label: '巴马瑶族自治县',
            value: '451227',
            parentId: '451200'
          },
          {
            id: '451228',
            label: '都安瑶族自治县',
            value: '451228',
            parentId: '451200'
          },
          {
            id: '451229',
            label: '大化瑶族自治县',
            value: '451229',
            parentId: '451200'
          }
        ]
      },
      {
        id: '451300',
        label: '来宾市',
        value: '451300',
        parentId: '450000',
        children: [
          {
            id: '451302',
            label: '兴宾区',
            value: '451302',
            parentId: '451300'
          },
          {
            id: '451321',
            label: '忻城县',
            value: '451321',
            parentId: '451300'
          },
          {
            id: '451322',
            label: '象州县',
            value: '451322',
            parentId: '451300'
          },
          {
            id: '451323',
            label: '武宣县',
            value: '451323',
            parentId: '451300'
          },
          {
            id: '451324',
            label: '金秀瑶族自治县',
            value: '451324',
            parentId: '451300'
          },
          {
            id: '451381',
            label: '合山市',
            value: '451381',
            parentId: '451300'
          }
        ]
      },
      {
        id: '451400',
        label: '崇左市',
        value: '451400',
        parentId: '450000',
        children: [
          {
            id: '451402',
            label: '江州区',
            value: '451402',
            parentId: '451400'
          },
          {
            id: '451421',
            label: '扶绥县',
            value: '451421',
            parentId: '451400'
          },
          {
            id: '451422',
            label: '宁明县',
            value: '451422',
            parentId: '451400'
          },
          {
            id: '451423',
            label: '龙州县',
            value: '451423',
            parentId: '451400'
          },
          {
            id: '451424',
            label: '大新县',
            value: '451424',
            parentId: '451400'
          },
          {
            id: '451425',
            label: '天等县',
            value: '451425',
            parentId: '451400'
          },
          {
            id: '451481',
            label: '凭祥市',
            value: '451481',
            parentId: '451400'
          }
        ]
      }
    ]
  },
  {
    id: '460000',
    label: '海南省',
    value: '460000',
    children: [
      {
        id: '460100',
        label: '海口市',
        value: '460100',
        parentId: '460000',
        children: [
          {
            id: '460105',
            label: '秀英区',
            value: '460105',
            parentId: '460100'
          },
          {
            id: '460106',
            label: '龙华区',
            value: '460106',
            parentId: '460100'
          },
          {
            id: '460107',
            label: '琼山区',
            value: '460107',
            parentId: '460100'
          },
          {
            id: '460108',
            label: '美兰区',
            value: '460108',
            parentId: '460100'
          }
        ]
      },
      {
        id: '460200',
        label: '三亚市',
        value: '460200',
        parentId: '460000',
        children: [
          {
            id: '460202',
            label: '海棠区',
            value: '460202',
            parentId: '460200'
          },
          {
            id: '460203',
            label: '吉阳区',
            value: '460203',
            parentId: '460200'
          },
          {
            id: '460204',
            label: '天涯区',
            value: '460204',
            parentId: '460200'
          },
          {
            id: '460205',
            label: '崖州区',
            value: '460205',
            parentId: '460200'
          }
        ]
      },
      {
        id: '460300',
        label: '三沙市',
        value: '460300',
        parentId: '460000',
        children: [
          {
            id: '460321',
            label: '西沙群岛',
            value: '460321',
            parentId: '460300'
          },
          {
            id: '460322',
            label: '南沙群岛',
            value: '460322',
            parentId: '460300'
          },
          {
            id: '460323',
            label: '中沙群岛',
            value: '460323',
            parentId: '460300'
          },
          {
            id: '460324',
            label: '东沙群岛',
            value: '460324',
            parentId: '460300'
          }
        ]
      },
      {
        id: '460400',
        label: '儋州市',
        value: '460400',
        parentId: '460000',
        children: [
          {
            id: '460400100000',
            label: '那大镇',
            value: '460400100000',
            parentId: '460400'
          },
          {
            id: '460400101000',
            label: '和庆镇',
            value: '460400101000',
            parentId: '460400'
          },
          {
            id: '460400102000',
            label: '南丰镇',
            value: '460400102000',
            parentId: '460400'
          },
          {
            id: '460400103000',
            label: '大成镇',
            value: '460400103000',
            parentId: '460400'
          },
          {
            id: '460400104000',
            label: '雅星镇',
            value: '460400104000',
            parentId: '460400'
          },
          {
            id: '460400105000',
            label: '兰洋镇',
            value: '460400105000',
            parentId: '460400'
          },
          {
            id: '460400106000',
            label: '光村镇',
            value: '460400106000',
            parentId: '460400'
          },
          {
            id: '460400107000',
            label: '木棠镇',
            value: '460400107000',
            parentId: '460400'
          },
          {
            id: '460400108000',
            label: '海头镇',
            value: '460400108000',
            parentId: '460400'
          },
          {
            id: '460400109000',
            label: '峨蔓镇',
            value: '460400109000',
            parentId: '460400'
          },
          {
            id: '460400111000',
            label: '王五镇',
            value: '460400111000',
            parentId: '460400'
          },
          {
            id: '460400112000',
            label: '白马井镇',
            value: '460400112000',
            parentId: '460400'
          },
          {
            id: '460400113000',
            label: '中和镇',
            value: '460400113000',
            parentId: '460400'
          },
          {
            id: '460400114000',
            label: '排浦镇',
            value: '460400114000',
            parentId: '460400'
          },
          {
            id: '460400115000',
            label: '东成镇',
            value: '460400115000',
            parentId: '460400'
          },
          {
            id: '460400116000',
            label: '新州镇',
            value: '460400116000',
            parentId: '460400'
          },
          {
            id: '460400499000',
            label: '洋浦经济开发区',
            value: '460400499000',
            parentId: '460400'
          },
          {
            id: '460400500000',
            label: '华南热作学院',
            value: '460400500000',
            parentId: '460400'
          }
        ]
      },
      {
        id: '469001',
        label: '五指山市',
        value: '469001',
        parentId: '460000',
        children: [
          {
            id: '469001',
            label: '五指山市',
            value: '469001',
            parentId: '469001'
          }
        ]
      },
      {
        id: '469002',
        label: '琼海市',
        value: '469002',
        parentId: '460000',
        children: [
          {
            id: '469002',
            label: '琼海市',
            value: '469002',
            parentId: '469002'
          }
        ]
      },
      {
        id: '469005',
        label: '文昌市',
        value: '469005',
        parentId: '460000',
        children: [
          {
            id: '469005',
            label: '文昌市',
            value: '469005',
            parentId: '469005'
          }
        ]
      },
      {
        id: '469006',
        label: '万宁市',
        value: '469006',
        parentId: '460000',
        children: [
          {
            id: '469006',
            label: '万宁市',
            value: '469006',
            parentId: '469006'
          }
        ]
      },
      {
        id: '469007',
        label: '东方市',
        value: '469007',
        parentId: '460000',
        children: [
          {
            id: '469007',
            label: '东方市',
            value: '469007',
            parentId: '469007'
          }
        ]
      },
      {
        id: '469021',
        label: '定安县',
        value: '469021',
        parentId: '460000',
        children: [
          {
            id: '469021',
            label: '定安县',
            value: '469021',
            parentId: '469021'
          }
        ]
      },
      {
        id: '469022',
        label: '屯昌县',
        value: '469022',
        parentId: '460000',
        children: [
          {
            id: '469022',
            label: '屯昌县',
            value: '469022',
            parentId: '469022'
          }
        ]
      },
      {
        id: '469023',
        label: '澄迈县',
        value: '469023',
        parentId: '460000',
        children: [
          {
            id: '469023',
            label: '澄迈县',
            value: '469023',
            parentId: '469023'
          }
        ]
      },
      {
        id: '469024',
        label: '临高县',
        value: '469024',
        parentId: '460000',
        children: [
          {
            id: '469024',
            label: '临高县',
            value: '469024',
            parentId: '469024'
          }
        ]
      },
      {
        id: '469025',
        label: '白沙黎族自治县',
        value: '469025',
        parentId: '460000',
        children: [
          {
            id: '469025',
            label: '白沙黎族自治县',
            value: '469025',
            parentId: '469025'
          }
        ]
      },
      {
        id: '469026',
        label: '昌江黎族自治县',
        value: '469026',
        parentId: '460000',
        children: [
          {
            id: '469026',
            label: '昌江黎族自治县',
            value: '469026',
            parentId: '469026'
          }
        ]
      },
      {
        id: '469027',
        label: '乐东黎族自治县',
        value: '469027',
        parentId: '460000',
        children: [
          {
            id: '469027',
            label: '乐东黎族自治县',
            value: '469027',
            parentId: '469027'
          }
        ]
      },
      {
        id: '469028',
        label: '陵水黎族自治县',
        value: '469028',
        parentId: '460000',
        children: [
          {
            id: '469028',
            label: '陵水黎族自治县',
            value: '469028',
            parentId: '469028'
          }
        ]
      },
      {
        id: '469029',
        label: '保亭黎族苗族自治县',
        value: '469029',
        parentId: '460000',
        children: [
          {
            id: '469029',
            label: '保亭黎族苗族自治县',
            value: '469029',
            parentId: '469029'
          }
        ]
      },
      {
        id: '469030',
        label: '琼中黎族苗族自治县',
        value: '469030',
        parentId: '460000',
        children: [
          {
            id: '469030',
            label: '琼中黎族苗族自治县',
            value: '469030',
            parentId: '469030'
          }
        ]
      }
    ]
  },
  {
    id: '500000',
    label: '重庆市',
    value: '500000',
    children: [
      {
        id: '500100',
        label: '重庆市',
        value: '500100',
        parentId: '500000',
        children: [
          {
            id: '500101',
            label: '万州区',
            value: '500101',
            parentId: '500100'
          },
          {
            id: '500102',
            label: '涪陵区',
            value: '500102',
            parentId: '500100'
          },
          {
            id: '500103',
            label: '渝中区',
            value: '500103',
            parentId: '500100'
          },
          {
            id: '500104',
            label: '大渡口区',
            value: '500104',
            parentId: '500100'
          },
          {
            id: '500105',
            label: '江北区',
            value: '500105',
            parentId: '500100'
          },
          {
            id: '500106',
            label: '沙坪坝区',
            value: '500106',
            parentId: '500100'
          },
          {
            id: '500107',
            label: '九龙坡区',
            value: '500107',
            parentId: '500100'
          },
          {
            id: '500108',
            label: '南岸区',
            value: '500108',
            parentId: '500100'
          },
          {
            id: '500109',
            label: '北碚区',
            value: '500109',
            parentId: '500100'
          },
          {
            id: '500110',
            label: '綦江区',
            value: '500110',
            parentId: '500100'
          },
          {
            id: '500111',
            label: '大足区',
            value: '500111',
            parentId: '500100'
          },
          {
            id: '500112',
            label: '渝北区',
            value: '500112',
            parentId: '500100'
          },
          {
            id: '500113',
            label: '巴南区',
            value: '500113',
            parentId: '500100'
          },
          {
            id: '500114',
            label: '黔江区',
            value: '500114',
            parentId: '500100'
          },
          {
            id: '500115',
            label: '长寿区',
            value: '500115',
            parentId: '500100'
          },
          {
            id: '500116',
            label: '江津区',
            value: '500116',
            parentId: '500100'
          },
          {
            id: '500117',
            label: '合川区',
            value: '500117',
            parentId: '500100'
          },
          {
            id: '500118',
            label: '永川区',
            value: '500118',
            parentId: '500100'
          },
          {
            id: '500119',
            label: '南川区',
            value: '500119',
            parentId: '500100'
          },
          {
            id: '500120',
            label: '璧山区',
            value: '500120',
            parentId: '500100'
          },
          {
            id: '500151',
            label: '铜梁区',
            value: '500151',
            parentId: '500100'
          },
          {
            id: '500152',
            label: '潼南区',
            value: '500152',
            parentId: '500100'
          },
          {
            id: '500153',
            label: '荣昌区',
            value: '500153',
            parentId: '500100'
          },
          {
            id: '500154',
            label: '开州区',
            value: '500154',
            parentId: '500100'
          },
          {
            id: '500155',
            label: '梁平区',
            value: '500155',
            parentId: '500100'
          },
          {
            id: '500156',
            label: '武隆区',
            value: '500156',
            parentId: '500100'
          },
          {
            id: '500157',
            label: '城口县',
            value: '500157',
            parentId: '500100'
          },
          {
            id: '500158',
            label: '丰都县',
            value: '500158',
            parentId: '500100'
          },
          {
            id: '500159',
            label: '垫江县',
            value: '500159',
            parentId: '500100'
          },
          {
            id: '500160',
            label: '忠县',
            value: '500160',
            parentId: '500100'
          },
          {
            id: '500161',
            label: '云阳县',
            value: '500161',
            parentId: '500100'
          },
          {
            id: '500162',
            label: '奉节县',
            value: '500162',
            parentId: '500100'
          },
          {
            id: '500163',
            label: '巫山县',
            value: '500163',
            parentId: '500100'
          },
          {
            id: '500164',
            label: '巫溪县',
            value: '500164',
            parentId: '500100'
          },
          {
            id: '500165',
            label: '石柱土家族自治县',
            value: '500165',
            parentId: '500100'
          },
          {
            id: '500166',
            label: '秀山土家族苗族自治县',
            value: '500166',
            parentId: '500100'
          },
          {
            id: '500167',
            label: '酉阳土家族苗族自治县',
            value: '500167',
            parentId: '500100'
          },
          {
            id: '500168',
            label: '彭水苗族土家族自治县',
            value: '500168',
            parentId: '500100'
          }
        ]
      }
    ]
  },
  {
    id: '510000',
    label: '四川省',
    value: '510000',
    children: [
      {
        id: '510100',
        label: '成都市',
        value: '510100',
        parentId: '510000',
        children: [
          {
            id: '510104',
            label: '锦江区',
            value: '510104',
            parentId: '510100'
          },
          {
            id: '510105',
            label: '青羊区',
            value: '510105',
            parentId: '510100'
          },
          {
            id: '510106',
            label: '金牛区',
            value: '510106',
            parentId: '510100'
          },
          {
            id: '510107',
            label: '武侯区',
            value: '510107',
            parentId: '510100'
          },
          {
            id: '510108',
            label: '成华区',
            value: '510108',
            parentId: '510100'
          },
          {
            id: '510112',
            label: '龙泉驿区',
            value: '510112',
            parentId: '510100'
          },
          {
            id: '510113',
            label: '青白江区',
            value: '510113',
            parentId: '510100'
          },
          {
            id: '510114',
            label: '新都区',
            value: '510114',
            parentId: '510100'
          },
          {
            id: '510115',
            label: '温江区',
            value: '510115',
            parentId: '510100'
          },
          {
            id: '510116',
            label: '双流区',
            value: '510116',
            parentId: '510100'
          },
          {
            id: '510117',
            label: '郫都区',
            value: '510117',
            parentId: '510100'
          },
          {
            id: '510118',
            label: '新津区',
            value: '510118',
            parentId: '510100'
          },
          {
            id: '510121',
            label: '金堂县',
            value: '510121',
            parentId: '510100'
          },
          {
            id: '510129',
            label: '大邑县',
            value: '510129',
            parentId: '510100'
          },
          {
            id: '510131',
            label: '蒲江县',
            value: '510131',
            parentId: '510100'
          },
          {
            id: '510181',
            label: '都江堰市',
            value: '510181',
            parentId: '510100'
          },
          {
            id: '510182',
            label: '彭州市',
            value: '510182',
            parentId: '510100'
          },
          {
            id: '510183',
            label: '邛崃市',
            value: '510183',
            parentId: '510100'
          },
          {
            id: '510184',
            label: '崇州市',
            value: '510184',
            parentId: '510100'
          },
          {
            id: '510185',
            label: '简阳市',
            value: '510185',
            parentId: '510100'
          }
        ]
      },
      {
        id: '510300',
        label: '自贡市',
        value: '510300',
        parentId: '510000',
        children: [
          {
            id: '510302',
            label: '自流井区',
            value: '510302',
            parentId: '510300'
          },
          {
            id: '510303',
            label: '贡井区',
            value: '510303',
            parentId: '510300'
          },
          {
            id: '510304',
            label: '大安区',
            value: '510304',
            parentId: '510300'
          },
          {
            id: '510311',
            label: '沿滩区',
            value: '510311',
            parentId: '510300'
          },
          {
            id: '510321',
            label: '荣县',
            value: '510321',
            parentId: '510300'
          },
          {
            id: '510322',
            label: '富顺县',
            value: '510322',
            parentId: '510300'
          }
        ]
      },
      {
        id: '510400',
        label: '攀枝花市',
        value: '510400',
        parentId: '510000',
        children: [
          {
            id: '510402',
            label: '东区',
            value: '510402',
            parentId: '510400'
          },
          {
            id: '510403',
            label: '西区',
            value: '510403',
            parentId: '510400'
          },
          {
            id: '510411',
            label: '仁和区',
            value: '510411',
            parentId: '510400'
          },
          {
            id: '510421',
            label: '米易县',
            value: '510421',
            parentId: '510400'
          },
          {
            id: '510422',
            label: '盐边县',
            value: '510422',
            parentId: '510400'
          }
        ]
      },
      {
        id: '510500',
        label: '泸州市',
        value: '510500',
        parentId: '510000',
        children: [
          {
            id: '510502',
            label: '江阳区',
            value: '510502',
            parentId: '510500'
          },
          {
            id: '510503',
            label: '纳溪区',
            value: '510503',
            parentId: '510500'
          },
          {
            id: '510504',
            label: '龙马潭区',
            value: '510504',
            parentId: '510500'
          },
          {
            id: '510521',
            label: '泸县',
            value: '510521',
            parentId: '510500'
          },
          {
            id: '510522',
            label: '合江县',
            value: '510522',
            parentId: '510500'
          },
          {
            id: '510524',
            label: '叙永县',
            value: '510524',
            parentId: '510500'
          },
          {
            id: '510525',
            label: '古蔺县',
            value: '510525',
            parentId: '510500'
          }
        ]
      },
      {
        id: '510600',
        label: '德阳市',
        value: '510600',
        parentId: '510000',
        children: [
          {
            id: '510603',
            label: '旌阳区',
            value: '510603',
            parentId: '510600'
          },
          {
            id: '510604',
            label: '罗江区',
            value: '510604',
            parentId: '510600'
          },
          {
            id: '510623',
            label: '中江县',
            value: '510623',
            parentId: '510600'
          },
          {
            id: '510681',
            label: '广汉市',
            value: '510681',
            parentId: '510600'
          },
          {
            id: '510682',
            label: '什邡市',
            value: '510682',
            parentId: '510600'
          },
          {
            id: '510683',
            label: '绵竹市',
            value: '510683',
            parentId: '510600'
          }
        ]
      },
      {
        id: '510700',
        label: '绵阳市',
        value: '510700',
        parentId: '510000',
        children: [
          {
            id: '510703',
            label: '涪城区',
            value: '510703',
            parentId: '510700'
          },
          {
            id: '510704',
            label: '游仙区',
            value: '510704',
            parentId: '510700'
          },
          {
            id: '510705',
            label: '安州区',
            value: '510705',
            parentId: '510700'
          },
          {
            id: '510722',
            label: '三台县',
            value: '510722',
            parentId: '510700'
          },
          {
            id: '510723',
            label: '盐亭县',
            value: '510723',
            parentId: '510700'
          },
          {
            id: '510725',
            label: '梓潼县',
            value: '510725',
            parentId: '510700'
          },
          {
            id: '510726',
            label: '北川羌族自治县',
            value: '510726',
            parentId: '510700'
          },
          {
            id: '510727',
            label: '平武县',
            value: '510727',
            parentId: '510700'
          },
          {
            id: '510781',
            label: '江油市',
            value: '510781',
            parentId: '510700'
          }
        ]
      },
      {
        id: '510800',
        label: '广元市',
        value: '510800',
        parentId: '510000',
        children: [
          {
            id: '510802',
            label: '利州区',
            value: '510802',
            parentId: '510800'
          },
          {
            id: '510811',
            label: '昭化区',
            value: '510811',
            parentId: '510800'
          },
          {
            id: '510812',
            label: '朝天区',
            value: '510812',
            parentId: '510800'
          },
          {
            id: '510821',
            label: '旺苍县',
            value: '510821',
            parentId: '510800'
          },
          {
            id: '510822',
            label: '青川县',
            value: '510822',
            parentId: '510800'
          },
          {
            id: '510823',
            label: '剑阁县',
            value: '510823',
            parentId: '510800'
          },
          {
            id: '510824',
            label: '苍溪县',
            value: '510824',
            parentId: '510800'
          }
        ]
      },
      {
        id: '510900',
        label: '遂宁市',
        value: '510900',
        parentId: '510000',
        children: [
          {
            id: '510903',
            label: '船山区',
            value: '510903',
            parentId: '510900'
          },
          {
            id: '510904',
            label: '安居区',
            value: '510904',
            parentId: '510900'
          },
          {
            id: '510921',
            label: '蓬溪县',
            value: '510921',
            parentId: '510900'
          },
          {
            id: '510923',
            label: '大英县',
            value: '510923',
            parentId: '510900'
          },
          {
            id: '510981',
            label: '射洪市',
            value: '510981',
            parentId: '510900'
          }
        ]
      },
      {
        id: '511000',
        label: '内江市',
        value: '511000',
        parentId: '510000',
        children: [
          {
            id: '511002',
            label: '市中区',
            value: '511002',
            parentId: '511000'
          },
          {
            id: '511011',
            label: '东兴区',
            value: '511011',
            parentId: '511000'
          },
          {
            id: '511024',
            label: '威远县',
            value: '511024',
            parentId: '511000'
          },
          {
            id: '511025',
            label: '资中县',
            value: '511025',
            parentId: '511000'
          },
          {
            id: '511083',
            label: '隆昌市',
            value: '511083',
            parentId: '511000'
          }
        ]
      },
      {
        id: '511100',
        label: '乐山市',
        value: '511100',
        parentId: '510000',
        children: [
          {
            id: '511102',
            label: '市中区',
            value: '511102',
            parentId: '511100'
          },
          {
            id: '511111',
            label: '沙湾区',
            value: '511111',
            parentId: '511100'
          },
          {
            id: '511112',
            label: '五通桥区',
            value: '511112',
            parentId: '511100'
          },
          {
            id: '511113',
            label: '金口河区',
            value: '511113',
            parentId: '511100'
          },
          {
            id: '511123',
            label: '犍为县',
            value: '511123',
            parentId: '511100'
          },
          {
            id: '511124',
            label: '井研县',
            value: '511124',
            parentId: '511100'
          },
          {
            id: '511126',
            label: '夹江县',
            value: '511126',
            parentId: '511100'
          },
          {
            id: '511129',
            label: '沐川县',
            value: '511129',
            parentId: '511100'
          },
          {
            id: '511132',
            label: '峨边彝族自治县',
            value: '511132',
            parentId: '511100'
          },
          {
            id: '511133',
            label: '马边彝族自治县',
            value: '511133',
            parentId: '511100'
          },
          {
            id: '511181',
            label: '峨眉山市',
            value: '511181',
            parentId: '511100'
          }
        ]
      },
      {
        id: '511300',
        label: '南充市',
        value: '511300',
        parentId: '510000',
        children: [
          {
            id: '511302',
            label: '顺庆区',
            value: '511302',
            parentId: '511300'
          },
          {
            id: '511303',
            label: '高坪区',
            value: '511303',
            parentId: '511300'
          },
          {
            id: '511304',
            label: '嘉陵区',
            value: '511304',
            parentId: '511300'
          },
          {
            id: '511321',
            label: '南部县',
            value: '511321',
            parentId: '511300'
          },
          {
            id: '511322',
            label: '营山县',
            value: '511322',
            parentId: '511300'
          },
          {
            id: '511323',
            label: '蓬安县',
            value: '511323',
            parentId: '511300'
          },
          {
            id: '511324',
            label: '仪陇县',
            value: '511324',
            parentId: '511300'
          },
          {
            id: '511325',
            label: '西充县',
            value: '511325',
            parentId: '511300'
          },
          {
            id: '511381',
            label: '阆中市',
            value: '511381',
            parentId: '511300'
          }
        ]
      },
      {
        id: '511400',
        label: '眉山市',
        value: '511400',
        parentId: '510000',
        children: [
          {
            id: '511402',
            label: '东坡区',
            value: '511402',
            parentId: '511400'
          },
          {
            id: '511403',
            label: '彭山区',
            value: '511403',
            parentId: '511400'
          },
          {
            id: '511421',
            label: '仁寿县',
            value: '511421',
            parentId: '511400'
          },
          {
            id: '511423',
            label: '洪雅县',
            value: '511423',
            parentId: '511400'
          },
          {
            id: '511424',
            label: '丹棱县',
            value: '511424',
            parentId: '511400'
          },
          {
            id: '511425',
            label: '青神县',
            value: '511425',
            parentId: '511400'
          }
        ]
      },
      {
        id: '511500',
        label: '宜宾市',
        value: '511500',
        parentId: '510000',
        children: [
          {
            id: '511502',
            label: '翠屏区',
            value: '511502',
            parentId: '511500'
          },
          {
            id: '511503',
            label: '南溪区',
            value: '511503',
            parentId: '511500'
          },
          {
            id: '511504',
            label: '叙州区',
            value: '511504',
            parentId: '511500'
          },
          {
            id: '511523',
            label: '江安县',
            value: '511523',
            parentId: '511500'
          },
          {
            id: '511524',
            label: '长宁县',
            value: '511524',
            parentId: '511500'
          },
          {
            id: '511525',
            label: '高县',
            value: '511525',
            parentId: '511500'
          },
          {
            id: '511526',
            label: '珙县',
            value: '511526',
            parentId: '511500'
          },
          {
            id: '511527',
            label: '筠连县',
            value: '511527',
            parentId: '511500'
          },
          {
            id: '511528',
            label: '兴文县',
            value: '511528',
            parentId: '511500'
          },
          {
            id: '511529',
            label: '屏山县',
            value: '511529',
            parentId: '511500'
          }
        ]
      },
      {
        id: '511600',
        label: '广安市',
        value: '511600',
        parentId: '510000',
        children: [
          {
            id: '511602',
            label: '广安区',
            value: '511602',
            parentId: '511600'
          },
          {
            id: '511603',
            label: '前锋区',
            value: '511603',
            parentId: '511600'
          },
          {
            id: '511621',
            label: '岳池县',
            value: '511621',
            parentId: '511600'
          },
          {
            id: '511622',
            label: '武胜县',
            value: '511622',
            parentId: '511600'
          },
          {
            id: '511623',
            label: '邻水县',
            value: '511623',
            parentId: '511600'
          },
          {
            id: '511681',
            label: '华蓥市',
            value: '511681',
            parentId: '511600'
          }
        ]
      },
      {
        id: '511700',
        label: '达州市',
        value: '511700',
        parentId: '510000',
        children: [
          {
            id: '511702',
            label: '通川区',
            value: '511702',
            parentId: '511700'
          },
          {
            id: '511703',
            label: '达川区',
            value: '511703',
            parentId: '511700'
          },
          {
            id: '511722',
            label: '宣汉县',
            value: '511722',
            parentId: '511700'
          },
          {
            id: '511723',
            label: '开江县',
            value: '511723',
            parentId: '511700'
          },
          {
            id: '511724',
            label: '大竹县',
            value: '511724',
            parentId: '511700'
          },
          {
            id: '511725',
            label: '渠县',
            value: '511725',
            parentId: '511700'
          },
          {
            id: '511781',
            label: '万源市',
            value: '511781',
            parentId: '511700'
          }
        ]
      },
      {
        id: '511800',
        label: '雅安市',
        value: '511800',
        parentId: '510000',
        children: [
          {
            id: '511802',
            label: '雨城区',
            value: '511802',
            parentId: '511800'
          },
          {
            id: '511803',
            label: '名山区',
            value: '511803',
            parentId: '511800'
          },
          {
            id: '511822',
            label: '荥经县',
            value: '511822',
            parentId: '511800'
          },
          {
            id: '511823',
            label: '汉源县',
            value: '511823',
            parentId: '511800'
          },
          {
            id: '511824',
            label: '石棉县',
            value: '511824',
            parentId: '511800'
          },
          {
            id: '511825',
            label: '天全县',
            value: '511825',
            parentId: '511800'
          },
          {
            id: '511826',
            label: '芦山县',
            value: '511826',
            parentId: '511800'
          },
          {
            id: '511827',
            label: '宝兴县',
            value: '511827',
            parentId: '511800'
          }
        ]
      },
      {
        id: '511900',
        label: '巴中市',
        value: '511900',
        parentId: '510000',
        children: [
          {
            id: '511902',
            label: '巴州区',
            value: '511902',
            parentId: '511900'
          },
          {
            id: '511903',
            label: '恩阳区',
            value: '511903',
            parentId: '511900'
          },
          {
            id: '511921',
            label: '通江县',
            value: '511921',
            parentId: '511900'
          },
          {
            id: '511922',
            label: '南江县',
            value: '511922',
            parentId: '511900'
          },
          {
            id: '511923',
            label: '平昌县',
            value: '511923',
            parentId: '511900'
          }
        ]
      },
      {
        id: '512000',
        label: '资阳市',
        value: '512000',
        parentId: '510000',
        children: [
          {
            id: '512002',
            label: '雁江区',
            value: '512002',
            parentId: '512000'
          },
          {
            id: '512021',
            label: '安岳县',
            value: '512021',
            parentId: '512000'
          },
          {
            id: '512022',
            label: '乐至县',
            value: '512022',
            parentId: '512000'
          }
        ]
      },
      {
        id: '513200',
        label: '阿坝藏族羌族自治州',
        value: '513200',
        parentId: '510000',
        children: [
          {
            id: '513201',
            label: '马尔康市',
            value: '513201',
            parentId: '513200'
          },
          {
            id: '513221',
            label: '汶川县',
            value: '513221',
            parentId: '513200'
          },
          {
            id: '513222',
            label: '理县',
            value: '513222',
            parentId: '513200'
          },
          {
            id: '513223',
            label: '茂县',
            value: '513223',
            parentId: '513200'
          },
          {
            id: '513224',
            label: '松潘县',
            value: '513224',
            parentId: '513200'
          },
          {
            id: '513225',
            label: '九寨沟县',
            value: '513225',
            parentId: '513200'
          },
          {
            id: '513226',
            label: '金川县',
            value: '513226',
            parentId: '513200'
          },
          {
            id: '513227',
            label: '小金县',
            value: '513227',
            parentId: '513200'
          },
          {
            id: '513228',
            label: '黑水县',
            value: '513228',
            parentId: '513200'
          },
          {
            id: '513230',
            label: '壤塘县',
            value: '513230',
            parentId: '513200'
          },
          {
            id: '513231',
            label: '阿坝县',
            value: '513231',
            parentId: '513200'
          },
          {
            id: '513232',
            label: '若尔盖县',
            value: '513232',
            parentId: '513200'
          },
          {
            id: '513233',
            label: '红原县',
            value: '513233',
            parentId: '513200'
          }
        ]
      },
      {
        id: '513300',
        label: '甘孜藏族自治州',
        value: '513300',
        parentId: '510000',
        children: [
          {
            id: '513301',
            label: '康定市',
            value: '513301',
            parentId: '513300'
          },
          {
            id: '513322',
            label: '泸定县',
            value: '513322',
            parentId: '513300'
          },
          {
            id: '513323',
            label: '丹巴县',
            value: '513323',
            parentId: '513300'
          },
          {
            id: '513324',
            label: '九龙县',
            value: '513324',
            parentId: '513300'
          },
          {
            id: '513325',
            label: '雅江县',
            value: '513325',
            parentId: '513300'
          },
          {
            id: '513326',
            label: '道孚县',
            value: '513326',
            parentId: '513300'
          },
          {
            id: '513327',
            label: '炉霍县',
            value: '513327',
            parentId: '513300'
          },
          {
            id: '513328',
            label: '甘孜县',
            value: '513328',
            parentId: '513300'
          },
          {
            id: '513329',
            label: '新龙县',
            value: '513329',
            parentId: '513300'
          },
          {
            id: '513330',
            label: '德格县',
            value: '513330',
            parentId: '513300'
          },
          {
            id: '513331',
            label: '白玉县',
            value: '513331',
            parentId: '513300'
          },
          {
            id: '513332',
            label: '石渠县',
            value: '513332',
            parentId: '513300'
          },
          {
            id: '513333',
            label: '色达县',
            value: '513333',
            parentId: '513300'
          },
          {
            id: '513334',
            label: '理塘县',
            value: '513334',
            parentId: '513300'
          },
          {
            id: '513335',
            label: '巴塘县',
            value: '513335',
            parentId: '513300'
          },
          {
            id: '513336',
            label: '乡城县',
            value: '513336',
            parentId: '513300'
          },
          {
            id: '513337',
            label: '稻城县',
            value: '513337',
            parentId: '513300'
          },
          {
            id: '513338',
            label: '得荣县',
            value: '513338',
            parentId: '513300'
          }
        ]
      },
      {
        id: '513400',
        label: '凉山彝族自治州',
        value: '513400',
        parentId: '510000',
        children: [
          {
            id: '513401',
            label: '西昌市',
            value: '513401',
            parentId: '513400'
          },
          {
            id: '513402',
            label: '会理市',
            value: '513402',
            parentId: '513400'
          },
          {
            id: '513422',
            label: '木里藏族自治县',
            value: '513422',
            parentId: '513400'
          },
          {
            id: '513423',
            label: '盐源县',
            value: '513423',
            parentId: '513400'
          },
          {
            id: '513424',
            label: '德昌县',
            value: '513424',
            parentId: '513400'
          },
          {
            id: '513426',
            label: '会东县',
            value: '513426',
            parentId: '513400'
          },
          {
            id: '513427',
            label: '宁南县',
            value: '513427',
            parentId: '513400'
          },
          {
            id: '513428',
            label: '普格县',
            value: '513428',
            parentId: '513400'
          },
          {
            id: '513429',
            label: '布拖县',
            value: '513429',
            parentId: '513400'
          },
          {
            id: '513430',
            label: '金阳县',
            value: '513430',
            parentId: '513400'
          },
          {
            id: '513431',
            label: '昭觉县',
            value: '513431',
            parentId: '513400'
          },
          {
            id: '513432',
            label: '喜德县',
            value: '513432',
            parentId: '513400'
          },
          {
            id: '513433',
            label: '冕宁县',
            value: '513433',
            parentId: '513400'
          },
          {
            id: '513434',
            label: '越西县',
            value: '513434',
            parentId: '513400'
          },
          {
            id: '513435',
            label: '甘洛县',
            value: '513435',
            parentId: '513400'
          },
          {
            id: '513436',
            label: '美姑县',
            value: '513436',
            parentId: '513400'
          },
          {
            id: '513437',
            label: '雷波县',
            value: '513437',
            parentId: '513400'
          }
        ]
      }
    ]
  },
  {
    id: '520000',
    label: '贵州省',
    value: '520000',
    children: [
      {
        id: '520100',
        label: '贵阳市',
        value: '520100',
        parentId: '520000',
        children: [
          {
            id: '520102',
            label: '南明区',
            value: '520102',
            parentId: '520100'
          },
          {
            id: '520103',
            label: '云岩区',
            value: '520103',
            parentId: '520100'
          },
          {
            id: '520111',
            label: '花溪区',
            value: '520111',
            parentId: '520100'
          },
          {
            id: '520112',
            label: '乌当区',
            value: '520112',
            parentId: '520100'
          },
          {
            id: '520113',
            label: '白云区',
            value: '520113',
            parentId: '520100'
          },
          {
            id: '520115',
            label: '观山湖区',
            value: '520115',
            parentId: '520100'
          },
          {
            id: '520121',
            label: '开阳县',
            value: '520121',
            parentId: '520100'
          },
          {
            id: '520122',
            label: '息烽县',
            value: '520122',
            parentId: '520100'
          },
          {
            id: '520123',
            label: '修文县',
            value: '520123',
            parentId: '520100'
          },
          {
            id: '520181',
            label: '清镇市',
            value: '520181',
            parentId: '520100'
          }
        ]
      },
      {
        id: '520200',
        label: '六盘水市',
        value: '520200',
        parentId: '520000',
        children: [
          {
            id: '520201',
            label: '钟山区',
            value: '520201',
            parentId: '520200'
          },
          {
            id: '520203',
            label: '六枝特区',
            value: '520203',
            parentId: '520200'
          },
          {
            id: '520204',
            label: '水城区',
            value: '520204',
            parentId: '520200'
          },
          {
            id: '520281',
            label: '盘州市',
            value: '520281',
            parentId: '520200'
          }
        ]
      },
      {
        id: '520300',
        label: '遵义市',
        value: '520300',
        parentId: '520000',
        children: [
          {
            id: '520302',
            label: '红花岗区',
            value: '520302',
            parentId: '520300'
          },
          {
            id: '520303',
            label: '汇川区',
            value: '520303',
            parentId: '520300'
          },
          {
            id: '520304',
            label: '播州区',
            value: '520304',
            parentId: '520300'
          },
          {
            id: '520322',
            label: '桐梓县',
            value: '520322',
            parentId: '520300'
          },
          {
            id: '520323',
            label: '绥阳县',
            value: '520323',
            parentId: '520300'
          },
          {
            id: '520324',
            label: '正安县',
            value: '520324',
            parentId: '520300'
          },
          {
            id: '520325',
            label: '道真仡佬族苗族自治县',
            value: '520325',
            parentId: '520300'
          },
          {
            id: '520326',
            label: '务川仡佬族苗族自治县',
            value: '520326',
            parentId: '520300'
          },
          {
            id: '520327',
            label: '凤冈县',
            value: '520327',
            parentId: '520300'
          },
          {
            id: '520328',
            label: '湄潭县',
            value: '520328',
            parentId: '520300'
          },
          {
            id: '520329',
            label: '余庆县',
            value: '520329',
            parentId: '520300'
          },
          {
            id: '520330',
            label: '习水县',
            value: '520330',
            parentId: '520300'
          },
          {
            id: '520381',
            label: '赤水市',
            value: '520381',
            parentId: '520300'
          },
          {
            id: '520382',
            label: '仁怀市',
            value: '520382',
            parentId: '520300'
          }
        ]
      },
      {
        id: '520400',
        label: '安顺市',
        value: '520400',
        parentId: '520000',
        children: [
          {
            id: '520402',
            label: '西秀区',
            value: '520402',
            parentId: '520400'
          },
          {
            id: '520403',
            label: '平坝区',
            value: '520403',
            parentId: '520400'
          },
          {
            id: '520422',
            label: '普定县',
            value: '520422',
            parentId: '520400'
          },
          {
            id: '520423',
            label: '镇宁布依族苗族自治县',
            value: '520423',
            parentId: '520400'
          },
          {
            id: '520424',
            label: '关岭布依族苗族自治县',
            value: '520424',
            parentId: '520400'
          },
          {
            id: '520425',
            label: '紫云苗族布依族自治县',
            value: '520425',
            parentId: '520400'
          }
        ]
      },
      {
        id: '520500',
        label: '毕节市',
        value: '520500',
        parentId: '520000',
        children: [
          {
            id: '520502',
            label: '七星关区',
            value: '520502',
            parentId: '520500'
          },
          {
            id: '520521',
            label: '大方县',
            value: '520521',
            parentId: '520500'
          },
          {
            id: '520523',
            label: '金沙县',
            value: '520523',
            parentId: '520500'
          },
          {
            id: '520524',
            label: '织金县',
            value: '520524',
            parentId: '520500'
          },
          {
            id: '520525',
            label: '纳雍县',
            value: '520525',
            parentId: '520500'
          },
          {
            id: '520526',
            label: '威宁彝族回族苗族自治县',
            value: '520526',
            parentId: '520500'
          },
          {
            id: '520527',
            label: '赫章县',
            value: '520527',
            parentId: '520500'
          },
          {
            id: '520581',
            label: '黔西市',
            value: '520581',
            parentId: '520500'
          }
        ]
      },
      {
        id: '520600',
        label: '铜仁市',
        value: '520600',
        parentId: '520000',
        children: [
          {
            id: '520602',
            label: '碧江区',
            value: '520602',
            parentId: '520600'
          },
          {
            id: '520603',
            label: '万山区',
            value: '520603',
            parentId: '520600'
          },
          {
            id: '520621',
            label: '江口县',
            value: '520621',
            parentId: '520600'
          },
          {
            id: '520622',
            label: '玉屏侗族自治县',
            value: '520622',
            parentId: '520600'
          },
          {
            id: '520623',
            label: '石阡县',
            value: '520623',
            parentId: '520600'
          },
          {
            id: '520624',
            label: '思南县',
            value: '520624',
            parentId: '520600'
          },
          {
            id: '520625',
            label: '印江土家族苗族自治县',
            value: '520625',
            parentId: '520600'
          },
          {
            id: '520626',
            label: '德江县',
            value: '520626',
            parentId: '520600'
          },
          {
            id: '520627',
            label: '沿河土家族自治县',
            value: '520627',
            parentId: '520600'
          },
          {
            id: '520628',
            label: '松桃苗族自治县',
            value: '520628',
            parentId: '520600'
          }
        ]
      },
      {
        id: '522300',
        label: '黔西南布依族苗族自治州',
        value: '522300',
        parentId: '520000',
        children: [
          {
            id: '522301',
            label: '兴义市',
            value: '522301',
            parentId: '522300'
          },
          {
            id: '522302',
            label: '兴仁市',
            value: '522302',
            parentId: '522300'
          },
          {
            id: '522323',
            label: '普安县',
            value: '522323',
            parentId: '522300'
          },
          {
            id: '522324',
            label: '晴隆县',
            value: '522324',
            parentId: '522300'
          },
          {
            id: '522325',
            label: '贞丰县',
            value: '522325',
            parentId: '522300'
          },
          {
            id: '522326',
            label: '望谟县',
            value: '522326',
            parentId: '522300'
          },
          {
            id: '522327',
            label: '册亨县',
            value: '522327',
            parentId: '522300'
          },
          {
            id: '522328',
            label: '安龙县',
            value: '522328',
            parentId: '522300'
          }
        ]
      },
      {
        id: '522600',
        label: '黔东南苗族侗族自治州',
        value: '522600',
        parentId: '520000',
        children: [
          {
            id: '522601',
            label: '凯里市',
            value: '522601',
            parentId: '522600'
          },
          {
            id: '522622',
            label: '黄平县',
            value: '522622',
            parentId: '522600'
          },
          {
            id: '522623',
            label: '施秉县',
            value: '522623',
            parentId: '522600'
          },
          {
            id: '522624',
            label: '三穗县',
            value: '522624',
            parentId: '522600'
          },
          {
            id: '522625',
            label: '镇远县',
            value: '522625',
            parentId: '522600'
          },
          {
            id: '522626',
            label: '岑巩县',
            value: '522626',
            parentId: '522600'
          },
          {
            id: '522627',
            label: '天柱县',
            value: '522627',
            parentId: '522600'
          },
          {
            id: '522628',
            label: '锦屏县',
            value: '522628',
            parentId: '522600'
          },
          {
            id: '522629',
            label: '剑河县',
            value: '522629',
            parentId: '522600'
          },
          {
            id: '522630',
            label: '台江县',
            value: '522630',
            parentId: '522600'
          },
          {
            id: '522631',
            label: '黎平县',
            value: '522631',
            parentId: '522600'
          },
          {
            id: '522632',
            label: '榕江县',
            value: '522632',
            parentId: '522600'
          },
          {
            id: '522633',
            label: '从江县',
            value: '522633',
            parentId: '522600'
          },
          {
            id: '522634',
            label: '雷山县',
            value: '522634',
            parentId: '522600'
          },
          {
            id: '522635',
            label: '麻江县',
            value: '522635',
            parentId: '522600'
          },
          {
            id: '522636',
            label: '丹寨县',
            value: '522636',
            parentId: '522600'
          }
        ]
      },
      {
        id: '522700',
        label: '黔南布依族苗族自治州',
        value: '522700',
        parentId: '520000',
        children: [
          {
            id: '522701',
            label: '都匀市',
            value: '522701',
            parentId: '522700'
          },
          {
            id: '522702',
            label: '福泉市',
            value: '522702',
            parentId: '522700'
          },
          {
            id: '522722',
            label: '荔波县',
            value: '522722',
            parentId: '522700'
          },
          {
            id: '522723',
            label: '贵定县',
            value: '522723',
            parentId: '522700'
          },
          {
            id: '522725',
            label: '瓮安县',
            value: '522725',
            parentId: '522700'
          },
          {
            id: '522726',
            label: '独山县',
            value: '522726',
            parentId: '522700'
          },
          {
            id: '522727',
            label: '平塘县',
            value: '522727',
            parentId: '522700'
          },
          {
            id: '522728',
            label: '罗甸县',
            value: '522728',
            parentId: '522700'
          },
          {
            id: '522729',
            label: '长顺县',
            value: '522729',
            parentId: '522700'
          },
          {
            id: '522730',
            label: '龙里县',
            value: '522730',
            parentId: '522700'
          },
          {
            id: '522731',
            label: '惠水县',
            value: '522731',
            parentId: '522700'
          },
          {
            id: '522732',
            label: '三都水族自治县',
            value: '522732',
            parentId: '522700'
          }
        ]
      }
    ]
  },
  {
    id: '530000',
    label: '云南省',
    value: '530000',
    children: [
      {
        id: '530100',
        label: '昆明市',
        value: '530100',
        parentId: '530000',
        children: [
          {
            id: '530102',
            label: '五华区',
            value: '530102',
            parentId: '530100'
          },
          {
            id: '530103',
            label: '盘龙区',
            value: '530103',
            parentId: '530100'
          },
          {
            id: '530111',
            label: '官渡区',
            value: '530111',
            parentId: '530100'
          },
          {
            id: '530112',
            label: '西山区',
            value: '530112',
            parentId: '530100'
          },
          {
            id: '530113',
            label: '东川区',
            value: '530113',
            parentId: '530100'
          },
          {
            id: '530114',
            label: '呈贡区',
            value: '530114',
            parentId: '530100'
          },
          {
            id: '530115',
            label: '晋宁区',
            value: '530115',
            parentId: '530100'
          },
          {
            id: '530124',
            label: '富民县',
            value: '530124',
            parentId: '530100'
          },
          {
            id: '530125',
            label: '宜良县',
            value: '530125',
            parentId: '530100'
          },
          {
            id: '530126',
            label: '石林彝族自治县',
            value: '530126',
            parentId: '530100'
          },
          {
            id: '530127',
            label: '嵩明县',
            value: '530127',
            parentId: '530100'
          },
          {
            id: '530128',
            label: '禄劝彝族苗族自治县',
            value: '530128',
            parentId: '530100'
          },
          {
            id: '530129',
            label: '寻甸回族彝族自治县',
            value: '530129',
            parentId: '530100'
          },
          {
            id: '530181',
            label: '安宁市',
            value: '530181',
            parentId: '530100'
          }
        ]
      },
      {
        id: '530300',
        label: '曲靖市',
        value: '530300',
        parentId: '530000',
        children: [
          {
            id: '530302',
            label: '麒麟区',
            value: '530302',
            parentId: '530300'
          },
          {
            id: '530303',
            label: '沾益区',
            value: '530303',
            parentId: '530300'
          },
          {
            id: '530304',
            label: '马龙区',
            value: '530304',
            parentId: '530300'
          },
          {
            id: '530322',
            label: '陆良县',
            value: '530322',
            parentId: '530300'
          },
          {
            id: '530323',
            label: '师宗县',
            value: '530323',
            parentId: '530300'
          },
          {
            id: '530324',
            label: '罗平县',
            value: '530324',
            parentId: '530300'
          },
          {
            id: '530325',
            label: '富源县',
            value: '530325',
            parentId: '530300'
          },
          {
            id: '530326',
            label: '会泽县',
            value: '530326',
            parentId: '530300'
          },
          {
            id: '530381',
            label: '宣威市',
            value: '530381',
            parentId: '530300'
          }
        ]
      },
      {
        id: '530400',
        label: '玉溪市',
        value: '530400',
        parentId: '530000',
        children: [
          {
            id: '530402',
            label: '红塔区',
            value: '530402',
            parentId: '530400'
          },
          {
            id: '530403',
            label: '江川区',
            value: '530403',
            parentId: '530400'
          },
          {
            id: '530423',
            label: '通海县',
            value: '530423',
            parentId: '530400'
          },
          {
            id: '530424',
            label: '华宁县',
            value: '530424',
            parentId: '530400'
          },
          {
            id: '530425',
            label: '易门县',
            value: '530425',
            parentId: '530400'
          },
          {
            id: '530426',
            label: '峨山彝族自治县',
            value: '530426',
            parentId: '530400'
          },
          {
            id: '530427',
            label: '新平彝族傣族自治县',
            value: '530427',
            parentId: '530400'
          },
          {
            id: '530428',
            label: '元江哈尼族彝族傣族自治县',
            value: '530428',
            parentId: '530400'
          },
          {
            id: '530481',
            label: '澄江市',
            value: '530481',
            parentId: '530400'
          }
        ]
      },
      {
        id: '530500',
        label: '保山市',
        value: '530500',
        parentId: '530000',
        children: [
          {
            id: '530502',
            label: '隆阳区',
            value: '530502',
            parentId: '530500'
          },
          {
            id: '530521',
            label: '施甸县',
            value: '530521',
            parentId: '530500'
          },
          {
            id: '530523',
            label: '龙陵县',
            value: '530523',
            parentId: '530500'
          },
          {
            id: '530524',
            label: '昌宁县',
            value: '530524',
            parentId: '530500'
          },
          {
            id: '530581',
            label: '腾冲市',
            value: '530581',
            parentId: '530500'
          }
        ]
      },
      {
        id: '530600',
        label: '昭通市',
        value: '530600',
        parentId: '530000',
        children: [
          {
            id: '530602',
            label: '昭阳区',
            value: '530602',
            parentId: '530600'
          },
          {
            id: '530621',
            label: '鲁甸县',
            value: '530621',
            parentId: '530600'
          },
          {
            id: '530622',
            label: '巧家县',
            value: '530622',
            parentId: '530600'
          },
          {
            id: '530623',
            label: '盐津县',
            value: '530623',
            parentId: '530600'
          },
          {
            id: '530624',
            label: '大关县',
            value: '530624',
            parentId: '530600'
          },
          {
            id: '530625',
            label: '永善县',
            value: '530625',
            parentId: '530600'
          },
          {
            id: '530626',
            label: '绥江县',
            value: '530626',
            parentId: '530600'
          },
          {
            id: '530627',
            label: '镇雄县',
            value: '530627',
            parentId: '530600'
          },
          {
            id: '530628',
            label: '彝良县',
            value: '530628',
            parentId: '530600'
          },
          {
            id: '530629',
            label: '威信县',
            value: '530629',
            parentId: '530600'
          },
          {
            id: '530681',
            label: '水富市',
            value: '530681',
            parentId: '530600'
          }
        ]
      },
      {
        id: '530700',
        label: '丽江市',
        value: '530700',
        parentId: '530000',
        children: [
          {
            id: '530702',
            label: '古城区',
            value: '530702',
            parentId: '530700'
          },
          {
            id: '530721',
            label: '玉龙纳西族自治县',
            value: '530721',
            parentId: '530700'
          },
          {
            id: '530722',
            label: '永胜县',
            value: '530722',
            parentId: '530700'
          },
          {
            id: '530723',
            label: '华坪县',
            value: '530723',
            parentId: '530700'
          },
          {
            id: '530724',
            label: '宁蒗彝族自治县',
            value: '530724',
            parentId: '530700'
          }
        ]
      },
      {
        id: '530800',
        label: '普洱市',
        value: '530800',
        parentId: '530000',
        children: [
          {
            id: '530802',
            label: '思茅区',
            value: '530802',
            parentId: '530800'
          },
          {
            id: '530821',
            label: '宁洱哈尼族彝族自治县',
            value: '530821',
            parentId: '530800'
          },
          {
            id: '530822',
            label: '墨江哈尼族自治县',
            value: '530822',
            parentId: '530800'
          },
          {
            id: '530823',
            label: '景东彝族自治县',
            value: '530823',
            parentId: '530800'
          },
          {
            id: '530824',
            label: '景谷傣族彝族自治县',
            value: '530824',
            parentId: '530800'
          },
          {
            id: '530825',
            label: '镇沅彝族哈尼族拉祜族自治县',
            value: '530825',
            parentId: '530800'
          },
          {
            id: '530826',
            label: '江城哈尼族彝族自治县',
            value: '530826',
            parentId: '530800'
          },
          {
            id: '530827',
            label: '孟连傣族拉祜族佤族自治县',
            value: '530827',
            parentId: '530800'
          },
          {
            id: '530828',
            label: '澜沧拉祜族自治县',
            value: '530828',
            parentId: '530800'
          },
          {
            id: '530829',
            label: '西盟佤族自治县',
            value: '530829',
            parentId: '530800'
          }
        ]
      },
      {
        id: '530900',
        label: '临沧市',
        value: '530900',
        parentId: '530000',
        children: [
          {
            id: '530902',
            label: '临翔区',
            value: '530902',
            parentId: '530900'
          },
          {
            id: '530921',
            label: '凤庆县',
            value: '530921',
            parentId: '530900'
          },
          {
            id: '530922',
            label: '云县',
            value: '530922',
            parentId: '530900'
          },
          {
            id: '530923',
            label: '永德县',
            value: '530923',
            parentId: '530900'
          },
          {
            id: '530924',
            label: '镇康县',
            value: '530924',
            parentId: '530900'
          },
          {
            id: '530925',
            label: '双江拉祜族佤族布朗族傣族自治县',
            value: '530925',
            parentId: '530900'
          },
          {
            id: '530926',
            label: '耿马傣族佤族自治县',
            value: '530926',
            parentId: '530900'
          },
          {
            id: '530927',
            label: '沧源佤族自治县',
            value: '530927',
            parentId: '530900'
          }
        ]
      },
      {
        id: '532300',
        label: '楚雄彝族自治州',
        value: '532300',
        parentId: '530000',
        children: [
          {
            id: '532301',
            label: '楚雄市',
            value: '532301',
            parentId: '532300'
          },
          {
            id: '532302',
            label: '禄丰市',
            value: '532302',
            parentId: '532300'
          },
          {
            id: '532322',
            label: '双柏县',
            value: '532322',
            parentId: '532300'
          },
          {
            id: '532323',
            label: '牟定县',
            value: '532323',
            parentId: '532300'
          },
          {
            id: '532324',
            label: '南华县',
            value: '532324',
            parentId: '532300'
          },
          {
            id: '532325',
            label: '姚安县',
            value: '532325',
            parentId: '532300'
          },
          {
            id: '532326',
            label: '大姚县',
            value: '532326',
            parentId: '532300'
          },
          {
            id: '532327',
            label: '永仁县',
            value: '532327',
            parentId: '532300'
          },
          {
            id: '532328',
            label: '元谋县',
            value: '532328',
            parentId: '532300'
          },
          {
            id: '532329',
            label: '武定县',
            value: '532329',
            parentId: '532300'
          }
        ]
      },
      {
        id: '532500',
        label: '红河哈尼族彝族自治州',
        value: '532500',
        parentId: '530000',
        children: [
          {
            id: '532501',
            label: '个旧市',
            value: '532501',
            parentId: '532500'
          },
          {
            id: '532502',
            label: '开远市',
            value: '532502',
            parentId: '532500'
          },
          {
            id: '532503',
            label: '蒙自市',
            value: '532503',
            parentId: '532500'
          },
          {
            id: '532504',
            label: '弥勒市',
            value: '532504',
            parentId: '532500'
          },
          {
            id: '532523',
            label: '屏边苗族自治县',
            value: '532523',
            parentId: '532500'
          },
          {
            id: '532524',
            label: '建水县',
            value: '532524',
            parentId: '532500'
          },
          {
            id: '532525',
            label: '石屏县',
            value: '532525',
            parentId: '532500'
          },
          {
            id: '532527',
            label: '泸西县',
            value: '532527',
            parentId: '532500'
          },
          {
            id: '532528',
            label: '元阳县',
            value: '532528',
            parentId: '532500'
          },
          {
            id: '532529',
            label: '红河县',
            value: '532529',
            parentId: '532500'
          },
          {
            id: '532530',
            label: '金平苗族瑶族傣族自治县',
            value: '532530',
            parentId: '532500'
          },
          {
            id: '532531',
            label: '绿春县',
            value: '532531',
            parentId: '532500'
          },
          {
            id: '532532',
            label: '河口瑶族自治县',
            value: '532532',
            parentId: '532500'
          }
        ]
      },
      {
        id: '532600',
        label: '文山壮族苗族自治州',
        value: '532600',
        parentId: '530000',
        children: [
          {
            id: '532601',
            label: '文山市',
            value: '532601',
            parentId: '532600'
          },
          {
            id: '532622',
            label: '砚山县',
            value: '532622',
            parentId: '532600'
          },
          {
            id: '532623',
            label: '西畴县',
            value: '532623',
            parentId: '532600'
          },
          {
            id: '532624',
            label: '麻栗坡县',
            value: '532624',
            parentId: '532600'
          },
          {
            id: '532625',
            label: '马关县',
            value: '532625',
            parentId: '532600'
          },
          {
            id: '532626',
            label: '丘北县',
            value: '532626',
            parentId: '532600'
          },
          {
            id: '532627',
            label: '广南县',
            value: '532627',
            parentId: '532600'
          },
          {
            id: '532628',
            label: '富宁县',
            value: '532628',
            parentId: '532600'
          }
        ]
      },
      {
        id: '532800',
        label: '西双版纳傣族自治州',
        value: '532800',
        parentId: '530000',
        children: [
          {
            id: '532801',
            label: '景洪市',
            value: '532801',
            parentId: '532800'
          },
          {
            id: '532822',
            label: '勐海县',
            value: '532822',
            parentId: '532800'
          },
          {
            id: '532823',
            label: '勐腊县',
            value: '532823',
            parentId: '532800'
          }
        ]
      },
      {
        id: '532900',
        label: '大理白族自治州',
        value: '532900',
        parentId: '530000',
        children: [
          {
            id: '532901',
            label: '大理市',
            value: '532901',
            parentId: '532900'
          },
          {
            id: '532922',
            label: '漾濞彝族自治县',
            value: '532922',
            parentId: '532900'
          },
          {
            id: '532923',
            label: '祥云县',
            value: '532923',
            parentId: '532900'
          },
          {
            id: '532924',
            label: '宾川县',
            value: '532924',
            parentId: '532900'
          },
          {
            id: '532925',
            label: '弥渡县',
            value: '532925',
            parentId: '532900'
          },
          {
            id: '532926',
            label: '南涧彝族自治县',
            value: '532926',
            parentId: '532900'
          },
          {
            id: '532927',
            label: '巍山彝族回族自治县',
            value: '532927',
            parentId: '532900'
          },
          {
            id: '532928',
            label: '永平县',
            value: '532928',
            parentId: '532900'
          },
          {
            id: '532929',
            label: '云龙县',
            value: '532929',
            parentId: '532900'
          },
          {
            id: '532930',
            label: '洱源县',
            value: '532930',
            parentId: '532900'
          },
          {
            id: '532931',
            label: '剑川县',
            value: '532931',
            parentId: '532900'
          },
          {
            id: '532932',
            label: '鹤庆县',
            value: '532932',
            parentId: '532900'
          }
        ]
      },
      {
        id: '533100',
        label: '德宏傣族景颇族自治州',
        value: '533100',
        parentId: '530000',
        children: [
          {
            id: '533102',
            label: '瑞丽市',
            value: '533102',
            parentId: '533100'
          },
          {
            id: '533103',
            label: '芒市',
            value: '533103',
            parentId: '533100'
          },
          {
            id: '533122',
            label: '梁河县',
            value: '533122',
            parentId: '533100'
          },
          {
            id: '533123',
            label: '盈江县',
            value: '533123',
            parentId: '533100'
          },
          {
            id: '533124',
            label: '陇川县',
            value: '533124',
            parentId: '533100'
          }
        ]
      },
      {
        id: '533300',
        label: '怒江傈僳族自治州',
        value: '533300',
        parentId: '530000',
        children: [
          {
            id: '533301',
            label: '泸水市',
            value: '533301',
            parentId: '533300'
          },
          {
            id: '533323',
            label: '福贡县',
            value: '533323',
            parentId: '533300'
          },
          {
            id: '533324',
            label: '贡山独龙族怒族自治县',
            value: '533324',
            parentId: '533300'
          },
          {
            id: '533325',
            label: '兰坪白族普米族自治县',
            value: '533325',
            parentId: '533300'
          }
        ]
      },
      {
        id: '533400',
        label: '迪庆藏族自治州',
        value: '533400',
        parentId: '530000',
        children: [
          {
            id: '533401',
            label: '香格里拉市',
            value: '533401',
            parentId: '533400'
          },
          {
            id: '533422',
            label: '德钦县',
            value: '533422',
            parentId: '533400'
          },
          {
            id: '533423',
            label: '维西傈僳族自治县',
            value: '533423',
            parentId: '533400'
          }
        ]
      }
    ]
  },
  {
    id: '540000',
    label: '西藏自治区',
    value: '540000',
    children: [
      {
        id: '540100',
        label: '拉萨市',
        value: '540100',
        parentId: '540000',
        children: [
          {
            id: '540102',
            label: '城关区',
            value: '540102',
            parentId: '540100'
          },
          {
            id: '540103',
            label: '堆龙德庆区',
            value: '540103',
            parentId: '540100'
          },
          {
            id: '540104',
            label: '达孜区',
            value: '540104',
            parentId: '540100'
          },
          {
            id: '540121',
            label: '林周县',
            value: '540121',
            parentId: '540100'
          },
          {
            id: '540122',
            label: '当雄县',
            value: '540122',
            parentId: '540100'
          },
          {
            id: '540123',
            label: '尼木县',
            value: '540123',
            parentId: '540100'
          },
          {
            id: '540124',
            label: '曲水县',
            value: '540124',
            parentId: '540100'
          },
          {
            id: '540127',
            label: '墨竹工卡县',
            value: '540127',
            parentId: '540100'
          }
        ]
      },
      {
        id: '540200',
        label: '日喀则市',
        value: '540200',
        parentId: '540000',
        children: [
          {
            id: '540202',
            label: '桑珠孜区',
            value: '540202',
            parentId: '540200'
          },
          {
            id: '540221',
            label: '南木林县',
            value: '540221',
            parentId: '540200'
          },
          {
            id: '540222',
            label: '江孜县',
            value: '540222',
            parentId: '540200'
          },
          {
            id: '540223',
            label: '定日县',
            value: '540223',
            parentId: '540200'
          },
          {
            id: '540224',
            label: '萨迦县',
            value: '540224',
            parentId: '540200'
          },
          {
            id: '540225',
            label: '拉孜县',
            value: '540225',
            parentId: '540200'
          },
          {
            id: '540226',
            label: '昂仁县',
            value: '540226',
            parentId: '540200'
          },
          {
            id: '540227',
            label: '谢通门县',
            value: '540227',
            parentId: '540200'
          },
          {
            id: '540228',
            label: '白朗县',
            value: '540228',
            parentId: '540200'
          },
          {
            id: '540229',
            label: '仁布县',
            value: '540229',
            parentId: '540200'
          },
          {
            id: '540230',
            label: '康马县',
            value: '540230',
            parentId: '540200'
          },
          {
            id: '540231',
            label: '定结县',
            value: '540231',
            parentId: '540200'
          },
          {
            id: '540232',
            label: '仲巴县',
            value: '540232',
            parentId: '540200'
          },
          {
            id: '540233',
            label: '亚东县',
            value: '540233',
            parentId: '540200'
          },
          {
            id: '540234',
            label: '吉隆县',
            value: '540234',
            parentId: '540200'
          },
          {
            id: '540235',
            label: '聂拉木县',
            value: '540235',
            parentId: '540200'
          },
          {
            id: '540236',
            label: '萨嘎县',
            value: '540236',
            parentId: '540200'
          },
          {
            id: '540237',
            label: '岗巴县',
            value: '540237',
            parentId: '540200'
          }
        ]
      },
      {
        id: '540300',
        label: '昌都市',
        value: '540300',
        parentId: '540000',
        children: [
          {
            id: '540302',
            label: '卡若区',
            value: '540302',
            parentId: '540300'
          },
          {
            id: '540321',
            label: '江达县',
            value: '540321',
            parentId: '540300'
          },
          {
            id: '540322',
            label: '贡觉县',
            value: '540322',
            parentId: '540300'
          },
          {
            id: '540323',
            label: '类乌齐县',
            value: '540323',
            parentId: '540300'
          },
          {
            id: '540324',
            label: '丁青县',
            value: '540324',
            parentId: '540300'
          },
          {
            id: '540325',
            label: '察雅县',
            value: '540325',
            parentId: '540300'
          },
          {
            id: '540326',
            label: '八宿县',
            value: '540326',
            parentId: '540300'
          },
          {
            id: '540327',
            label: '左贡县',
            value: '540327',
            parentId: '540300'
          },
          {
            id: '540328',
            label: '芒康县',
            value: '540328',
            parentId: '540300'
          },
          {
            id: '540329',
            label: '洛隆县',
            value: '540329',
            parentId: '540300'
          },
          {
            id: '540330',
            label: '边坝县',
            value: '540330',
            parentId: '540300'
          }
        ]
      },
      {
        id: '540400',
        label: '林芝市',
        value: '540400',
        parentId: '540000',
        children: [
          {
            id: '540402',
            label: '巴宜区',
            value: '540402',
            parentId: '540400'
          },
          {
            id: '540421',
            label: '工布江达县',
            value: '540421',
            parentId: '540400'
          },
          {
            id: '540422',
            label: '米林县',
            value: '540422',
            parentId: '540400'
          },
          {
            id: '540423',
            label: '墨脱县',
            value: '540423',
            parentId: '540400'
          },
          {
            id: '540424',
            label: '波密县',
            value: '540424',
            parentId: '540400'
          },
          {
            id: '540425',
            label: '察隅县',
            value: '540425',
            parentId: '540400'
          },
          {
            id: '540426',
            label: '朗县',
            value: '540426',
            parentId: '540400'
          }
        ]
      },
      {
        id: '540500',
        label: '山南市',
        value: '540500',
        parentId: '540000',
        children: [
          {
            id: '540502',
            label: '乃东区',
            value: '540502',
            parentId: '540500'
          },
          {
            id: '540521',
            label: '扎囊县',
            value: '540521',
            parentId: '540500'
          },
          {
            id: '540522',
            label: '贡嘎县',
            value: '540522',
            parentId: '540500'
          },
          {
            id: '540523',
            label: '桑日县',
            value: '540523',
            parentId: '540500'
          },
          {
            id: '540524',
            label: '琼结县',
            value: '540524',
            parentId: '540500'
          },
          {
            id: '540525',
            label: '曲松县',
            value: '540525',
            parentId: '540500'
          },
          {
            id: '540526',
            label: '措美县',
            value: '540526',
            parentId: '540500'
          },
          {
            id: '540527',
            label: '洛扎县',
            value: '540527',
            parentId: '540500'
          },
          {
            id: '540528',
            label: '加查县',
            value: '540528',
            parentId: '540500'
          },
          {
            id: '540529',
            label: '隆子县',
            value: '540529',
            parentId: '540500'
          },
          {
            id: '540530',
            label: '错那县',
            value: '540530',
            parentId: '540500'
          },
          {
            id: '540531',
            label: '浪卡子县',
            value: '540531',
            parentId: '540500'
          }
        ]
      },
      {
        id: '540600',
        label: '那曲市',
        value: '540600',
        parentId: '540000',
        children: [
          {
            id: '540602',
            label: '色尼区',
            value: '540602',
            parentId: '540600'
          },
          {
            id: '540621',
            label: '嘉黎县',
            value: '540621',
            parentId: '540600'
          },
          {
            id: '540622',
            label: '比如县',
            value: '540622',
            parentId: '540600'
          },
          {
            id: '540623',
            label: '聂荣县',
            value: '540623',
            parentId: '540600'
          },
          {
            id: '540624',
            label: '安多县',
            value: '540624',
            parentId: '540600'
          },
          {
            id: '540625',
            label: '申扎县',
            value: '540625',
            parentId: '540600'
          },
          {
            id: '540626',
            label: '索县',
            value: '540626',
            parentId: '540600'
          },
          {
            id: '540627',
            label: '班戈县',
            value: '540627',
            parentId: '540600'
          },
          {
            id: '540628',
            label: '巴青县',
            value: '540628',
            parentId: '540600'
          },
          {
            id: '540629',
            label: '尼玛县',
            value: '540629',
            parentId: '540600'
          },
          {
            id: '540630',
            label: '双湖县',
            value: '540630',
            parentId: '540600'
          }
        ]
      },
      {
        id: '542500',
        label: '阿里地区',
        value: '542500',
        parentId: '540000',
        children: [
          {
            id: '542521',
            label: '普兰县',
            value: '542521',
            parentId: '542500'
          },
          {
            id: '542522',
            label: '札达县',
            value: '542522',
            parentId: '542500'
          },
          {
            id: '542523',
            label: '噶尔县',
            value: '542523',
            parentId: '542500'
          },
          {
            id: '542524',
            label: '日土县',
            value: '542524',
            parentId: '542500'
          },
          {
            id: '542525',
            label: '革吉县',
            value: '542525',
            parentId: '542500'
          },
          {
            id: '542526',
            label: '改则县',
            value: '542526',
            parentId: '542500'
          },
          {
            id: '542527',
            label: '措勤县',
            value: '542527',
            parentId: '542500'
          }
        ]
      }
    ]
  },
  {
    id: '610000',
    label: '陕西省',
    value: '610000',
    children: [
      {
        id: '610100',
        label: '西安市',
        value: '610100',
        parentId: '610000',
        children: [
          {
            id: '610102',
            label: '新城区',
            value: '610102',
            parentId: '610100'
          },
          {
            id: '610103',
            label: '碑林区',
            value: '610103',
            parentId: '610100'
          },
          {
            id: '610104',
            label: '莲湖区',
            value: '610104',
            parentId: '610100'
          },
          {
            id: '610111',
            label: '灞桥区',
            value: '610111',
            parentId: '610100'
          },
          {
            id: '610112',
            label: '未央区',
            value: '610112',
            parentId: '610100'
          },
          {
            id: '610113',
            label: '雁塔区',
            value: '610113',
            parentId: '610100'
          },
          {
            id: '610114',
            label: '阎良区',
            value: '610114',
            parentId: '610100'
          },
          {
            id: '610115',
            label: '临潼区',
            value: '610115',
            parentId: '610100'
          },
          {
            id: '610116',
            label: '长安区',
            value: '610116',
            parentId: '610100'
          },
          {
            id: '610117',
            label: '高陵区',
            value: '610117',
            parentId: '610100'
          },
          {
            id: '610118',
            label: '鄠邑区',
            value: '610118',
            parentId: '610100'
          },
          {
            id: '610122',
            label: '蓝田县',
            value: '610122',
            parentId: '610100'
          },
          {
            id: '610124',
            label: '周至县',
            value: '610124',
            parentId: '610100'
          }
        ]
      },
      {
        id: '610200',
        label: '铜川市',
        value: '610200',
        parentId: '610000',
        children: [
          {
            id: '610202',
            label: '王益区',
            value: '610202',
            parentId: '610200'
          },
          {
            id: '610203',
            label: '印台区',
            value: '610203',
            parentId: '610200'
          },
          {
            id: '610204',
            label: '耀州区',
            value: '610204',
            parentId: '610200'
          },
          {
            id: '610222',
            label: '宜君县',
            value: '610222',
            parentId: '610200'
          }
        ]
      },
      {
        id: '610300',
        label: '宝鸡市',
        value: '610300',
        parentId: '610000',
        children: [
          {
            id: '610302',
            label: '渭滨区',
            value: '610302',
            parentId: '610300'
          },
          {
            id: '610303',
            label: '金台区',
            value: '610303',
            parentId: '610300'
          },
          {
            id: '610304',
            label: '陈仓区',
            value: '610304',
            parentId: '610300'
          },
          {
            id: '610305',
            label: '凤翔区',
            value: '610305',
            parentId: '610300'
          },
          {
            id: '610323',
            label: '岐山县',
            value: '610323',
            parentId: '610300'
          },
          {
            id: '610324',
            label: '扶风县',
            value: '610324',
            parentId: '610300'
          },
          {
            id: '610326',
            label: '眉县',
            value: '610326',
            parentId: '610300'
          },
          {
            id: '610327',
            label: '陇县',
            value: '610327',
            parentId: '610300'
          },
          {
            id: '610328',
            label: '千阳县',
            value: '610328',
            parentId: '610300'
          },
          {
            id: '610329',
            label: '麟游县',
            value: '610329',
            parentId: '610300'
          },
          {
            id: '610330',
            label: '凤县',
            value: '610330',
            parentId: '610300'
          },
          {
            id: '610331',
            label: '太白县',
            value: '610331',
            parentId: '610300'
          }
        ]
      },
      {
        id: '610400',
        label: '咸阳市',
        value: '610400',
        parentId: '610000',
        children: [
          {
            id: '610402',
            label: '秦都区',
            value: '610402',
            parentId: '610400'
          },
          {
            id: '610403',
            label: '杨陵区',
            value: '610403',
            parentId: '610400'
          },
          {
            id: '610404',
            label: '渭城区',
            value: '610404',
            parentId: '610400'
          },
          {
            id: '610422',
            label: '三原县',
            value: '610422',
            parentId: '610400'
          },
          {
            id: '610423',
            label: '泾阳县',
            value: '610423',
            parentId: '610400'
          },
          {
            id: '610424',
            label: '乾县',
            value: '610424',
            parentId: '610400'
          },
          {
            id: '610425',
            label: '礼泉县',
            value: '610425',
            parentId: '610400'
          },
          {
            id: '610426',
            label: '永寿县',
            value: '610426',
            parentId: '610400'
          },
          {
            id: '610428',
            label: '长武县',
            value: '610428',
            parentId: '610400'
          },
          {
            id: '610429',
            label: '旬邑县',
            value: '610429',
            parentId: '610400'
          },
          {
            id: '610430',
            label: '淳化县',
            value: '610430',
            parentId: '610400'
          },
          {
            id: '610431',
            label: '武功县',
            value: '610431',
            parentId: '610400'
          },
          {
            id: '610481',
            label: '兴平市',
            value: '610481',
            parentId: '610400'
          },
          {
            id: '610482',
            label: '彬州市',
            value: '610482',
            parentId: '610400'
          }
        ]
      },
      {
        id: '610500',
        label: '渭南市',
        value: '610500',
        parentId: '610000',
        children: [
          {
            id: '610502',
            label: '临渭区',
            value: '610502',
            parentId: '610500'
          },
          {
            id: '610503',
            label: '华州区',
            value: '610503',
            parentId: '610500'
          },
          {
            id: '610522',
            label: '潼关县',
            value: '610522',
            parentId: '610500'
          },
          {
            id: '610523',
            label: '大荔县',
            value: '610523',
            parentId: '610500'
          },
          {
            id: '610524',
            label: '合阳县',
            value: '610524',
            parentId: '610500'
          },
          {
            id: '610525',
            label: '澄城县',
            value: '610525',
            parentId: '610500'
          },
          {
            id: '610526',
            label: '蒲城县',
            value: '610526',
            parentId: '610500'
          },
          {
            id: '610527',
            label: '白水县',
            value: '610527',
            parentId: '610500'
          },
          {
            id: '610528',
            label: '富平县',
            value: '610528',
            parentId: '610500'
          },
          {
            id: '610581',
            label: '韩城市',
            value: '610581',
            parentId: '610500'
          },
          {
            id: '610582',
            label: '华阴市',
            value: '610582',
            parentId: '610500'
          }
        ]
      },
      {
        id: '610600',
        label: '延安市',
        value: '610600',
        parentId: '610000',
        children: [
          {
            id: '610602',
            label: '宝塔区',
            value: '610602',
            parentId: '610600'
          },
          {
            id: '610603',
            label: '安塞区',
            value: '610603',
            parentId: '610600'
          },
          {
            id: '610621',
            label: '延长县',
            value: '610621',
            parentId: '610600'
          },
          {
            id: '610622',
            label: '延川县',
            value: '610622',
            parentId: '610600'
          },
          {
            id: '610625',
            label: '志丹县',
            value: '610625',
            parentId: '610600'
          },
          {
            id: '610626',
            label: '吴起县',
            value: '610626',
            parentId: '610600'
          },
          {
            id: '610627',
            label: '甘泉县',
            value: '610627',
            parentId: '610600'
          },
          {
            id: '610628',
            label: '富县',
            value: '610628',
            parentId: '610600'
          },
          {
            id: '610629',
            label: '洛川县',
            value: '610629',
            parentId: '610600'
          },
          {
            id: '610630',
            label: '宜川县',
            value: '610630',
            parentId: '610600'
          },
          {
            id: '610631',
            label: '黄龙县',
            value: '610631',
            parentId: '610600'
          },
          {
            id: '610632',
            label: '黄陵县',
            value: '610632',
            parentId: '610600'
          },
          {
            id: '610681',
            label: '子长市',
            value: '610681',
            parentId: '610600'
          }
        ]
      },
      {
        id: '610700',
        label: '汉中市',
        value: '610700',
        parentId: '610000',
        children: [
          {
            id: '610702',
            label: '汉台区',
            value: '610702',
            parentId: '610700'
          },
          {
            id: '610703',
            label: '南郑区',
            value: '610703',
            parentId: '610700'
          },
          {
            id: '610722',
            label: '城固县',
            value: '610722',
            parentId: '610700'
          },
          {
            id: '610723',
            label: '洋县',
            value: '610723',
            parentId: '610700'
          },
          {
            id: '610724',
            label: '西乡县',
            value: '610724',
            parentId: '610700'
          },
          {
            id: '610725',
            label: '勉县',
            value: '610725',
            parentId: '610700'
          },
          {
            id: '610726',
            label: '宁强县',
            value: '610726',
            parentId: '610700'
          },
          {
            id: '610727',
            label: '略阳县',
            value: '610727',
            parentId: '610700'
          },
          {
            id: '610728',
            label: '镇巴县',
            value: '610728',
            parentId: '610700'
          },
          {
            id: '610729',
            label: '留坝县',
            value: '610729',
            parentId: '610700'
          },
          {
            id: '610730',
            label: '佛坪县',
            value: '610730',
            parentId: '610700'
          }
        ]
      },
      {
        id: '610800',
        label: '榆林市',
        value: '610800',
        parentId: '610000',
        children: [
          {
            id: '610802',
            label: '榆阳区',
            value: '610802',
            parentId: '610800'
          },
          {
            id: '610803',
            label: '横山区',
            value: '610803',
            parentId: '610800'
          },
          {
            id: '610822',
            label: '府谷县',
            value: '610822',
            parentId: '610800'
          },
          {
            id: '610824',
            label: '靖边县',
            value: '610824',
            parentId: '610800'
          },
          {
            id: '610825',
            label: '定边县',
            value: '610825',
            parentId: '610800'
          },
          {
            id: '610826',
            label: '绥德县',
            value: '610826',
            parentId: '610800'
          },
          {
            id: '610827',
            label: '米脂县',
            value: '610827',
            parentId: '610800'
          },
          {
            id: '610828',
            label: '佳县',
            value: '610828',
            parentId: '610800'
          },
          {
            id: '610829',
            label: '吴堡县',
            value: '610829',
            parentId: '610800'
          },
          {
            id: '610830',
            label: '清涧县',
            value: '610830',
            parentId: '610800'
          },
          {
            id: '610831',
            label: '子洲县',
            value: '610831',
            parentId: '610800'
          },
          {
            id: '610881',
            label: '神木市',
            value: '610881',
            parentId: '610800'
          }
        ]
      },
      {
        id: '610900',
        label: '安康市',
        value: '610900',
        parentId: '610000',
        children: [
          {
            id: '610902',
            label: '汉滨区',
            value: '610902',
            parentId: '610900'
          },
          {
            id: '610921',
            label: '汉阴县',
            value: '610921',
            parentId: '610900'
          },
          {
            id: '610922',
            label: '石泉县',
            value: '610922',
            parentId: '610900'
          },
          {
            id: '610923',
            label: '宁陕县',
            value: '610923',
            parentId: '610900'
          },
          {
            id: '610924',
            label: '紫阳县',
            value: '610924',
            parentId: '610900'
          },
          {
            id: '610925',
            label: '岚皋县',
            value: '610925',
            parentId: '610900'
          },
          {
            id: '610926',
            label: '平利县',
            value: '610926',
            parentId: '610900'
          },
          {
            id: '610927',
            label: '镇坪县',
            value: '610927',
            parentId: '610900'
          },
          {
            id: '610929',
            label: '白河县',
            value: '610929',
            parentId: '610900'
          },
          {
            id: '610981',
            label: '旬阳市',
            value: '610981',
            parentId: '610900'
          }
        ]
      },
      {
        id: '611000',
        label: '商洛市',
        value: '611000',
        parentId: '610000',
        children: [
          {
            id: '611002',
            label: '商州区',
            value: '611002',
            parentId: '611000'
          },
          {
            id: '611021',
            label: '洛南县',
            value: '611021',
            parentId: '611000'
          },
          {
            id: '611022',
            label: '丹凤县',
            value: '611022',
            parentId: '611000'
          },
          {
            id: '611023',
            label: '商南县',
            value: '611023',
            parentId: '611000'
          },
          {
            id: '611024',
            label: '山阳县',
            value: '611024',
            parentId: '611000'
          },
          {
            id: '611025',
            label: '镇安县',
            value: '611025',
            parentId: '611000'
          },
          {
            id: '611026',
            label: '柞水县',
            value: '611026',
            parentId: '611000'
          }
        ]
      }
    ]
  },
  {
    id: '620000',
    label: '甘肃省',
    value: '620000',
    children: [
      {
        id: '620100',
        label: '兰州市',
        value: '620100',
        parentId: '620000',
        children: [
          {
            id: '620102',
            label: '城关区',
            value: '620102',
            parentId: '620100'
          },
          {
            id: '620103',
            label: '七里河区',
            value: '620103',
            parentId: '620100'
          },
          {
            id: '620104',
            label: '西固区',
            value: '620104',
            parentId: '620100'
          },
          {
            id: '620105',
            label: '安宁区',
            value: '620105',
            parentId: '620100'
          },
          {
            id: '620111',
            label: '红古区',
            value: '620111',
            parentId: '620100'
          },
          {
            id: '620121',
            label: '永登县',
            value: '620121',
            parentId: '620100'
          },
          {
            id: '620122',
            label: '皋兰县',
            value: '620122',
            parentId: '620100'
          },
          {
            id: '620123',
            label: '榆中县',
            value: '620123',
            parentId: '620100'
          }
        ]
      },
      {
        id: '620200',
        label: '嘉峪关市',
        value: '620200',
        parentId: '620000',
        children: [
          {
            id: '620201001000',
            label: '雄关街道',
            value: '620201001000',
            parentId: '620200'
          },
          {
            id: '620201002000',
            label: '钢城街道',
            value: '620201002000',
            parentId: '620200'
          },
          {
            id: '620201100000',
            label: '新城镇',
            value: '620201100000',
            parentId: '620200'
          },
          {
            id: '620201101000',
            label: '峪泉镇',
            value: '620201101000',
            parentId: '620200'
          },
          {
            id: '620201102000',
            label: '文殊镇',
            value: '620201102000',
            parentId: '620200'
          }
        ]
      },
      {
        id: '620300',
        label: '金昌市',
        value: '620300',
        parentId: '620000',
        children: [
          {
            id: '620302',
            label: '金川区',
            value: '620302',
            parentId: '620300'
          },
          {
            id: '620321',
            label: '永昌县',
            value: '620321',
            parentId: '620300'
          }
        ]
      },
      {
        id: '620400',
        label: '白银市',
        value: '620400',
        parentId: '620000',
        children: [
          {
            id: '620402',
            label: '白银区',
            value: '620402',
            parentId: '620400'
          },
          {
            id: '620403',
            label: '平川区',
            value: '620403',
            parentId: '620400'
          },
          {
            id: '620421',
            label: '靖远县',
            value: '620421',
            parentId: '620400'
          },
          {
            id: '620422',
            label: '会宁县',
            value: '620422',
            parentId: '620400'
          },
          {
            id: '620423',
            label: '景泰县',
            value: '620423',
            parentId: '620400'
          }
        ]
      },
      {
        id: '620500',
        label: '天水市',
        value: '620500',
        parentId: '620000',
        children: [
          {
            id: '620502',
            label: '秦州区',
            value: '620502',
            parentId: '620500'
          },
          {
            id: '620503',
            label: '麦积区',
            value: '620503',
            parentId: '620500'
          },
          {
            id: '620521',
            label: '清水县',
            value: '620521',
            parentId: '620500'
          },
          {
            id: '620522',
            label: '秦安县',
            value: '620522',
            parentId: '620500'
          },
          {
            id: '620523',
            label: '甘谷县',
            value: '620523',
            parentId: '620500'
          },
          {
            id: '620524',
            label: '武山县',
            value: '620524',
            parentId: '620500'
          },
          {
            id: '620525',
            label: '张家川回族自治县',
            value: '620525',
            parentId: '620500'
          }
        ]
      },
      {
        id: '620600',
        label: '武威市',
        value: '620600',
        parentId: '620000',
        children: [
          {
            id: '620602',
            label: '凉州区',
            value: '620602',
            parentId: '620600'
          },
          {
            id: '620621',
            label: '民勤县',
            value: '620621',
            parentId: '620600'
          },
          {
            id: '620622',
            label: '古浪县',
            value: '620622',
            parentId: '620600'
          },
          {
            id: '620623',
            label: '天祝藏族自治县',
            value: '620623',
            parentId: '620600'
          }
        ]
      },
      {
        id: '620700',
        label: '张掖市',
        value: '620700',
        parentId: '620000',
        children: [
          {
            id: '620702',
            label: '甘州区',
            value: '620702',
            parentId: '620700'
          },
          {
            id: '620721',
            label: '肃南裕固族自治县',
            value: '620721',
            parentId: '620700'
          },
          {
            id: '620722',
            label: '民乐县',
            value: '620722',
            parentId: '620700'
          },
          {
            id: '620723',
            label: '临泽县',
            value: '620723',
            parentId: '620700'
          },
          {
            id: '620724',
            label: '高台县',
            value: '620724',
            parentId: '620700'
          },
          {
            id: '620725',
            label: '山丹县',
            value: '620725',
            parentId: '620700'
          }
        ]
      },
      {
        id: '620800',
        label: '平凉市',
        value: '620800',
        parentId: '620000',
        children: [
          {
            id: '620802',
            label: '崆峒区',
            value: '620802',
            parentId: '620800'
          },
          {
            id: '620821',
            label: '泾川县',
            value: '620821',
            parentId: '620800'
          },
          {
            id: '620822',
            label: '灵台县',
            value: '620822',
            parentId: '620800'
          },
          {
            id: '620823',
            label: '崇信县',
            value: '620823',
            parentId: '620800'
          },
          {
            id: '620825',
            label: '庄浪县',
            value: '620825',
            parentId: '620800'
          },
          {
            id: '620826',
            label: '静宁县',
            value: '620826',
            parentId: '620800'
          },
          {
            id: '620881',
            label: '华亭市',
            value: '620881',
            parentId: '620800'
          }
        ]
      },
      {
        id: '620900',
        label: '酒泉市',
        value: '620900',
        parentId: '620000',
        children: [
          {
            id: '620902',
            label: '肃州区',
            value: '620902',
            parentId: '620900'
          },
          {
            id: '620921',
            label: '金塔县',
            value: '620921',
            parentId: '620900'
          },
          {
            id: '620922',
            label: '瓜州县',
            value: '620922',
            parentId: '620900'
          },
          {
            id: '620923',
            label: '肃北蒙古族自治县',
            value: '620923',
            parentId: '620900'
          },
          {
            id: '620924',
            label: '阿克塞哈萨克族自治县',
            value: '620924',
            parentId: '620900'
          },
          {
            id: '620981',
            label: '玉门市',
            value: '620981',
            parentId: '620900'
          },
          {
            id: '620982',
            label: '敦煌市',
            value: '620982',
            parentId: '620900'
          }
        ]
      },
      {
        id: '621000',
        label: '庆阳市',
        value: '621000',
        parentId: '620000',
        children: [
          {
            id: '621002',
            label: '西峰区',
            value: '621002',
            parentId: '621000'
          },
          {
            id: '621021',
            label: '庆城县',
            value: '621021',
            parentId: '621000'
          },
          {
            id: '621022',
            label: '环县',
            value: '621022',
            parentId: '621000'
          },
          {
            id: '621023',
            label: '华池县',
            value: '621023',
            parentId: '621000'
          },
          {
            id: '621024',
            label: '合水县',
            value: '621024',
            parentId: '621000'
          },
          {
            id: '621025',
            label: '正宁县',
            value: '621025',
            parentId: '621000'
          },
          {
            id: '621026',
            label: '宁县',
            value: '621026',
            parentId: '621000'
          },
          {
            id: '621027',
            label: '镇原县',
            value: '621027',
            parentId: '621000'
          }
        ]
      },
      {
        id: '621100',
        label: '定西市',
        value: '621100',
        parentId: '620000',
        children: [
          {
            id: '621102',
            label: '安定区',
            value: '621102',
            parentId: '621100'
          },
          {
            id: '621121',
            label: '通渭县',
            value: '621121',
            parentId: '621100'
          },
          {
            id: '621122',
            label: '陇西县',
            value: '621122',
            parentId: '621100'
          },
          {
            id: '621123',
            label: '渭源县',
            value: '621123',
            parentId: '621100'
          },
          {
            id: '621124',
            label: '临洮县',
            value: '621124',
            parentId: '621100'
          },
          {
            id: '621125',
            label: '漳县',
            value: '621125',
            parentId: '621100'
          },
          {
            id: '621126',
            label: '岷县',
            value: '621126',
            parentId: '621100'
          }
        ]
      },
      {
        id: '621200',
        label: '陇南市',
        value: '621200',
        parentId: '620000',
        children: [
          {
            id: '621202',
            label: '武都区',
            value: '621202',
            parentId: '621200'
          },
          {
            id: '621221',
            label: '成县',
            value: '621221',
            parentId: '621200'
          },
          {
            id: '621222',
            label: '文县',
            value: '621222',
            parentId: '621200'
          },
          {
            id: '621223',
            label: '宕昌县',
            value: '621223',
            parentId: '621200'
          },
          {
            id: '621224',
            label: '康县',
            value: '621224',
            parentId: '621200'
          },
          {
            id: '621225',
            label: '西和县',
            value: '621225',
            parentId: '621200'
          },
          {
            id: '621226',
            label: '礼县',
            value: '621226',
            parentId: '621200'
          },
          {
            id: '621227',
            label: '徽县',
            value: '621227',
            parentId: '621200'
          },
          {
            id: '621228',
            label: '两当县',
            value: '621228',
            parentId: '621200'
          }
        ]
      },
      {
        id: '622900',
        label: '临夏回族自治州',
        value: '622900',
        parentId: '620000',
        children: [
          {
            id: '622901',
            label: '临夏市',
            value: '622901',
            parentId: '622900'
          },
          {
            id: '622921',
            label: '临夏县',
            value: '622921',
            parentId: '622900'
          },
          {
            id: '622922',
            label: '康乐县',
            value: '622922',
            parentId: '622900'
          },
          {
            id: '622923',
            label: '永靖县',
            value: '622923',
            parentId: '622900'
          },
          {
            id: '622924',
            label: '广河县',
            value: '622924',
            parentId: '622900'
          },
          {
            id: '622925',
            label: '和政县',
            value: '622925',
            parentId: '622900'
          },
          {
            id: '622926',
            label: '东乡族自治县',
            value: '622926',
            parentId: '622900'
          },
          {
            id: '622927',
            label: '积石山保安族东乡族撒拉族自治县',
            value: '622927',
            parentId: '622900'
          }
        ]
      },
      {
        id: '623000',
        label: '甘南藏族自治州',
        value: '623000',
        parentId: '620000',
        children: [
          {
            id: '623001',
            label: '合作市',
            value: '623001',
            parentId: '623000'
          },
          {
            id: '623021',
            label: '临潭县',
            value: '623021',
            parentId: '623000'
          },
          {
            id: '623022',
            label: '卓尼县',
            value: '623022',
            parentId: '623000'
          },
          {
            id: '623023',
            label: '舟曲县',
            value: '623023',
            parentId: '623000'
          },
          {
            id: '623024',
            label: '迭部县',
            value: '623024',
            parentId: '623000'
          },
          {
            id: '623025',
            label: '玛曲县',
            value: '623025',
            parentId: '623000'
          },
          {
            id: '623026',
            label: '碌曲县',
            value: '623026',
            parentId: '623000'
          },
          {
            id: '623027',
            label: '夏河县',
            value: '623027',
            parentId: '623000'
          }
        ]
      }
    ]
  },
  {
    id: '630000',
    label: '青海省',
    value: '630000',
    children: [
      {
        id: '630100',
        label: '西宁市',
        value: '630100',
        parentId: '630000',
        children: [
          {
            id: '630102',
            label: '城东区',
            value: '630102',
            parentId: '630100'
          },
          {
            id: '630103',
            label: '城中区',
            value: '630103',
            parentId: '630100'
          },
          {
            id: '630104',
            label: '城西区',
            value: '630104',
            parentId: '630100'
          },
          {
            id: '630105',
            label: '城北区',
            value: '630105',
            parentId: '630100'
          },
          {
            id: '630106',
            label: '湟中区',
            value: '630106',
            parentId: '630100'
          },
          {
            id: '630121',
            label: '大通回族土族自治县',
            value: '630121',
            parentId: '630100'
          },
          {
            id: '630123',
            label: '湟源县',
            value: '630123',
            parentId: '630100'
          }
        ]
      },
      {
        id: '630200',
        label: '海东市',
        value: '630200',
        parentId: '630000',
        children: [
          {
            id: '630202',
            label: '乐都区',
            value: '630202',
            parentId: '630200'
          },
          {
            id: '630203',
            label: '平安区',
            value: '630203',
            parentId: '630200'
          },
          {
            id: '630222',
            label: '民和回族土族自治县',
            value: '630222',
            parentId: '630200'
          },
          {
            id: '630223',
            label: '互助土族自治县',
            value: '630223',
            parentId: '630200'
          },
          {
            id: '630224',
            label: '化隆回族自治县',
            value: '630224',
            parentId: '630200'
          },
          {
            id: '630225',
            label: '循化撒拉族自治县',
            value: '630225',
            parentId: '630200'
          }
        ]
      },
      {
        id: '632200',
        label: '海北藏族自治州',
        value: '632200',
        parentId: '630000',
        children: [
          {
            id: '632221',
            label: '门源回族自治县',
            value: '632221',
            parentId: '632200'
          },
          {
            id: '632222',
            label: '祁连县',
            value: '632222',
            parentId: '632200'
          },
          {
            id: '632223',
            label: '海晏县',
            value: '632223',
            parentId: '632200'
          },
          {
            id: '632224',
            label: '刚察县',
            value: '632224',
            parentId: '632200'
          }
        ]
      },
      {
        id: '632300',
        label: '黄南藏族自治州',
        value: '632300',
        parentId: '630000',
        children: [
          {
            id: '632301',
            label: '同仁市',
            value: '632301',
            parentId: '632300'
          },
          {
            id: '632322',
            label: '尖扎县',
            value: '632322',
            parentId: '632300'
          },
          {
            id: '632323',
            label: '泽库县',
            value: '632323',
            parentId: '632300'
          },
          {
            id: '632324',
            label: '河南蒙古族自治县',
            value: '632324',
            parentId: '632300'
          }
        ]
      },
      {
        id: '632500',
        label: '海南藏族自治州',
        value: '632500',
        parentId: '630000',
        children: [
          {
            id: '632521',
            label: '共和县',
            value: '632521',
            parentId: '632500'
          },
          {
            id: '632522',
            label: '同德县',
            value: '632522',
            parentId: '632500'
          },
          {
            id: '632523',
            label: '贵德县',
            value: '632523',
            parentId: '632500'
          },
          {
            id: '632524',
            label: '兴海县',
            value: '632524',
            parentId: '632500'
          },
          {
            id: '632525',
            label: '贵南县',
            value: '632525',
            parentId: '632500'
          }
        ]
      },
      {
        id: '632600',
        label: '果洛藏族自治州',
        value: '632600',
        parentId: '630000',
        children: [
          {
            id: '632621',
            label: '玛沁县',
            value: '632621',
            parentId: '632600'
          },
          {
            id: '632622',
            label: '班玛县',
            value: '632622',
            parentId: '632600'
          },
          {
            id: '632623',
            label: '甘德县',
            value: '632623',
            parentId: '632600'
          },
          {
            id: '632624',
            label: '达日县',
            value: '632624',
            parentId: '632600'
          },
          {
            id: '632625',
            label: '久治县',
            value: '632625',
            parentId: '632600'
          },
          {
            id: '632626',
            label: '玛多县',
            value: '632626',
            parentId: '632600'
          }
        ]
      },
      {
        id: '632700',
        label: '玉树藏族自治州',
        value: '632700',
        parentId: '630000',
        children: [
          {
            id: '632701',
            label: '玉树市',
            value: '632701',
            parentId: '632700'
          },
          {
            id: '632722',
            label: '杂多县',
            value: '632722',
            parentId: '632700'
          },
          {
            id: '632723',
            label: '称多县',
            value: '632723',
            parentId: '632700'
          },
          {
            id: '632724',
            label: '治多县',
            value: '632724',
            parentId: '632700'
          },
          {
            id: '632725',
            label: '囊谦县',
            value: '632725',
            parentId: '632700'
          },
          {
            id: '632726',
            label: '曲麻莱县',
            value: '632726',
            parentId: '632700'
          }
        ]
      },
      {
        id: '632800',
        label: '海西蒙古族藏族自治州',
        value: '632800',
        parentId: '630000',
        children: [
          {
            id: '632801',
            label: '格尔木市',
            value: '632801',
            parentId: '632800'
          },
          {
            id: '632802',
            label: '德令哈市',
            value: '632802',
            parentId: '632800'
          },
          {
            id: '632803',
            label: '茫崖市',
            value: '632803',
            parentId: '632800'
          },
          {
            id: '632821',
            label: '乌兰县',
            value: '632821',
            parentId: '632800'
          },
          {
            id: '632822',
            label: '都兰县',
            value: '632822',
            parentId: '632800'
          },
          {
            id: '632823',
            label: '天峻县',
            value: '632823',
            parentId: '632800'
          },
          {
            id: '632825',
            label: '大柴旦行政委员会',
            value: '632825',
            parentId: '632800'
          }
        ]
      }
    ]
  },
  {
    id: '640000',
    label: '宁夏回族自治区',
    value: '640000',
    children: [
      {
        id: '640100',
        label: '银川市',
        value: '640100',
        parentId: '640000',
        children: [
          {
            id: '640104',
            label: '兴庆区',
            value: '640104',
            parentId: '640100'
          },
          {
            id: '640105',
            label: '西夏区',
            value: '640105',
            parentId: '640100'
          },
          {
            id: '640106',
            label: '金凤区',
            value: '640106',
            parentId: '640100'
          },
          {
            id: '640121',
            label: '永宁县',
            value: '640121',
            parentId: '640100'
          },
          {
            id: '640122',
            label: '贺兰县',
            value: '640122',
            parentId: '640100'
          },
          {
            id: '640181',
            label: '灵武市',
            value: '640181',
            parentId: '640100'
          }
        ]
      },
      {
        id: '640200',
        label: '石嘴山市',
        value: '640200',
        parentId: '640000',
        children: [
          {
            id: '640202',
            label: '大武口区',
            value: '640202',
            parentId: '640200'
          },
          {
            id: '640205',
            label: '惠农区',
            value: '640205',
            parentId: '640200'
          },
          {
            id: '640221',
            label: '平罗县',
            value: '640221',
            parentId: '640200'
          }
        ]
      },
      {
        id: '640300',
        label: '吴忠市',
        value: '640300',
        parentId: '640000',
        children: [
          {
            id: '640302',
            label: '利通区',
            value: '640302',
            parentId: '640300'
          },
          {
            id: '640303',
            label: '红寺堡区',
            value: '640303',
            parentId: '640300'
          },
          {
            id: '640323',
            label: '盐池县',
            value: '640323',
            parentId: '640300'
          },
          {
            id: '640324',
            label: '同心县',
            value: '640324',
            parentId: '640300'
          },
          {
            id: '640381',
            label: '青铜峡市',
            value: '640381',
            parentId: '640300'
          }
        ]
      },
      {
        id: '640400',
        label: '固原市',
        value: '640400',
        parentId: '640000',
        children: [
          {
            id: '640402',
            label: '原州区',
            value: '640402',
            parentId: '640400'
          },
          {
            id: '640422',
            label: '西吉县',
            value: '640422',
            parentId: '640400'
          },
          {
            id: '640423',
            label: '隆德县',
            value: '640423',
            parentId: '640400'
          },
          {
            id: '640424',
            label: '泾源县',
            value: '640424',
            parentId: '640400'
          },
          {
            id: '640425',
            label: '彭阳县',
            value: '640425',
            parentId: '640400'
          }
        ]
      },
      {
        id: '640500',
        label: '中卫市',
        value: '640500',
        parentId: '640000',
        children: [
          {
            id: '640502',
            label: '沙坡头区',
            value: '640502',
            parentId: '640500'
          },
          {
            id: '640521',
            label: '中宁县',
            value: '640521',
            parentId: '640500'
          },
          {
            id: '640522',
            label: '海原县',
            value: '640522',
            parentId: '640500'
          }
        ]
      }
    ]
  },
  {
    id: '650000',
    label: '新疆维吾尔自治区',
    value: '650000',
    children: [
      {
        id: '650100',
        label: '乌鲁木齐市',
        value: '650100',
        parentId: '650000',
        children: [
          {
            id: '650102',
            label: '天山区',
            value: '650102',
            parentId: '650100'
          },
          {
            id: '650103',
            label: '沙依巴克区',
            value: '650103',
            parentId: '650100'
          },
          {
            id: '650104',
            label: '新市区',
            value: '650104',
            parentId: '650100'
          },
          {
            id: '650105',
            label: '水磨沟区',
            value: '650105',
            parentId: '650100'
          },
          {
            id: '650106',
            label: '头屯河区',
            value: '650106',
            parentId: '650100'
          },
          {
            id: '650107',
            label: '达坂城区',
            value: '650107',
            parentId: '650100'
          },
          {
            id: '650109',
            label: '米东区',
            value: '650109',
            parentId: '650100'
          },
          {
            id: '650121',
            label: '乌鲁木齐县',
            value: '650121',
            parentId: '650100'
          }
        ]
      },
      {
        id: '650200',
        label: '克拉玛依市',
        value: '650200',
        parentId: '650000',
        children: [
          {
            id: '650202',
            label: '独山子区',
            value: '650202',
            parentId: '650200'
          },
          {
            id: '650203',
            label: '克拉玛依区',
            value: '650203',
            parentId: '650200'
          },
          {
            id: '650204',
            label: '白碱滩区',
            value: '650204',
            parentId: '650200'
          },
          {
            id: '650205',
            label: '乌尔禾区',
            value: '650205',
            parentId: '650200'
          }
        ]
      },
      {
        id: '650400',
        label: '吐鲁番市',
        value: '650400',
        parentId: '650000',
        children: [
          {
            id: '650402',
            label: '高昌区',
            value: '650402',
            parentId: '650400'
          },
          {
            id: '650421',
            label: '鄯善县',
            value: '650421',
            parentId: '650400'
          },
          {
            id: '650422',
            label: '托克逊县',
            value: '650422',
            parentId: '650400'
          }
        ]
      },
      {
        id: '650500',
        label: '哈密市',
        value: '650500',
        parentId: '650000',
        children: [
          {
            id: '650502',
            label: '伊州区',
            value: '650502',
            parentId: '650500'
          },
          {
            id: '650521',
            label: '巴里坤哈萨克自治县',
            value: '650521',
            parentId: '650500'
          },
          {
            id: '650522',
            label: '伊吾县',
            value: '650522',
            parentId: '650500'
          }
        ]
      },
      {
        id: '652300',
        label: '昌吉回族自治州',
        value: '652300',
        parentId: '650000',
        children: [
          {
            id: '652301',
            label: '昌吉市',
            value: '652301',
            parentId: '652300'
          },
          {
            id: '652302',
            label: '阜康市',
            value: '652302',
            parentId: '652300'
          },
          {
            id: '652323',
            label: '呼图壁县',
            value: '652323',
            parentId: '652300'
          },
          {
            id: '652324',
            label: '玛纳斯县',
            value: '652324',
            parentId: '652300'
          },
          {
            id: '652325',
            label: '奇台县',
            value: '652325',
            parentId: '652300'
          },
          {
            id: '652327',
            label: '吉木萨尔县',
            value: '652327',
            parentId: '652300'
          },
          {
            id: '652328',
            label: '木垒哈萨克自治县',
            value: '652328',
            parentId: '652300'
          }
        ]
      },
      {
        id: '652700',
        label: '博尔塔拉蒙古自治州',
        value: '652700',
        parentId: '650000',
        children: [
          {
            id: '652701',
            label: '博乐市',
            value: '652701',
            parentId: '652700'
          },
          {
            id: '652702',
            label: '阿拉山口市',
            value: '652702',
            parentId: '652700'
          },
          {
            id: '652722',
            label: '精河县',
            value: '652722',
            parentId: '652700'
          },
          {
            id: '652723',
            label: '温泉县',
            value: '652723',
            parentId: '652700'
          }
        ]
      },
      {
        id: '652800',
        label: '巴音郭楞蒙古自治州',
        value: '652800',
        parentId: '650000',
        children: [
          {
            id: '652801',
            label: '库尔勒市',
            value: '652801',
            parentId: '652800'
          },
          {
            id: '652822',
            label: '轮台县',
            value: '652822',
            parentId: '652800'
          },
          {
            id: '652823',
            label: '尉犁县',
            value: '652823',
            parentId: '652800'
          },
          {
            id: '652824',
            label: '若羌县',
            value: '652824',
            parentId: '652800'
          },
          {
            id: '652825',
            label: '且末县',
            value: '652825',
            parentId: '652800'
          },
          {
            id: '652826',
            label: '焉耆回族自治县',
            value: '652826',
            parentId: '652800'
          },
          {
            id: '652827',
            label: '和静县',
            value: '652827',
            parentId: '652800'
          },
          {
            id: '652828',
            label: '和硕县',
            value: '652828',
            parentId: '652800'
          },
          {
            id: '652829',
            label: '博湖县',
            value: '652829',
            parentId: '652800'
          }
        ]
      },
      {
        id: '652900',
        label: '阿克苏地区',
        value: '652900',
        parentId: '650000',
        children: [
          {
            id: '652901',
            label: '阿克苏市',
            value: '652901',
            parentId: '652900'
          },
          {
            id: '652902',
            label: '库车市',
            value: '652902',
            parentId: '652900'
          },
          {
            id: '652922',
            label: '温宿县',
            value: '652922',
            parentId: '652900'
          },
          {
            id: '652924',
            label: '沙雅县',
            value: '652924',
            parentId: '652900'
          },
          {
            id: '652925',
            label: '新和县',
            value: '652925',
            parentId: '652900'
          },
          {
            id: '652926',
            label: '拜城县',
            value: '652926',
            parentId: '652900'
          },
          {
            id: '652927',
            label: '乌什县',
            value: '652927',
            parentId: '652900'
          },
          {
            id: '652928',
            label: '阿瓦提县',
            value: '652928',
            parentId: '652900'
          },
          {
            id: '652929',
            label: '柯坪县',
            value: '652929',
            parentId: '652900'
          }
        ]
      },
      {
        id: '653000',
        label: '克孜勒苏柯尔克孜自治州',
        value: '653000',
        parentId: '650000',
        children: [
          {
            id: '653001',
            label: '阿图什市',
            value: '653001',
            parentId: '653000'
          },
          {
            id: '653022',
            label: '阿克陶县',
            value: '653022',
            parentId: '653000'
          },
          {
            id: '653023',
            label: '阿合奇县',
            value: '653023',
            parentId: '653000'
          },
          {
            id: '653024',
            label: '乌恰县',
            value: '653024',
            parentId: '653000'
          }
        ]
      },
      {
        id: '653100',
        label: '喀什地区',
        value: '653100',
        parentId: '650000',
        children: [
          {
            id: '653101',
            label: '喀什市',
            value: '653101',
            parentId: '653100'
          },
          {
            id: '653121',
            label: '疏附县',
            value: '653121',
            parentId: '653100'
          },
          {
            id: '653122',
            label: '疏勒县',
            value: '653122',
            parentId: '653100'
          },
          {
            id: '653123',
            label: '英吉沙县',
            value: '653123',
            parentId: '653100'
          },
          {
            id: '653124',
            label: '泽普县',
            value: '653124',
            parentId: '653100'
          },
          {
            id: '653125',
            label: '莎车县',
            value: '653125',
            parentId: '653100'
          },
          {
            id: '653126',
            label: '叶城县',
            value: '653126',
            parentId: '653100'
          },
          {
            id: '653127',
            label: '麦盖提县',
            value: '653127',
            parentId: '653100'
          },
          {
            id: '653128',
            label: '岳普湖县',
            value: '653128',
            parentId: '653100'
          },
          {
            id: '653129',
            label: '伽师县',
            value: '653129',
            parentId: '653100'
          },
          {
            id: '653130',
            label: '巴楚县',
            value: '653130',
            parentId: '653100'
          },
          {
            id: '653131',
            label: '塔什库尔干塔吉克自治县',
            value: '653131',
            parentId: '653100'
          }
        ]
      },
      {
        id: '653200',
        label: '和田地区',
        value: '653200',
        parentId: '650000',
        children: [
          {
            id: '653201',
            label: '和田市',
            value: '653201',
            parentId: '653200'
          },
          {
            id: '653221',
            label: '和田县',
            value: '653221',
            parentId: '653200'
          },
          {
            id: '653222',
            label: '墨玉县',
            value: '653222',
            parentId: '653200'
          },
          {
            id: '653223',
            label: '皮山县',
            value: '653223',
            parentId: '653200'
          },
          {
            id: '653224',
            label: '洛浦县',
            value: '653224',
            parentId: '653200'
          },
          {
            id: '653225',
            label: '策勒县',
            value: '653225',
            parentId: '653200'
          },
          {
            id: '653226',
            label: '于田县',
            value: '653226',
            parentId: '653200'
          },
          {
            id: '653227',
            label: '民丰县',
            value: '653227',
            parentId: '653200'
          }
        ]
      },
      {
        id: '654000',
        label: '伊犁哈萨克自治州',
        value: '654000',
        parentId: '650000',
        children: [
          {
            id: '654002',
            label: '伊宁市',
            value: '654002',
            parentId: '654000'
          },
          {
            id: '654003',
            label: '奎屯市',
            value: '654003',
            parentId: '654000'
          },
          {
            id: '654004',
            label: '霍尔果斯市',
            value: '654004',
            parentId: '654000'
          },
          {
            id: '654021',
            label: '伊宁县',
            value: '654021',
            parentId: '654000'
          },
          {
            id: '654022',
            label: '察布查尔锡伯自治县',
            value: '654022',
            parentId: '654000'
          },
          {
            id: '654023',
            label: '霍城县',
            value: '654023',
            parentId: '654000'
          },
          {
            id: '654024',
            label: '巩留县',
            value: '654024',
            parentId: '654000'
          },
          {
            id: '654025',
            label: '新源县',
            value: '654025',
            parentId: '654000'
          },
          {
            id: '654026',
            label: '昭苏县',
            value: '654026',
            parentId: '654000'
          },
          {
            id: '654027',
            label: '特克斯县',
            value: '654027',
            parentId: '654000'
          },
          {
            id: '654028',
            label: '尼勒克县',
            value: '654028',
            parentId: '654000'
          }
        ]
      },
      {
        id: '654200',
        label: '塔城地区',
        value: '654200',
        parentId: '650000',
        children: [
          {
            id: '654201',
            label: '塔城市',
            value: '654201',
            parentId: '654200'
          },
          {
            id: '654202',
            label: '乌苏市',
            value: '654202',
            parentId: '654200'
          },
          {
            id: '654203',
            label: '沙湾市',
            value: '654203',
            parentId: '654200'
          },
          {
            id: '654221',
            label: '额敏县',
            value: '654221',
            parentId: '654200'
          },
          {
            id: '654224',
            label: '托里县',
            value: '654224',
            parentId: '654200'
          },
          {
            id: '654225',
            label: '裕民县',
            value: '654225',
            parentId: '654200'
          },
          {
            id: '654226',
            label: '和布克赛尔蒙古自治县',
            value: '654226',
            parentId: '654200'
          }
        ]
      },
      {
        id: '654300',
        label: '阿勒泰地区',
        value: '654300',
        parentId: '650000',
        children: [
          {
            id: '654301',
            label: '阿勒泰市',
            value: '654301',
            parentId: '654300'
          },
          {
            id: '654321',
            label: '布尔津县',
            value: '654321',
            parentId: '654300'
          },
          {
            id: '654322',
            label: '富蕴县',
            value: '654322',
            parentId: '654300'
          },
          {
            id: '654323',
            label: '福海县',
            value: '654323',
            parentId: '654300'
          },
          {
            id: '654324',
            label: '哈巴河县',
            value: '654324',
            parentId: '654300'
          },
          {
            id: '654325',
            label: '青河县',
            value: '654325',
            parentId: '654300'
          },
          {
            id: '654326',
            label: '吉木乃县',
            value: '654326',
            parentId: '654300'
          }
        ]
      },
      {
        id: '659001',
        label: '石河子市',
        value: '659001',
        parentId: '650000',
        children: [
          {
            id: '659001',
            label: '石河子市',
            value: '659001',
            parentId: '659001'
          }
        ]
      },
      {
        id: '659002',
        label: '阿拉尔市',
        value: '659002',
        parentId: '650000',
        children: [
          {
            id: '659002',
            label: '阿拉尔市',
            value: '659002',
            parentId: '659002'
          }
        ]
      },
      {
        id: '659003',
        label: '图木舒克市',
        value: '659003',
        parentId: '650000',
        children: [
          {
            id: '659003',
            label: '图木舒克市',
            value: '659003',
            parentId: '659003'
          }
        ]
      },
      {
        id: '659004',
        label: '五家渠市',
        value: '659004',
        parentId: '650000',
        children: [
          {
            id: '659004',
            label: '五家渠市',
            value: '659004',
            parentId: '659004'
          }
        ]
      },
      {
        id: '659005',
        label: '北屯市',
        value: '659005',
        parentId: '650000',
        children: [
          {
            id: '659005',
            label: '北屯市',
            value: '659005',
            parentId: '659005'
          }
        ]
      },
      {
        id: '659006',
        label: '铁门关市',
        value: '659006',
        parentId: '650000',
        children: [
          {
            id: '659006',
            label: '铁门关市',
            value: '659006',
            parentId: '659006'
          }
        ]
      },
      {
        id: '659007',
        label: '双河市',
        value: '659007',
        parentId: '650000',
        children: [
          {
            id: '659007',
            label: '双河市',
            value: '659007',
            parentId: '659007'
          }
        ]
      },
      {
        id: '659008',
        label: '可克达拉市',
        value: '659008',
        parentId: '650000',
        children: [
          {
            id: '659008',
            label: '可克达拉市',
            value: '659008',
            parentId: '659008'
          }
        ]
      },
      {
        id: '659009',
        label: '昆玉市',
        value: '659009',
        parentId: '650000',
        children: [
          {
            id: '659009',
            label: '昆玉市',
            value: '659009',
            parentId: '659009'
          }
        ]
      },
      {
        id: '659010',
        label: '胡杨河市',
        value: '659010',
        parentId: '650000',
        children: [
          {
            id: '659010',
            label: '胡杨河市',
            value: '659010',
            parentId: '659010'
          }
        ]
      }
    ]
  },
  {
    id: '710000',
    label: '台湾省',
    value: '710000',
    children: [
      {
        id: '710100',
        label: '台北市',
        value: '710100',
        parentId: '710000',
        children: [
          {
            id: '710101',
            label: '中正区',
            value: '710101',
            parentId: '710100'
          },
          {
            id: '710102',
            label: '大同区',
            value: '710102',
            parentId: '710100'
          },
          {
            id: '710103',
            label: '中山区',
            value: '710103',
            parentId: '710100'
          },
          {
            id: '710104',
            label: '松山区',
            value: '710104',
            parentId: '710100'
          },
          {
            id: '710105',
            label: '大安区',
            value: '710105',
            parentId: '710100'
          },
          {
            id: '710106',
            label: '万华区',
            value: '710106',
            parentId: '710100'
          },
          {
            id: '710107',
            label: '信义区',
            value: '710107',
            parentId: '710100'
          },
          {
            id: '710108',
            label: '士林区',
            value: '710108',
            parentId: '710100'
          },
          {
            id: '710109',
            label: '北投区',
            value: '710109',
            parentId: '710100'
          },
          {
            id: '710110',
            label: '内湖区',
            value: '710110',
            parentId: '710100'
          },
          {
            id: '710111',
            label: '南港区',
            value: '710111',
            parentId: '710100'
          },
          {
            id: '710112',
            label: '文山区',
            value: '710112',
            parentId: '710100'
          }
        ]
      },
      {
        id: '710200',
        label: '高雄市',
        value: '710200',
        parentId: '710000',
        children: [
          {
            id: '710201',
            label: '新兴区',
            value: '710201',
            parentId: '710200'
          },
          {
            id: '710202',
            label: '前金区',
            value: '710202',
            parentId: '710200'
          },
          {
            id: '710203',
            label: '苓雅区',
            value: '710203',
            parentId: '710200'
          },
          {
            id: '710204',
            label: '盐埕区',
            value: '710204',
            parentId: '710200'
          },
          {
            id: '710205',
            label: '鼓山区',
            value: '710205',
            parentId: '710200'
          },
          {
            id: '710206',
            label: '旗津区',
            value: '710206',
            parentId: '710200'
          },
          {
            id: '710207',
            label: '前镇区',
            value: '710207',
            parentId: '710200'
          },
          {
            id: '710208',
            label: '三民区',
            value: '710208',
            parentId: '710200'
          },
          {
            id: '710209',
            label: '左营区',
            value: '710209',
            parentId: '710200'
          },
          {
            id: '710210',
            label: '楠梓区',
            value: '710210',
            parentId: '710200'
          },
          {
            id: '710211',
            label: '小港区',
            value: '710211',
            parentId: '710200'
          },
          {
            id: '710242',
            label: '仁武区',
            value: '710242',
            parentId: '710200'
          },
          {
            id: '710243',
            label: '大社区',
            value: '710243',
            parentId: '710200'
          },
          {
            id: '710244',
            label: '冈山区',
            value: '710244',
            parentId: '710200'
          },
          {
            id: '710245',
            label: '路竹区',
            value: '710245',
            parentId: '710200'
          },
          {
            id: '710246',
            label: '阿莲区',
            value: '710246',
            parentId: '710200'
          },
          {
            id: '710247',
            label: '田寮区',
            value: '710247',
            parentId: '710200'
          },
          {
            id: '710248',
            label: '燕巢区',
            value: '710248',
            parentId: '710200'
          },
          {
            id: '710249',
            label: '桥头区',
            value: '710249',
            parentId: '710200'
          },
          {
            id: '710250',
            label: '梓官区',
            value: '710250',
            parentId: '710200'
          },
          {
            id: '710251',
            label: '弥陀区',
            value: '710251',
            parentId: '710200'
          },
          {
            id: '710252',
            label: '永安区',
            value: '710252',
            parentId: '710200'
          },
          {
            id: '710253',
            label: '湖内区',
            value: '710253',
            parentId: '710200'
          },
          {
            id: '710254',
            label: '凤山区',
            value: '710254',
            parentId: '710200'
          },
          {
            id: '710255',
            label: '大寮区',
            value: '710255',
            parentId: '710200'
          },
          {
            id: '710256',
            label: '林园区',
            value: '710256',
            parentId: '710200'
          },
          {
            id: '710257',
            label: '鸟松区',
            value: '710257',
            parentId: '710200'
          },
          {
            id: '710258',
            label: '大树区',
            value: '710258',
            parentId: '710200'
          },
          {
            id: '710259',
            label: '旗山区',
            value: '710259',
            parentId: '710200'
          },
          {
            id: '710260',
            label: '美浓区',
            value: '710260',
            parentId: '710200'
          },
          {
            id: '710261',
            label: '六龟区',
            value: '710261',
            parentId: '710200'
          },
          {
            id: '710262',
            label: '内门区',
            value: '710262',
            parentId: '710200'
          },
          {
            id: '710263',
            label: '杉林区',
            value: '710263',
            parentId: '710200'
          },
          {
            id: '710264',
            label: '甲仙区',
            value: '710264',
            parentId: '710200'
          },
          {
            id: '710265',
            label: '桃源区',
            value: '710265',
            parentId: '710200'
          },
          {
            id: '710266',
            label: '那玛夏区',
            value: '710266',
            parentId: '710200'
          },
          {
            id: '710267',
            label: '茂林区',
            value: '710267',
            parentId: '710200'
          },
          {
            id: '710268',
            label: '茄萣区',
            value: '710268',
            parentId: '710200'
          }
        ]
      },
      {
        id: '710300',
        label: '台南市',
        value: '710300',
        parentId: '710000',
        children: [
          {
            id: '710301',
            label: '中西区',
            value: '710301',
            parentId: '710300'
          },
          {
            id: '710302',
            label: '东区',
            value: '710302',
            parentId: '710300'
          },
          {
            id: '710303',
            label: '南区',
            value: '710303',
            parentId: '710300'
          },
          {
            id: '710304',
            label: '北区',
            value: '710304',
            parentId: '710300'
          },
          {
            id: '710305',
            label: '安平区',
            value: '710305',
            parentId: '710300'
          },
          {
            id: '710306',
            label: '安南区',
            value: '710306',
            parentId: '710300'
          },
          {
            id: '710339',
            label: '永康区',
            value: '710339',
            parentId: '710300'
          },
          {
            id: '710340',
            label: '归仁区',
            value: '710340',
            parentId: '710300'
          },
          {
            id: '710341',
            label: '新化区',
            value: '710341',
            parentId: '710300'
          },
          {
            id: '710342',
            label: '左镇区',
            value: '710342',
            parentId: '710300'
          },
          {
            id: '710343',
            label: '玉井区',
            value: '710343',
            parentId: '710300'
          },
          {
            id: '710344',
            label: '楠西区',
            value: '710344',
            parentId: '710300'
          },
          {
            id: '710345',
            label: '南化区',
            value: '710345',
            parentId: '710300'
          },
          {
            id: '710346',
            label: '仁德区',
            value: '710346',
            parentId: '710300'
          },
          {
            id: '710347',
            label: '关庙区',
            value: '710347',
            parentId: '710300'
          },
          {
            id: '710348',
            label: '龙崎区',
            value: '710348',
            parentId: '710300'
          },
          {
            id: '710349',
            label: '官田区',
            value: '710349',
            parentId: '710300'
          },
          {
            id: '710350',
            label: '麻豆区',
            value: '710350',
            parentId: '710300'
          },
          {
            id: '710351',
            label: '佳里区',
            value: '710351',
            parentId: '710300'
          },
          {
            id: '710352',
            label: '西港区',
            value: '710352',
            parentId: '710300'
          },
          {
            id: '710353',
            label: '七股区',
            value: '710353',
            parentId: '710300'
          },
          {
            id: '710354',
            label: '将军区',
            value: '710354',
            parentId: '710300'
          },
          {
            id: '710355',
            label: '学甲区',
            value: '710355',
            parentId: '710300'
          },
          {
            id: '710356',
            label: '北门区',
            value: '710356',
            parentId: '710300'
          },
          {
            id: '710357',
            label: '新营区',
            value: '710357',
            parentId: '710300'
          },
          {
            id: '710358',
            label: '后壁区',
            value: '710358',
            parentId: '710300'
          },
          {
            id: '710359',
            label: '白河区',
            value: '710359',
            parentId: '710300'
          },
          {
            id: '710360',
            label: '东山区',
            value: '710360',
            parentId: '710300'
          },
          {
            id: '710361',
            label: '六甲区',
            value: '710361',
            parentId: '710300'
          },
          {
            id: '710362',
            label: '下营区',
            value: '710362',
            parentId: '710300'
          },
          {
            id: '710363',
            label: '柳营区',
            value: '710363',
            parentId: '710300'
          },
          {
            id: '710364',
            label: '盐水区',
            value: '710364',
            parentId: '710300'
          },
          {
            id: '710365',
            label: '善化区',
            value: '710365',
            parentId: '710300'
          },
          {
            id: '710366',
            label: '大内区',
            value: '710366',
            parentId: '710300'
          },
          {
            id: '710367',
            label: '山上区',
            value: '710367',
            parentId: '710300'
          },
          {
            id: '710368',
            label: '新市区',
            value: '710368',
            parentId: '710300'
          },
          {
            id: '710369',
            label: '安定区',
            value: '710369',
            parentId: '710300'
          }
        ]
      },
      {
        id: '710400',
        label: '台中市',
        value: '710400',
        parentId: '710000',
        children: [
          {
            id: '710401',
            label: '中区',
            value: '710401',
            parentId: '710400'
          },
          {
            id: '710402',
            label: '东区',
            value: '710402',
            parentId: '710400'
          },
          {
            id: '710403',
            label: '南区',
            value: '710403',
            parentId: '710400'
          },
          {
            id: '710404',
            label: '西区',
            value: '710404',
            parentId: '710400'
          },
          {
            id: '710405',
            label: '北区',
            value: '710405',
            parentId: '710400'
          },
          {
            id: '710406',
            label: '北屯区',
            value: '710406',
            parentId: '710400'
          },
          {
            id: '710407',
            label: '西屯区',
            value: '710407',
            parentId: '710400'
          },
          {
            id: '710408',
            label: '南屯区',
            value: '710408',
            parentId: '710400'
          },
          {
            id: '710431',
            label: '太平区',
            value: '710431',
            parentId: '710400'
          },
          {
            id: '710432',
            label: '大里区',
            value: '710432',
            parentId: '710400'
          },
          {
            id: '710433',
            label: '雾峰区',
            value: '710433',
            parentId: '710400'
          },
          {
            id: '710434',
            label: '乌日区',
            value: '710434',
            parentId: '710400'
          },
          {
            id: '710435',
            label: '丰原区',
            value: '710435',
            parentId: '710400'
          },
          {
            id: '710436',
            label: '后里区',
            value: '710436',
            parentId: '710400'
          },
          {
            id: '710437',
            label: '石冈区',
            value: '710437',
            parentId: '710400'
          },
          {
            id: '710438',
            label: '东势区',
            value: '710438',
            parentId: '710400'
          },
          {
            id: '710439',
            label: '和平区',
            value: '710439',
            parentId: '710400'
          },
          {
            id: '710440',
            label: '新社区',
            value: '710440',
            parentId: '710400'
          },
          {
            id: '710441',
            label: '潭子区',
            value: '710441',
            parentId: '710400'
          },
          {
            id: '710442',
            label: '大雅区',
            value: '710442',
            parentId: '710400'
          },
          {
            id: '710443',
            label: '神冈区',
            value: '710443',
            parentId: '710400'
          },
          {
            id: '710444',
            label: '大肚区',
            value: '710444',
            parentId: '710400'
          },
          {
            id: '710445',
            label: '沙鹿区',
            value: '710445',
            parentId: '710400'
          },
          {
            id: '710446',
            label: '龙井区',
            value: '710446',
            parentId: '710400'
          },
          {
            id: '710447',
            label: '梧栖区',
            value: '710447',
            parentId: '710400'
          },
          {
            id: '710448',
            label: '清水区',
            value: '710448',
            parentId: '710400'
          },
          {
            id: '710449',
            label: '大甲区',
            value: '710449',
            parentId: '710400'
          },
          {
            id: '710450',
            label: '外埔区',
            value: '710450',
            parentId: '710400'
          },
          {
            id: '710451',
            label: '大安区',
            value: '710451',
            parentId: '710400'
          }
        ]
      },
      {
        id: '710600',
        label: '南投县',
        value: '710600',
        parentId: '710000',
        children: [
          {
            id: '710614',
            label: '南投市',
            value: '710614',
            parentId: '710600'
          },
          {
            id: '710615',
            label: '中寮乡',
            value: '710615',
            parentId: '710600'
          },
          {
            id: '710616',
            label: '草屯镇',
            value: '710616',
            parentId: '710600'
          },
          {
            id: '710617',
            label: '国姓乡',
            value: '710617',
            parentId: '710600'
          },
          {
            id: '710618',
            label: '埔里镇',
            value: '710618',
            parentId: '710600'
          },
          {
            id: '710619',
            label: '仁爱乡',
            value: '710619',
            parentId: '710600'
          },
          {
            id: '710620',
            label: '名间乡',
            value: '710620',
            parentId: '710600'
          },
          {
            id: '710621',
            label: '集集镇',
            value: '710621',
            parentId: '710600'
          },
          {
            id: '710622',
            label: '水里乡',
            value: '710622',
            parentId: '710600'
          },
          {
            id: '710623',
            label: '鱼池乡',
            value: '710623',
            parentId: '710600'
          },
          {
            id: '710624',
            label: '信义乡',
            value: '710624',
            parentId: '710600'
          },
          {
            id: '710625',
            label: '竹山镇',
            value: '710625',
            parentId: '710600'
          },
          {
            id: '710626',
            label: '鹿谷乡',
            value: '710626',
            parentId: '710600'
          }
        ]
      },
      {
        id: '710700',
        label: '基隆市',
        value: '710700',
        parentId: '710000',
        children: [
          {
            id: '710701',
            label: '仁爱区',
            value: '710701',
            parentId: '710700'
          },
          {
            id: '710702',
            label: '信义区',
            value: '710702',
            parentId: '710700'
          },
          {
            id: '710703',
            label: '中正区',
            value: '710703',
            parentId: '710700'
          },
          {
            id: '710704',
            label: '中山区',
            value: '710704',
            parentId: '710700'
          },
          {
            id: '710705',
            label: '安乐区',
            value: '710705',
            parentId: '710700'
          },
          {
            id: '710706',
            label: '暖暖区',
            value: '710706',
            parentId: '710700'
          },
          {
            id: '710707',
            label: '七堵区',
            value: '710707',
            parentId: '710700'
          }
        ]
      },
      {
        id: '710800',
        label: '新竹市',
        value: '710800',
        parentId: '710000',
        children: [
          {
            id: '710801',
            label: '东区',
            value: '710801',
            parentId: '710800'
          },
          {
            id: '710802',
            label: '北区',
            value: '710802',
            parentId: '710800'
          },
          {
            id: '710803',
            label: '香山区',
            value: '710803',
            parentId: '710800'
          }
        ]
      },
      {
        id: '710900',
        label: '嘉义市',
        value: '710900',
        parentId: '710000',
        children: [
          {
            id: '710901',
            label: '东区',
            value: '710901',
            parentId: '710900'
          },
          {
            id: '710902',
            label: '西区',
            value: '710902',
            parentId: '710900'
          }
        ]
      },
      {
        id: '711100',
        label: '新北市',
        value: '711100',
        parentId: '710000',
        children: [
          {
            id: '711130',
            label: '万里区',
            value: '711130',
            parentId: '711100'
          },
          {
            id: '711131',
            label: '金山区',
            value: '711131',
            parentId: '711100'
          },
          {
            id: '711132',
            label: '板桥区',
            value: '711132',
            parentId: '711100'
          },
          {
            id: '711133',
            label: '汐止区',
            value: '711133',
            parentId: '711100'
          },
          {
            id: '711134',
            label: '深坑区',
            value: '711134',
            parentId: '711100'
          },
          {
            id: '711135',
            label: '石碇区',
            value: '711135',
            parentId: '711100'
          },
          {
            id: '711136',
            label: '瑞芳区',
            value: '711136',
            parentId: '711100'
          },
          {
            id: '711137',
            label: '平溪区',
            value: '711137',
            parentId: '711100'
          },
          {
            id: '711138',
            label: '双溪区',
            value: '711138',
            parentId: '711100'
          },
          {
            id: '711139',
            label: '贡寮区',
            value: '711139',
            parentId: '711100'
          },
          {
            id: '711140',
            label: '新店区',
            value: '711140',
            parentId: '711100'
          },
          {
            id: '711141',
            label: '坪林区',
            value: '711141',
            parentId: '711100'
          },
          {
            id: '711142',
            label: '乌来区',
            value: '711142',
            parentId: '711100'
          },
          {
            id: '711143',
            label: '永和区',
            value: '711143',
            parentId: '711100'
          },
          {
            id: '711144',
            label: '中和区',
            value: '711144',
            parentId: '711100'
          },
          {
            id: '711145',
            label: '土城区',
            value: '711145',
            parentId: '711100'
          },
          {
            id: '711146',
            label: '三峡区',
            value: '711146',
            parentId: '711100'
          },
          {
            id: '711147',
            label: '树林区',
            value: '711147',
            parentId: '711100'
          },
          {
            id: '711148',
            label: '莺歌区',
            value: '711148',
            parentId: '711100'
          },
          {
            id: '711149',
            label: '三重区',
            value: '711149',
            parentId: '711100'
          },
          {
            id: '711150',
            label: '新庄区',
            value: '711150',
            parentId: '711100'
          },
          {
            id: '711151',
            label: '泰山区',
            value: '711151',
            parentId: '711100'
          },
          {
            id: '711152',
            label: '林口区',
            value: '711152',
            parentId: '711100'
          },
          {
            id: '711153',
            label: '芦洲区',
            value: '711153',
            parentId: '711100'
          },
          {
            id: '711154',
            label: '五股区',
            value: '711154',
            parentId: '711100'
          },
          {
            id: '711155',
            label: '八里区',
            value: '711155',
            parentId: '711100'
          },
          {
            id: '711156',
            label: '淡水区',
            value: '711156',
            parentId: '711100'
          },
          {
            id: '711157',
            label: '三芝区',
            value: '711157',
            parentId: '711100'
          },
          {
            id: '711158',
            label: '石门区',
            value: '711158',
            parentId: '711100'
          }
        ]
      },
      {
        id: '711200',
        label: '宜兰县',
        value: '711200',
        parentId: '710000',
        children: [
          {
            id: '711214',
            label: '宜兰市',
            value: '711214',
            parentId: '711200'
          },
          {
            id: '711215',
            label: '头城镇',
            value: '711215',
            parentId: '711200'
          },
          {
            id: '711216',
            label: '礁溪乡',
            value: '711216',
            parentId: '711200'
          },
          {
            id: '711217',
            label: '壮围乡',
            value: '711217',
            parentId: '711200'
          },
          {
            id: '711218',
            label: '员山乡',
            value: '711218',
            parentId: '711200'
          },
          {
            id: '711219',
            label: '罗东镇',
            value: '711219',
            parentId: '711200'
          },
          {
            id: '711220',
            label: '三星乡',
            value: '711220',
            parentId: '711200'
          },
          {
            id: '711221',
            label: '大同乡',
            value: '711221',
            parentId: '711200'
          },
          {
            id: '711222',
            label: '五结乡',
            value: '711222',
            parentId: '711200'
          },
          {
            id: '711223',
            label: '冬山乡',
            value: '711223',
            parentId: '711200'
          },
          {
            id: '711224',
            label: '苏澳镇',
            value: '711224',
            parentId: '711200'
          },
          {
            id: '711225',
            label: '南澳乡',
            value: '711225',
            parentId: '711200'
          }
        ]
      },
      {
        id: '711300',
        label: '新竹县',
        value: '711300',
        parentId: '710000',
        children: [
          {
            id: '711314',
            label: '竹北市',
            value: '711314',
            parentId: '711300'
          },
          {
            id: '711315',
            label: '湖口乡',
            value: '711315',
            parentId: '711300'
          },
          {
            id: '711316',
            label: '新丰乡',
            value: '711316',
            parentId: '711300'
          },
          {
            id: '711317',
            label: '新埔镇',
            value: '711317',
            parentId: '711300'
          },
          {
            id: '711318',
            label: '关西镇',
            value: '711318',
            parentId: '711300'
          },
          {
            id: '711319',
            label: '芎林乡',
            value: '711319',
            parentId: '711300'
          },
          {
            id: '711320',
            label: '宝山乡',
            value: '711320',
            parentId: '711300'
          },
          {
            id: '711321',
            label: '竹东镇',
            value: '711321',
            parentId: '711300'
          },
          {
            id: '711322',
            label: '五峰乡',
            value: '711322',
            parentId: '711300'
          },
          {
            id: '711323',
            label: '横山乡',
            value: '711323',
            parentId: '711300'
          },
          {
            id: '711324',
            label: '尖石乡',
            value: '711324',
            parentId: '711300'
          },
          {
            id: '711325',
            label: '北埔乡',
            value: '711325',
            parentId: '711300'
          },
          {
            id: '711326',
            label: '峨眉乡',
            value: '711326',
            parentId: '711300'
          }
        ]
      },
      {
        id: '711400',
        label: '桃园市',
        value: '711400',
        parentId: '710000',
        children: [
          {
            id: '711414',
            label: '中坜区',
            value: '711414',
            parentId: '711400'
          },
          {
            id: '711415',
            label: '平镇区',
            value: '711415',
            parentId: '711400'
          },
          {
            id: '711416',
            label: '龙潭区',
            value: '711416',
            parentId: '711400'
          },
          {
            id: '711417',
            label: '杨梅区',
            value: '711417',
            parentId: '711400'
          },
          {
            id: '711418',
            label: '新屋区',
            value: '711418',
            parentId: '711400'
          },
          {
            id: '711419',
            label: '观音区',
            value: '711419',
            parentId: '711400'
          },
          {
            id: '711420',
            label: '桃园区',
            value: '711420',
            parentId: '711400'
          },
          {
            id: '711421',
            label: '龟山区',
            value: '711421',
            parentId: '711400'
          },
          {
            id: '711422',
            label: '八德区',
            value: '711422',
            parentId: '711400'
          },
          {
            id: '711423',
            label: '大溪区',
            value: '711423',
            parentId: '711400'
          },
          {
            id: '711424',
            label: '复兴区',
            value: '711424',
            parentId: '711400'
          },
          {
            id: '711425',
            label: '大园区',
            value: '711425',
            parentId: '711400'
          },
          {
            id: '711426',
            label: '芦竹区',
            value: '711426',
            parentId: '711400'
          }
        ]
      },
      {
        id: '711500',
        label: '苗栗县',
        value: '711500',
        parentId: '710000',
        children: [
          {
            id: '711519',
            label: '竹南镇',
            value: '711519',
            parentId: '711500'
          },
          {
            id: '711520',
            label: '头份市',
            value: '711520',
            parentId: '711500'
          },
          {
            id: '711521',
            label: '三湾乡',
            value: '711521',
            parentId: '711500'
          },
          {
            id: '711522',
            label: '南庄乡',
            value: '711522',
            parentId: '711500'
          },
          {
            id: '711523',
            label: '狮潭乡',
            value: '711523',
            parentId: '711500'
          },
          {
            id: '711524',
            label: '后龙镇',
            value: '711524',
            parentId: '711500'
          },
          {
            id: '711525',
            label: '通霄镇',
            value: '711525',
            parentId: '711500'
          },
          {
            id: '711526',
            label: '苑里镇',
            value: '711526',
            parentId: '711500'
          },
          {
            id: '711527',
            label: '苗栗市',
            value: '711527',
            parentId: '711500'
          },
          {
            id: '711528',
            label: '造桥乡',
            value: '711528',
            parentId: '711500'
          },
          {
            id: '711529',
            label: '头屋乡',
            value: '711529',
            parentId: '711500'
          },
          {
            id: '711530',
            label: '公馆乡',
            value: '711530',
            parentId: '711500'
          },
          {
            id: '711531',
            label: '大湖乡',
            value: '711531',
            parentId: '711500'
          },
          {
            id: '711532',
            label: '泰安乡',
            value: '711532',
            parentId: '711500'
          },
          {
            id: '711533',
            label: '铜锣乡',
            value: '711533',
            parentId: '711500'
          },
          {
            id: '711534',
            label: '三义乡',
            value: '711534',
            parentId: '711500'
          },
          {
            id: '711535',
            label: '西湖乡',
            value: '711535',
            parentId: '711500'
          },
          {
            id: '711536',
            label: '卓兰镇',
            value: '711536',
            parentId: '711500'
          }
        ]
      },
      {
        id: '711700',
        label: '彰化县',
        value: '711700',
        parentId: '710000',
        children: [
          {
            id: '711727',
            label: '彰化市',
            value: '711727',
            parentId: '711700'
          },
          {
            id: '711728',
            label: '芬园乡',
            value: '711728',
            parentId: '711700'
          },
          {
            id: '711729',
            label: '花坛乡',
            value: '711729',
            parentId: '711700'
          },
          {
            id: '711730',
            label: '秀水乡',
            value: '711730',
            parentId: '711700'
          },
          {
            id: '711731',
            label: '鹿港镇',
            value: '711731',
            parentId: '711700'
          },
          {
            id: '711732',
            label: '福兴乡',
            value: '711732',
            parentId: '711700'
          },
          {
            id: '711733',
            label: '线西乡',
            value: '711733',
            parentId: '711700'
          },
          {
            id: '711734',
            label: '和美镇',
            value: '711734',
            parentId: '711700'
          },
          {
            id: '711735',
            label: '伸港乡',
            value: '711735',
            parentId: '711700'
          },
          {
            id: '711736',
            label: '员林市',
            value: '711736',
            parentId: '711700'
          },
          {
            id: '711737',
            label: '社头乡',
            value: '711737',
            parentId: '711700'
          },
          {
            id: '711738',
            label: '永靖乡',
            value: '711738',
            parentId: '711700'
          },
          {
            id: '711739',
            label: '埔心乡',
            value: '711739',
            parentId: '711700'
          },
          {
            id: '711740',
            label: '溪湖镇',
            value: '711740',
            parentId: '711700'
          },
          {
            id: '711741',
            label: '大村乡',
            value: '711741',
            parentId: '711700'
          },
          {
            id: '711742',
            label: '埔盐乡',
            value: '711742',
            parentId: '711700'
          },
          {
            id: '711743',
            label: '田中镇',
            value: '711743',
            parentId: '711700'
          },
          {
            id: '711744',
            label: '北斗镇',
            value: '711744',
            parentId: '711700'
          },
          {
            id: '711745',
            label: '田尾乡',
            value: '711745',
            parentId: '711700'
          },
          {
            id: '711746',
            label: '埤头乡',
            value: '711746',
            parentId: '711700'
          },
          {
            id: '711747',
            label: '溪州乡',
            value: '711747',
            parentId: '711700'
          },
          {
            id: '711748',
            label: '竹塘乡',
            value: '711748',
            parentId: '711700'
          },
          {
            id: '711749',
            label: '二林镇',
            value: '711749',
            parentId: '711700'
          },
          {
            id: '711750',
            label: '大城乡',
            value: '711750',
            parentId: '711700'
          },
          {
            id: '711751',
            label: '芳苑乡',
            value: '711751',
            parentId: '711700'
          },
          {
            id: '711752',
            label: '二水乡',
            value: '711752',
            parentId: '711700'
          }
        ]
      },
      {
        id: '711900',
        label: '嘉义县',
        value: '711900',
        parentId: '710000',
        children: [
          {
            id: '711919',
            label: '番路乡',
            value: '711919',
            parentId: '711900'
          },
          {
            id: '711920',
            label: '梅山乡',
            value: '711920',
            parentId: '711900'
          },
          {
            id: '711921',
            label: '竹崎乡',
            value: '711921',
            parentId: '711900'
          },
          {
            id: '711922',
            label: '阿里山乡',
            value: '711922',
            parentId: '711900'
          },
          {
            id: '711923',
            label: '中埔乡',
            value: '711923',
            parentId: '711900'
          },
          {
            id: '711924',
            label: '大埔乡',
            value: '711924',
            parentId: '711900'
          },
          {
            id: '711925',
            label: '水上乡',
            value: '711925',
            parentId: '711900'
          },
          {
            id: '711926',
            label: '鹿草乡',
            value: '711926',
            parentId: '711900'
          },
          {
            id: '711927',
            label: '太保市',
            value: '711927',
            parentId: '711900'
          },
          {
            id: '711928',
            label: '朴子市',
            value: '711928',
            parentId: '711900'
          },
          {
            id: '711929',
            label: '东石乡',
            value: '711929',
            parentId: '711900'
          },
          {
            id: '711930',
            label: '六脚乡',
            value: '711930',
            parentId: '711900'
          },
          {
            id: '711931',
            label: '新港乡',
            value: '711931',
            parentId: '711900'
          },
          {
            id: '711932',
            label: '民雄乡',
            value: '711932',
            parentId: '711900'
          },
          {
            id: '711933',
            label: '大林镇',
            value: '711933',
            parentId: '711900'
          },
          {
            id: '711934',
            label: '溪口乡',
            value: '711934',
            parentId: '711900'
          },
          {
            id: '711935',
            label: '义竹乡',
            value: '711935',
            parentId: '711900'
          },
          {
            id: '711936',
            label: '布袋镇',
            value: '711936',
            parentId: '711900'
          }
        ]
      },
      {
        id: '712100',
        label: '云林县',
        value: '712100',
        parentId: '710000',
        children: [
          {
            id: '712121',
            label: '斗南镇',
            value: '712121',
            parentId: '712100'
          },
          {
            id: '712122',
            label: '大埤乡',
            value: '712122',
            parentId: '712100'
          },
          {
            id: '712123',
            label: '虎尾镇',
            value: '712123',
            parentId: '712100'
          },
          {
            id: '712124',
            label: '土库镇',
            value: '712124',
            parentId: '712100'
          },
          {
            id: '712125',
            label: '褒忠乡',
            value: '712125',
            parentId: '712100'
          },
          {
            id: '712126',
            label: '东势乡',
            value: '712126',
            parentId: '712100'
          },
          {
            id: '712127',
            label: '台西乡',
            value: '712127',
            parentId: '712100'
          },
          {
            id: '712128',
            label: '仑背乡',
            value: '712128',
            parentId: '712100'
          },
          {
            id: '712129',
            label: '麦寮乡',
            value: '712129',
            parentId: '712100'
          },
          {
            id: '712130',
            label: '斗六市',
            value: '712130',
            parentId: '712100'
          },
          {
            id: '712131',
            label: '林内乡',
            value: '712131',
            parentId: '712100'
          },
          {
            id: '712132',
            label: '古坑乡',
            value: '712132',
            parentId: '712100'
          },
          {
            id: '712133',
            label: '莿桐乡',
            value: '712133',
            parentId: '712100'
          },
          {
            id: '712134',
            label: '西螺镇',
            value: '712134',
            parentId: '712100'
          },
          {
            id: '712135',
            label: '二仑乡',
            value: '712135',
            parentId: '712100'
          },
          {
            id: '712136',
            label: '北港镇',
            value: '712136',
            parentId: '712100'
          },
          {
            id: '712137',
            label: '水林乡',
            value: '712137',
            parentId: '712100'
          },
          {
            id: '712138',
            label: '口湖乡',
            value: '712138',
            parentId: '712100'
          },
          {
            id: '712139',
            label: '四湖乡',
            value: '712139',
            parentId: '712100'
          },
          {
            id: '712140',
            label: '元长乡',
            value: '712140',
            parentId: '712100'
          }
        ]
      },
      {
        id: '712400',
        label: '屏东县',
        value: '712400',
        parentId: '710000',
        children: [
          {
            id: '712434',
            label: '屏东市',
            value: '712434',
            parentId: '712400'
          },
          {
            id: '712435',
            label: '三地门乡',
            value: '712435',
            parentId: '712400'
          },
          {
            id: '712436',
            label: '雾台乡',
            value: '712436',
            parentId: '712400'
          },
          {
            id: '712437',
            label: '玛家乡',
            value: '712437',
            parentId: '712400'
          },
          {
            id: '712438',
            label: '九如乡',
            value: '712438',
            parentId: '712400'
          },
          {
            id: '712439',
            label: '里港乡',
            value: '712439',
            parentId: '712400'
          },
          {
            id: '712440',
            label: '高树乡',
            value: '712440',
            parentId: '712400'
          },
          {
            id: '712441',
            label: '盐埔乡',
            value: '712441',
            parentId: '712400'
          },
          {
            id: '712442',
            label: '长治乡',
            value: '712442',
            parentId: '712400'
          },
          {
            id: '712443',
            label: '麟洛乡',
            value: '712443',
            parentId: '712400'
          },
          {
            id: '712444',
            label: '竹田乡',
            value: '712444',
            parentId: '712400'
          },
          {
            id: '712445',
            label: '内埔乡',
            value: '712445',
            parentId: '712400'
          },
          {
            id: '712446',
            label: '万丹乡',
            value: '712446',
            parentId: '712400'
          },
          {
            id: '712447',
            label: '潮州镇',
            value: '712447',
            parentId: '712400'
          },
          {
            id: '712448',
            label: '泰武乡',
            value: '712448',
            parentId: '712400'
          },
          {
            id: '712449',
            label: '来义乡',
            value: '712449',
            parentId: '712400'
          },
          {
            id: '712450',
            label: '万峦乡',
            value: '712450',
            parentId: '712400'
          },
          {
            id: '712451',
            label: '崁顶乡',
            value: '712451',
            parentId: '712400'
          },
          {
            id: '712452',
            label: '新埤乡',
            value: '712452',
            parentId: '712400'
          },
          {
            id: '712453',
            label: '南州乡',
            value: '712453',
            parentId: '712400'
          },
          {
            id: '712454',
            label: '林边乡',
            value: '712454',
            parentId: '712400'
          },
          {
            id: '712455',
            label: '东港镇',
            value: '712455',
            parentId: '712400'
          },
          {
            id: '712456',
            label: '琉球乡',
            value: '712456',
            parentId: '712400'
          },
          {
            id: '712457',
            label: '佳冬乡',
            value: '712457',
            parentId: '712400'
          },
          {
            id: '712458',
            label: '新园乡',
            value: '712458',
            parentId: '712400'
          },
          {
            id: '712459',
            label: '枋寮乡',
            value: '712459',
            parentId: '712400'
          },
          {
            id: '712460',
            label: '枋山乡',
            value: '712460',
            parentId: '712400'
          },
          {
            id: '712461',
            label: '春日乡',
            value: '712461',
            parentId: '712400'
          },
          {
            id: '712462',
            label: '狮子乡',
            value: '712462',
            parentId: '712400'
          },
          {
            id: '712463',
            label: '车城乡',
            value: '712463',
            parentId: '712400'
          },
          {
            id: '712464',
            label: '牡丹乡',
            value: '712464',
            parentId: '712400'
          },
          {
            id: '712465',
            label: '恒春镇',
            value: '712465',
            parentId: '712400'
          },
          {
            id: '712466',
            label: '满州乡',
            value: '712466',
            parentId: '712400'
          }
        ]
      },
      {
        id: '712500',
        label: '台东县',
        value: '712500',
        parentId: '710000',
        children: [
          {
            id: '712517',
            label: '台东市',
            value: '712517',
            parentId: '712500'
          },
          {
            id: '712518',
            label: '绿岛乡',
            value: '712518',
            parentId: '712500'
          },
          {
            id: '712519',
            label: '兰屿乡',
            value: '712519',
            parentId: '712500'
          },
          {
            id: '712520',
            label: '延平乡',
            value: '712520',
            parentId: '712500'
          },
          {
            id: '712521',
            label: '卑南乡',
            value: '712521',
            parentId: '712500'
          },
          {
            id: '712522',
            label: '鹿野乡',
            value: '712522',
            parentId: '712500'
          },
          {
            id: '712523',
            label: '关山镇',
            value: '712523',
            parentId: '712500'
          },
          {
            id: '712524',
            label: '海端乡',
            value: '712524',
            parentId: '712500'
          },
          {
            id: '712525',
            label: '池上乡',
            value: '712525',
            parentId: '712500'
          },
          {
            id: '712526',
            label: '东河乡',
            value: '712526',
            parentId: '712500'
          },
          {
            id: '712527',
            label: '成功镇',
            value: '712527',
            parentId: '712500'
          },
          {
            id: '712528',
            label: '长滨乡',
            value: '712528',
            parentId: '712500'
          },
          {
            id: '712529',
            label: '金峰乡',
            value: '712529',
            parentId: '712500'
          },
          {
            id: '712530',
            label: '大武乡',
            value: '712530',
            parentId: '712500'
          },
          {
            id: '712531',
            label: '达仁乡',
            value: '712531',
            parentId: '712500'
          },
          {
            id: '712532',
            label: '太麻里乡',
            value: '712532',
            parentId: '712500'
          }
        ]
      },
      {
        id: '712600',
        label: '花莲县',
        value: '712600',
        parentId: '710000',
        children: [
          {
            id: '712615',
            label: '花莲市',
            value: '712615',
            parentId: '712600'
          },
          {
            id: '712616',
            label: '新城乡',
            value: '712616',
            parentId: '712600'
          },
          {
            id: '712618',
            label: '秀林乡',
            value: '712618',
            parentId: '712600'
          },
          {
            id: '712619',
            label: '吉安乡',
            value: '712619',
            parentId: '712600'
          },
          {
            id: '712620',
            label: '寿丰乡',
            value: '712620',
            parentId: '712600'
          },
          {
            id: '712621',
            label: '凤林镇',
            value: '712621',
            parentId: '712600'
          },
          {
            id: '712622',
            label: '光复乡',
            value: '712622',
            parentId: '712600'
          },
          {
            id: '712623',
            label: '丰滨乡',
            value: '712623',
            parentId: '712600'
          },
          {
            id: '712624',
            label: '瑞穗乡',
            value: '712624',
            parentId: '712600'
          },
          {
            id: '712625',
            label: '万荣乡',
            value: '712625',
            parentId: '712600'
          },
          {
            id: '712626',
            label: '玉里镇',
            value: '712626',
            parentId: '712600'
          },
          {
            id: '712627',
            label: '卓溪乡',
            value: '712627',
            parentId: '712600'
          },
          {
            id: '712628',
            label: '富里乡',
            value: '712628',
            parentId: '712600'
          }
        ]
      },
      {
        id: '712700',
        label: '澎湖县',
        value: '712700',
        parentId: '710000',
        children: [
          {
            id: '712707',
            label: '马公市',
            value: '712707',
            parentId: '712700'
          },
          {
            id: '712708',
            label: '西屿乡',
            value: '712708',
            parentId: '712700'
          },
          {
            id: '712709',
            label: '望安乡',
            value: '712709',
            parentId: '712700'
          },
          {
            id: '712710',
            label: '七美乡',
            value: '712710',
            parentId: '712700'
          },
          {
            id: '712711',
            label: '白沙乡',
            value: '712711',
            parentId: '712700'
          },
          {
            id: '712712',
            label: '湖西乡',
            value: '712712',
            parentId: '712700'
          }
        ]
      }
    ]
  },
  {
    id: '810000',
    label: '香港',
    value: '810000',
    children: [
      {
        id: '810100',
        label: '香港特别行政区',
        value: '810100',
        parentId: '810000',
        children: [
          {
            id: '810101',
            label: '中西区',
            value: '810101',
            parentId: '810100'
          },
          {
            id: '810102',
            label: '东区',
            value: '810102',
            parentId: '810100'
          },
          {
            id: '810103',
            label: '九龙城区',
            value: '810103',
            parentId: '810100'
          },
          {
            id: '810104',
            label: '观塘区',
            value: '810104',
            parentId: '810100'
          },
          {
            id: '810105',
            label: '南区',
            value: '810105',
            parentId: '810100'
          },
          {
            id: '810106',
            label: '深水埗区',
            value: '810106',
            parentId: '810100'
          },
          {
            id: '810107',
            label: '湾仔区',
            value: '810107',
            parentId: '810100'
          },
          {
            id: '810108',
            label: '黄大仙区',
            value: '810108',
            parentId: '810100'
          },
          {
            id: '810109',
            label: '油尖旺区',
            value: '810109',
            parentId: '810100'
          },
          {
            id: '810110',
            label: '离岛区',
            value: '810110',
            parentId: '810100'
          },
          {
            id: '810111',
            label: '葵青区',
            value: '810111',
            parentId: '810100'
          },
          {
            id: '810112',
            label: '北区',
            value: '810112',
            parentId: '810100'
          },
          {
            id: '810113',
            label: '西贡区',
            value: '810113',
            parentId: '810100'
          },
          {
            id: '810114',
            label: '沙田区',
            value: '810114',
            parentId: '810100'
          },
          {
            id: '810115',
            label: '屯门区',
            value: '810115',
            parentId: '810100'
          },
          {
            id: '810116',
            label: '大埔区',
            value: '810116',
            parentId: '810100'
          },
          {
            id: '810117',
            label: '荃湾区',
            value: '810117',
            parentId: '810100'
          },
          {
            id: '810118',
            label: '元朗区',
            value: '810118',
            parentId: '810100'
          }
        ]
      }
    ]
  },
  {
    id: '820000',
    label: '澳门',
    value: '820000',
    children: [
      {
        id: '820100',
        label: '澳门特别行政区',
        value: '820100',
        parentId: '820000',
        children: [
          {
            id: '820101',
            label: '澳门半岛',
            value: '820101',
            parentId: '820100'
          },
          {
            id: '820102',
            label: '凼仔',
            value: '820102',
            parentId: '820100'
          },
          {
            id: '820103',
            label: '路凼城',
            value: '820103',
            parentId: '820100'
          },
          {
            id: '820104',
            label: '路环',
            value: '820104',
            parentId: '820100'
          }
        ]
      }
    ]
  }
]
